import React from "react";
import _ from "lodash";
// import MultiLineText from './MultiLineText';

const translate = (key, lang) => {
  const dictionary = {
    "Future Development": {
      en: "Future Development",
      cn: "未来开发项目",
      ru: "будущее развитие"
    },
    "20 Minutes": {
      en: "20 Minutes",
      cn: "(20分钟车程)",
      ru: "(20 минут езды)"
    },
    "To Phuket International Airport": {
      en: "To Phuket International Airport",
      cn: "普吉岛国际机场",
      ru: "МЕЖДУНАРОДНЫЙ АЭРОПОРТ ПХУКЕТА"
    },
    // 'Phuket Airport': {
    //   en: 'To Phuket International Airport',
    //   cn: '普吉岛国际机场',
    //   ru: 'АЭРОПОРТ ПХУКЕТА'
    // },
    International: {
      en: "To Phuket International Airport",
      cn: "",
      ru: "МЕЖДУНАРОДНЫЙ"
    },
    "Main Entrance": {
      en: "Main Entrance",
      cn: "主入口",
      ru: "Главный въезд"
    },
    "Laguna Park 2": {
      en: "Laguna Park 2",
      cn: "乐古浪熙园 2",
      ru: "Laguna Park 2"
    },
    "To Ban Don": {
      en: "To Ban Don",
      cn: "班顿",
      ru: "ХРАМ BAN DON"
    },
    Townhome: {
      en: "Townhome",
      cn: "双拼别墅",
      ru: "ТАУНХАУС"
    },
    Villa: {
      en: "Villa",
      cn: "独栋别墅",
      ru: "ВИЛЛА"
    },
    Townhomes: {
      en: "Townhomes",
      cn: "联排别墅",
      ru: "Таунхаусы"
    },
    Villas: {
      en: "Villas",
      cn: "独栋别墅",
      ru: "Виллы"
    },
    "To Angsana Villas Resort, Laguna Phuket": {
      en: "To Angsana Villas Resort, Laguna Phuket",
      cn: "悦椿别墅度假村",
      ru: "ОТЕЛЬ Angsana Villas Resort, Laguna Phuket"
    }
  };
  return _.get(dictionary, `${key}.${lang}`, "Content not found");
  // <tspan class="cls-59">{translate('Future Development', currentLang)}</tspan>
};

export default ({ currentLang, selectedType }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // id="floorplan"
    viewBox="0 0 841.89 595.28"
    className="site-plan-svg"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="427.69"
        y1="595.28"
        x2="427.69"
        y2="512.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset="0.72" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
    </defs>
    <g id="bg">
      <path
        d="M83.77,490.11V311.75s2.28-21.65-6.27-35.33L41,207.47s-5.69-10.26-5.69-26.78V109.46H621.12L737.93,208,732.52,401.5h5.41v12.25H225.09l-31.34,24.5s-63.25,13.11-85.48,61.54Z"
        fill="#dcddde"
      />
      <path
        d="M-896.33,849.1l86.61-137.9c7.73-12.31,20.29-23,32.94-29.83,29.28-15.8,57.56-4.87,87.31,3.43l73.08,20.38c34.3,9.56,63.53,17.5,96.15-4.24l81.94-43.75c34.43-18.37,66.88-40,106.16-46.19,42.15-6.65,86.12-3.6,128.67-3.85,42.36,0,84.84.23,127.19-.74C-41.37,605.61-3,608.32,28.24,590c44.26-26,55.22-83.18,77.33-125.32,17.1-32.59,52.19-44.05,87.61-44.05H720.84"
        fill="none"
        stroke="#dcddde"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="36.47"
      />
      <path
        d="M76.22,127.84H595.1s18.42.81,31.53,13.91l73.69,61.16s24.32,43.69-40.26,43.69H102.58a12.87,12.87,0,0,1-9.12-6.22L68.1,191.52a24.53,24.53,0,0,1-1.71-9.83V138.38S66.68,128.69,76.22,127.84Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M303.3,244.08H667.56s47.58-2.13,30.77-39.17l-77.21-63.82s-12.25-9.41-26.21-10.54H300.31V243.94Z"
        fill="#fff"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M125.94,264.64H675s14.81.58,14,17.47l-35,105.07s-4.56,14.6-20.23,14.6H125.94s-10.26-2.29-11.11-12.6V276.1S116.25,266.36,125.94,264.64Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect x="336.49" y="130.61" width="8.36" height="113.56" fill="#dcddde" />
      <line
        x1="303.39"
        y1="187.34"
        x2="303.39"
        y2="130.36"
        fill="none"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.23"
      />
      <circle
        cx="117.96"
        cy="434.03"
        r="15.81"
        fill="#fff"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M439.89-183.62c8.58,40.2,17.23,80.38,25.48,120.64,4.17,20.34,21.05,29.81,36.06,42.74l58.16,50.1c39.49,34,180.19,157.84,213,183.15,22.47,17.34,36.23,35.62,22.91,65.31L719,495.93c-9.07,25.8-50.13,130.29-48.43,141.7,1.74,11.56,13.21,22.15,20.79,30.41,64.26,70.08,127.19,141.28,190.73,212l63.82,129.16"
        fill="none"
        stroke="#808184"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="31.28"
      />
      <rect x="355.77" y="267.86" width="8.36" height="128.63" fill="#dcddde" />
      <path
        d="M767.85,233.11l-31.91-25.92-66.18,194h62.87L777.53,273C788.08,250.78,767.85,233.11,767.85,233.11Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="676.42"
        y="393.95"
        width="38.04"
        height="51.95"
        rx="1.41"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.66"
      />
      <line
        x1="70.1"
        y1="187.36"
        x2="303.34"
        y2="187.36"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="122.42"
        y1="243.94"
        x2="122.42"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="148.35"
        y1="243.94"
        x2="148.35"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="174.18"
        y1="243.94"
        x2="174.18"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="200.02"
        y1="243.94"
        x2="200.02"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="225.85"
        y1="243.94"
        x2="225.85"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="251.68"
        y1="243.94"
        x2="251.68"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="277.61"
        y1="243.94"
        x2="277.61"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="303.44"
        y1="243.94"
        x2="303.44"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="96.55"
        y1="237.48"
        x2="96.55"
        y2="130.36"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <path
        d="M698.63,204.81,621.42,141s-12.25-9.4-26.21-10.54H551.64V244H667.86S715.44,241.85,698.63,204.81Z"
        fill="#fff"
      />
      <rect
        x="760.36"
        y="479.2"
        width="18.1"
        height="30.38"
        fill="#b3d337"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.17"
      />
      <rect
        x="766.37"
        y="483.21"
        width="4.09"
        height="9.15"
        transform="translate(1256.21 -280.63) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="762.75"
        y="497.39"
        width="10.27"
        height="6.8"
        transform="translate(1268.67 -267.09) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <polygon
        points="771.29 502.65 773.1 502.65 773.1 497.62 771.29 497.62 771.29 488.36 764.96 488.36 764.96 489.29 763.85 489.29 763.85 501.24 764.49 501.24 764.49 505.25 771.29 505.25 771.29 502.65"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M771.3,497.63s0-8.31,0-8.33h-3.78v-.93H765v.95h-1.14v11.92h.66v1.44h8.64v-5.05Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="762.48"
        y="491.08"
        width="10.17"
        height="7.43"
        transform="translate(1262.36 -272.76) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="767.54"
        y="480.29"
        width="4.13"
        height="6.78"
        transform="translate(1253.28 -285.93) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M771.31,498.37V488.25H765v1h-1.14v8.86H765v.3Zm-4.46-2.86H771v1.79h-4.14Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="763.83"
        y="482.94"
        width="3.75"
        height="1.46"
        transform="translate(1249.37 -282.03) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="773.18"
        y="487.53"
        width="1.79"
        height="1.79"
        transform="translate(1262.5 -285.65) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.04"
      />
      <rect
        x="766.21"
        y="489.53"
        width="6.43"
        height="3.79"
        transform="translate(1260.84 -277.99) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="767.97"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1262.6 -279.75) rotate(90)"
        fill="#808083"
      />
      <rect
        x="767.82"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1262.45 -279.6) rotate(90)"
        fill="#808083"
      />
      <rect
        x="767.67"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1262.29 -279.45) rotate(90)"
        fill="#808083"
      />
      <rect
        x="767.52"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1262.14 -279.3) rotate(90)"
        fill="#808083"
      />
      <rect
        x="767.37"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1261.99 -279.15) rotate(90)"
        fill="#808083"
      />
      <rect
        x="767.22"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1261.84 -278.99) rotate(90)"
        fill="#808083"
      />
      <rect
        x="767.07"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1261.69 -278.84) rotate(90)"
        fill="#808083"
      />
      <rect
        x="766.92"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1261.54 -278.69) rotate(90)"
        fill="#808083"
      />
      <rect
        x="766.77"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1261.39 -278.54) rotate(90)"
        fill="#808083"
      />
      <rect
        x="766.62"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1261.24 -278.39) rotate(90)"
        fill="#808083"
      />
      <rect
        x="766.47"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1261.09 -278.24) rotate(90)"
        fill="#808083"
      />
      <rect
        x="766.31"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1260.94 -278.09) rotate(90)"
        fill="#808083"
      />
      <rect
        x="766.16"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1260.79 -277.94) rotate(90)"
        fill="#808083"
      />
      <rect
        x="766.01"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1260.64 -277.79) rotate(90)"
        fill="#808083"
      />
      <rect
        x="765.86"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1260.48 -277.64) rotate(90)"
        fill="#808083"
      />
      <rect
        x="765.71"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1260.33 -277.49) rotate(90)"
        fill="#808083"
      />
      <rect
        x="765.56"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1260.18 -277.34) rotate(90)"
        fill="#808083"
      />
      <rect
        x="765.41"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1260.03 -277.18) rotate(90)"
        fill="#808083"
      />
      <rect
        x="765.26"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1259.88 -277.03) rotate(90)"
        fill="#808083"
      />
      <rect
        x="765.11"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1259.73 -276.88) rotate(90)"
        fill="#808083"
      />
      <rect
        x="764.96"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1259.58 -276.73) rotate(90)"
        fill="#808083"
      />
      <rect
        x="764.81"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1259.43 -276.58) rotate(90)"
        fill="#808083"
      />
      <rect
        x="764.66"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1259.28 -276.43) rotate(90)"
        fill="#808083"
      />
      <rect
        x="764.5"
        y="491.39"
        width="6.4"
        height="0.07"
        transform="translate(1259.13 -276.28) rotate(90)"
        fill="#808083"
      />
      <path
        d="M772.09,507.16a1.67,1.67,0,0,1-.84-1.52h-6.74c0,.69,0,1.27-.5,1.52Z"
        fill="#838383"
      />
      <rect
        x="758.07"
        y="519.66"
        width="20.39"
        height="36.86"
        fill="#4f9656"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.19"
      />
      <polygon
        points="763.17 526.37 762.66 526.37 762.66 522.54 774.51 522.54 774.51 525.72 774.51 526.37 774.51 529.55 763.17 529.55 763.17 526.37"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="760.75"
        y="523.77"
        width="3.3"
        height="1.9"
        transform="translate(1287.11 -237.67) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="761.45"
        y="526.83"
        width="1.49"
        height="1.49"
        transform="translate(1289.77 -234.61) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="766.13"
        y="523.84"
        width="4.07"
        height="10.01"
        transform="translate(1297.02 -239.32) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="763.29"
        y="530.73"
        width="9.76"
        height="10.01"
        transform="translate(1303.9 -232.44) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="760.27"
        y="530.93"
        width="9.98"
        height="10.01"
        transform="translate(1301.19 -229.33) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="762.78"
        y="537.03"
        width="9.98"
        height="10.01"
        transform="translate(1309.81 -225.74) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="766.04"
        y="538.68"
        width="6.24"
        height="10.01"
        transform="translate(1312.85 -225.47) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="760.38"
        y="541.37"
        width="10.47"
        height="9.19"
        transform="translate(1311.58 -219.64) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <path
        d="M761.28,552.38h5.87a1.42,1.42,0,0,0,1,1.27h-7.85A1.44,1.44,0,0,0,761.28,552.38Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="761.27"
        y="550.33"
        width="5.89"
        height="2.51"
        transform="translate(1528.42 1103.17) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <polygon
        points="770.22 551.17 760.99 551.17 760.99 540.92 761.78 540.92 761.78 531.65 763.15 531.65 763.17 529.56 773.16 529.56 773.16 535.87 774.17 535.87 774.17 540.6 776.27 540.6 776.27 547.38 770.22 547.38 770.22 551.17"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <polygon
        points="763.13 529.54 773.14 529.54 773.14 535.87 774.13 535.87 774.13 540.58 776.27 540.58 776.27 547.36 764.31 547.36 764.31 545.61 763.13 545.61 763.13 529.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <path
        d="M763.12,541.75h11.12v-5.89h-1v-5.94H763.14l0,5.09h-.36v3.28h.37Zm5.87-.69v-3.47h5v3.47Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.03"
      />
      <rect
        x="765.31"
        y="527.72"
        width="5.7"
        height="10.09"
        transform="translate(1300.93 -235.39) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="760.45"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.04 -230.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="760.58"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.17 -230.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="760.71"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.31 -230.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="760.85"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.44 -230.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="760.98"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.57 -231.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="761.11"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.71 -231.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="761.25"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.84 -231.29) rotate(90)"
        fill="#808184"
      />
      <rect
        x="761.38"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1296.97 -231.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="761.51"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1297.11 -231.56) rotate(90)"
        fill="#808184"
      />
      <rect
        x="761.65"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1297.24 -231.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="761.78"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1297.38 -231.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="761.92"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1297.51 -231.96) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.05"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1297.64 -232.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.18"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1297.78 -232.23) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.32"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1297.91 -232.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.45"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.04 -232.5) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.58"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.18 -232.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.72"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.31 -232.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.85"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.44 -232.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="762.98"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.58 -233.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="763.12"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.71 -233.17) rotate(90)"
        fill="#808184"
      />
      <rect
        x="763.25"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.85 -233.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="763.39"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1298.98 -233.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="763.52"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1299.11 -233.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="763.65"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1299.25 -233.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="763.79"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1299.38 -233.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="763.92"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1299.51 -233.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.05"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1299.65 -234.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.19"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1299.78 -234.23) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.32"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1299.91 -234.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.45"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.05 -234.5) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.59"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.18 -234.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.72"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.32 -234.77) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.86"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.45 -234.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="764.99"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.58 -235.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="765.12"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.72 -235.17) rotate(90)"
        fill="#808184"
      />
      <rect
        x="765.26"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.85 -235.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="765.39"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1300.98 -235.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="765.52"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1301.12 -235.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="765.66"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1301.25 -235.71) rotate(90)"
        fill="#808184"
      />
      <rect
        x="765.79"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1301.38 -235.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="765.92"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1301.52 -235.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.06"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1301.65 -236.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.19"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1301.79 -236.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.33"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1301.92 -236.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.46"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.05 -236.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.59"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.19 -236.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.73"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.32 -236.77) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.86"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.45 -236.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="766.99"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.59 -237.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="767.13"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.72 -237.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="767.26"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.85 -237.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="767.4"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1302.99 -237.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="767.53"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1303.12 -237.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="767.66"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1303.26 -237.71) rotate(90)"
        fill="#808184"
      />
      <rect
        x="767.8"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1303.39 -237.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="767.93"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1303.52 -237.98) rotate(90)"
        fill="#808184"
      />
      <rect
        x="768.06"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1303.66 -238.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="768.2"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1303.79 -238.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="768.33"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1303.92 -238.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="768.46"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.06 -238.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="768.6"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.19 -238.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="768.73"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.32 -238.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="768.87"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.46 -238.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.59 -239.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769.13"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.73 -239.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769.27"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.86 -239.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769.4"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1304.99 -239.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769.53"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1305.13 -239.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769.67"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1305.26 -239.71) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769.8"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1305.39 -239.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="769.93"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1305.53 -239.98) rotate(90)"
        fill="#808184"
      />
      <rect
        x="770.07"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1305.66 -240.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="770.2"
        y="532.74"
        width="5.64"
        height="0.06"
        transform="translate(1305.79 -240.25) rotate(90)"
        fill="#808184"
      />
      <text
        transform="translate(785.58 497.28)"
        font-size="8"
        fill="none"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.11em">T</tspan>
        <tspan x="4" y="0">
          ownhome
        </tspan>
      </text>
      <text
        transform="translate(785.58 497.28)"
        font-size="8"
        fill="#6a6c6d"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.11em">T</tspan>
        <tspan x="4" y="0">
          ownhome
        </tspan>
      </text>
      <text
        transform="translate(785.58 497.28)"
        font-size="8"
        fill="none"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.11em">T</tspan>
        <tspan x="4" y="0">
          ownhome
        </tspan>
      </text>
      <text
        transform="translate(785.58 540.28)"
        font-size="8"
        fill="none"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.02em">V</tspan>
        <tspan x="5.2" y="0">
          illa
        </tspan>
      </text>
      <text
        transform="translate(785.58 540.28)"
        font-size="8"
        fill="#6a6c6d"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.02em">V</tspan>
        <tspan x="5.2" y="0">
          illa
        </tspan>
      </text>
      <text
        transform="translate(785.58 540.28)"
        font-size="8"
        fill="none"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.02em">V</tspan>
        <tspan x="5.2" y="0">
          illa
        </tspan>
      </text>
      <polygon
        points="51.32 73.87 53.05 84.65 63.83 86.39 53.05 88.12 51.32 98.9 49.58 88.12 38.8 86.39 49.58 84.65 51.32 73.87"
        fill="#414042"
      />
      <polygon
        points="51.32 73.87 51.32 86.4 49.58 84.65 51.32 73.87"
        fill="#808285"
      />
      <polygon
        points="51.32 98.9 51.32 86.4 53.05 88.12 51.32 98.9"
        fill="#808285"
      />
      <polygon
        points="38.8 86.39 51.33 86.39 49.59 88.12 38.8 86.39"
        fill="#808285"
      />
      <polygon
        points="63.83 86.39 51.33 86.39 53.05 84.65 63.83 86.39"
        fill="#808285"
      />
      <path
        d="M53.42,69c-.36,0-.51.1-.54.37s0,.48,0,1.07v2.54h-.2L50,69.63h0v1.58a9.85,9.85,0,0,0,0,1.06c0,.32.17.4.6.42v.18H49.11v-.18c.36,0,.52-.1.55-.41a10.4,10.4,0,0,0,0-1.07V69.82c0-.46,0-.48-.12-.64A.76.76,0,0,0,49,69v-.17h.93l2.63,3.15h0V70.39a9.61,9.61,0,0,0,0-1c0-.28-.18-.36-.62-.39v-.17h1.49V69"
        fill="#414042"
      />
      <path
        d="M52.48,101.07a1,1,0,0,0-1-.83c-.62,0-.88.34-.88.69s.38.67,1,.92,1.37.55,1.37,1.27-.7,1.19-1.75,1.19a3,3,0,0,1-.78-.1l-.39-.13a6.94,6.94,0,0,1-.21-1l.23,0a1.35,1.35,0,0,0,1.3,1c.6,0,.94-.3.94-.76s-.43-.69-1-.94S50,101.85,50,101.14s.61-1.12,1.63-1.12a4,4,0,0,1,1,.15c0,.23.07.47.13.86l-.23,0"
        fill="#414042"
      />
      <path
        d="M68.45,87c0,.2-.17.79-.22,1h-3v-.18c.57,0,.62-.09.62-.61V84.72c0-.56,0-.58-.54-.62v-.17h2.81c0,.14,0,.57,0,.9l-.18,0a1.61,1.61,0,0,0-.2-.54c-.09-.14-.26-.18-.71-.18h-.48c-.2,0-.21,0-.21.2v1.44h.59c.57,0,.61,0,.68-.47h.18v1.2h-.18c-.08-.45-.12-.49-.67-.49h-.6v1.19c0,.3,0,.44.15.51a1.38,1.38,0,0,0,.66.08c.47,0,.65,0,.79-.21a2,2,0,0,0,.31-.59l.19,0"
        fill="#414042"
      />
      <path
        d="M38.51,84.21c-.43.06-.49.11-.68.63s-.52,1.6-1,3.36H36.6c-.35-1-.78-2.23-1.1-3.14h0c-.35,1.11-.7,2.12-1,3.14h-.2c-.33-1.14-.69-2.25-1-3.37-.16-.52-.25-.58-.64-.62V84h1.53v.18c-.46.06-.47.11-.37.43.24.85.49,1.7.76,2.59h0c.35-1.07.71-2.11,1-3.14h.19c.35,1,.72,2.06,1.1,3.15h0c.27-.84.62-2.08.71-2.53s.06-.44-.42-.5V84h1.38v.18"
        fill="#414042"
      />
      <path
        d="M36.4,82A15.54,15.54,0,0,1,47.84,71.15l-.13-.58A16.14,16.14,0,0,0,35.82,81.84l.58.17m-.29.21a.3.3,0,1,0-.3-.3.29.29,0,0,0,.3.3M47.77,71.16a.29.29,0,0,0,.3-.3.3.3,0,1,0-.59,0,.29.29,0,0,0,.29.3"
        fill="#414042"
      />
      <path
        d="M48.91,101.59A15.53,15.53,0,0,1,36.32,90.22l-.58.15a16.13,16.13,0,0,0,13.08,11.81l.09-.59m0,.59a.29.29,0,0,0,.3-.3.3.3,0,0,0-.3-.3.31.31,0,0,0-.3.3.3.3,0,0,0,.3.3M36,90.59A.3.3,0,1,0,36,90a.3.3,0,0,0,0,.59"
        fill="#414042"
      />
      <path
        d="M66.56,89.09A15.51,15.51,0,0,1,53.8,101.57l.09.59a16.12,16.12,0,0,0,13.26-13l-.59-.11m.29.35a.3.3,0,1,0,0-.59.3.3,0,0,0,0,.59m-13,12.73a.3.3,0,0,0,.3-.3.29.29,0,0,0-.3-.3.3.3,0,0,0-.3.3.31.31,0,0,0,.3.3"
        fill="#414042"
      />
      <path
        d="M54.62,71.12A15.52,15.52,0,0,1,66.41,82.74l.59-.13A16.15,16.15,0,0,0,54.75,70.53l-.13.59m.07,0a.3.3,0,1,0,0-.59.3.3,0,1,0,0,.59M66.71,83a.3.3,0,0,0,0-.59.3.3,0,1,0,0,.59"
        fill="#414042"
      />
      <text
        transform="translate(706.31 114.21)"
        font-size="8"
        fill="#6a6c6d"
        font-family="Helvetica"
      >
        20 Minutes
        <tspan x="0" y="9.6" letter-spacing="-0.11em">
          T
        </tspan>
        <tspan x="4" y="9.6">
          o Phuket International
        </tspan>
        <tspan x="81.83" y="9.6" letter-spacing="-0.05em"></tspan>
        <tspan x="83.62" y="9.6">
          Airport
        </tspan>
      </text>
      <text
        transform="translate(706.31 114.21)"
        font-size="8"
        fill="none"
        font-family="Helvetica"
      >
        20 Minutes
        <tspan x="4" y="9.6">
          o Phuket International
        </tspan>
        <tspan x="81.83" y="9.6" letter-spacing="-0.05em"></tspan>
        <tspan x="83.62" y="9.6">
          Airport
        </tspan>
      </text>
      <line x1="673.41" y1="83.62" x2="701.92" y2="106.04" fill="none" />
      <line
        x1="681.77"
        y1="90.19"
        x2="701.92"
        y2="106.04"
        fill="none"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="2.4"
      />
      <polygon
        points="681.48 94.4 673.41 83.62 685.79 88.92 681.48 94.4"
        fill="#808184"
      />
      <line x1="141.33" y1="502.37" x2="162.69" y2="469.6" fill="none" />
      <line
        x1="147.59"
        y1="492.77"
        x2="162.69"
        y2="469.6"
        fill="none"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="2.59"
      />
      <polygon
        points="152.14 492.67 141.33 502.37 145.84 488.56 152.14 492.67"
        fill="#808184"
      />
      <text
        transform="translate(171.35 483.94)"
        font-size="8"
        fill="none"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.11em">T</tspan>
        <tspan x="4" y="0">
          o
        </tspan>
        <tspan x="8.45" y="0" letter-spacing="-0.05em"></tspan>
        <tspan x="10.23" y="0">
          Angsana
        </tspan>
        <tspan x="44.04" y="0" letter-spacing="-0.02em">
          V
        </tspan>
        <tspan x="49.23" y="0">
          illas Resort, Laguna Phuket
        </tspan>
      </text>
      <text
        transform="translate(171.35 483.94)"
        font-size="8"
        fill="#6a6c6d"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.11em">T</tspan>
        <tspan x="4" y="0">
          o
        </tspan>
        <tspan x="8.45" y="0" letter-spacing="-0.05em"></tspan>
        <tspan x="10.23" y="0">
          Angsana
        </tspan>
        <tspan x="44.04" y="0" letter-spacing="-0.02em">
          V
        </tspan>
        <tspan x="49.23" y="0">
          illas Resort, Laguna Phuket
        </tspan>
      </text>
      <text
        transform="translate(171.35 483.94)"
        font-size="8"
        fill="none"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.11em">T</tspan>
        <tspan x="4" y="0">
          o
        </tspan>
        <tspan x="8.45" y="0" letter-spacing="-0.05em"></tspan>
        <tspan x="10.23" y="0">
          Angsana
        </tspan>
        <tspan x="44.04" y="0" letter-spacing="-0.02em">
          V
        </tspan>
        <tspan x="49.23" y="0">
          illas Resort, Laguna Phuket
        </tspan>
      </text>
      <line x1="661.73" y1="520.27" x2="675.62" y2="483.7" fill="none" />
      <line
        x1="665.8"
        y1="509.55"
        x2="675.62"
        y2="483.7"
        fill="none"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="2.59"
      />
      <polygon
        points="670.23 508.49 661.73 520.27 663.2 505.82 670.23 508.49"
        fill="#808184"
      />
      <text
        transform="translate(28.22 531.05)"
        font-size="6"
        fill="none"
        font-family="Helvetica"
      >
        Updated 4 September 2019
      </text>
      <polygon
        points="329.17 228.88 329.17 244.01 337.17 244.01 337.17 231.38 341.5 231.38 341.5 130.59 332.5 130.59 332.5 146.38 333.5 146.38 333.5 228.88 329.17 228.88"
        fill="#dcddde"
      />
      <text
        transform="translate(657.35 477.94)"
        font-size="8"
        fill="#6a6c6d"
        font-family="Helvetica"
      >
        <tspan letter-spacing="-0.11em">T</tspan>
        <tspan x="4" y="0">
          o Ban Don
        </tspan>
      </text>
      <path
        d="M639.75,270.22H671s11.25.5,10.5,13.5l-34.5,104s-.5,5.5-7.25,11Z"
        fill="#fff"
      />
    </g>
    <g id="floorplan">
    <g id="Villas" data-name="Villas">
      <polygon
        points="125.94 267.59 352.44 267.59 352.44 396.65 126.22 396.65 118.53 388.96 118.53 274.71 125.94 267.59"
        fill="#4f9656"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.23"
      />
      <polygon
        points="150.43 342.74 151.53 342.74 151.53 334.47 125.94 334.47 125.94 341.33 125.94 342.74 125.94 349.6 150.43 349.6 150.43 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="148.54"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(491.28 187.08) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="150.94"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(497.89 192.81) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="135.24"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(487.73 208.46) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="129.1"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(502.58 223.32) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="135.14"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(509.3 217.47) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="129.71"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(517.04 236.06) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="130.76"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(517.62 242.63) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="133.86"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(530.2 239.89) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M154.5,398.9H141.84a3.09,3.09,0,0,1-2.19,2.74h17v0A3.09,3.09,0,0,1,154.5,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="141.82"
        y="394.47"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="135.22 396.27 155.14 396.27 155.14 374.15 153.43 374.15 153.43 354.15 150.48 354.15 150.44 349.62 128.85 349.62 128.85 363.25 126.67 363.25 126.67 373.47 122.14 373.47 122.14 388.09 135.22 388.09 135.22 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="150.52 349.58 128.89 349.58 128.89 363.25 126.76 363.25 126.76 373.43 122.14 373.43 122.14 388.04 147.96 388.04 147.96 384.28 150.52 384.28 150.52 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M150.52,368.48h.81v-7.09h-.77l-.07-11H128.75v12.82h-2.23V376h24Zm-23.55,6V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="133.5"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(496.21 216.9) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="144.13"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(506.78 206.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="143.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(506.5 206.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="143.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(506.21 206.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="143.27"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(505.92 207.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="142.98"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(505.63 207.5) rotate(90)"
        fill="#808184"
      />
      <rect
        x="142.69"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(505.34 207.79) rotate(90)"
        fill="#808184"
      />
      <rect
        x="142.4"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(505.05 208.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="142.11"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(504.76 208.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="141.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(504.48 208.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="141.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(504.19 208.94) rotate(90)"
        fill="#808184"
      />
      <rect
        x="141.25"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(503.9 209.23) rotate(90)"
        fill="#808184"
      />
      <rect
        x="140.96"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(503.61 209.52) rotate(90)"
        fill="#808184"
      />
      <rect
        x="140.67"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(503.32 209.81) rotate(90)"
        fill="#808184"
      />
      <rect
        x="140.38"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(503.03 210.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="140.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(502.74 210.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="139.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(502.46 210.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="139.52"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(502.17 210.96) rotate(90)"
        fill="#808184"
      />
      <rect
        x="139.23"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(501.88 211.25) rotate(90)"
        fill="#808184"
      />
      <rect
        x="138.94"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(501.59 211.54) rotate(90)"
        fill="#808184"
      />
      <rect
        x="138.65"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(501.3 211.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="138.36"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(501.01 212.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="138.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(500.72 212.4) rotate(90)"
        fill="#808184"
      />
      <rect
        x="137.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(500.44 212.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="137.5"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(500.15 212.98) rotate(90)"
        fill="#808184"
      />
      <rect
        x="137.21"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(499.86 213.27) rotate(90)"
        fill="#808184"
      />
      <rect
        x="136.92"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(499.57 213.56) rotate(90)"
        fill="#808184"
      />
      <rect
        x="136.63"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(499.28 213.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="136.34"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(498.99 214.13) rotate(90)"
        fill="#808184"
      />
      <rect
        x="136.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(498.71 214.42) rotate(90)"
        fill="#808184"
      />
      <rect
        x="135.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(498.42 214.71) rotate(90)"
        fill="#808184"
      />
      <rect
        x="135.48"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(498.13 215) rotate(90)"
        fill="#808184"
      />
      <rect
        x="135.19"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(497.84 215.29) rotate(90)"
        fill="#808184"
      />
      <rect
        x="134.9"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(497.55 215.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="134.61"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(497.26 215.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="134.32"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(496.97 216.15) rotate(90)"
        fill="#808184"
      />
      <rect
        x="134.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(496.69 216.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="133.75"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(496.4 216.73) rotate(90)"
        fill="#808184"
      />
      <rect
        x="133.46"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(496.11 217.02) rotate(90)"
        fill="#808184"
      />
      <rect
        x="133.17"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(495.82 217.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="132.88"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(495.53 217.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="132.59"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(495.24 217.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="132.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(494.95 218.17) rotate(90)"
        fill="#808184"
      />
      <rect
        x="132.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(494.67 218.46) rotate(90)"
        fill="#808184"
      />
      <rect
        x="131.73"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(494.38 218.75) rotate(90)"
        fill="#808184"
      />
      <rect
        x="131.44"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(494.09 219.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="131.15"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(493.8 219.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="130.86"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(493.51 219.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="130.57"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(493.22 219.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="130.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(492.94 220.19) rotate(90)"
        fill="#808184"
      />
      <rect
        x="129.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(492.65 220.48) rotate(90)"
        fill="#808184"
      />
      <rect
        x="129.71"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(492.36 220.77) rotate(90)"
        fill="#808184"
      />
      <rect
        x="129.42"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(492.07 221.06) rotate(90)"
        fill="#808184"
      />
      <rect
        x="129.13"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(491.78 221.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="128.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(491.49 221.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="128.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(491.2 221.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="128.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(490.92 222.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="127.98"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(490.63 222.5) rotate(90)"
        fill="#808184"
      />
      <rect
        x="127.69"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(490.34 222.79) rotate(90)"
        fill="#808184"
      />
      <rect
        x="127.4"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(490.05 223.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="127.11"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(489.76 223.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="126.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(489.47 223.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="126.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(489.18 223.94) rotate(90)"
        fill="#808184"
      />
      <rect
        x="126.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(488.9 224.23) rotate(90)"
        fill="#808184"
      />
      <rect
        x="125.96"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(488.61 224.52) rotate(90)"
        fill="#808184"
      />
      <rect
        x="125.67"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(488.32 224.81) rotate(90)"
        fill="#808184"
      />
      <rect
        x="125.38"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(488.03 225.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="125.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(487.74 225.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="124.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(487.45 225.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="124.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(487.17 225.96) rotate(90)"
        fill="#808184"
      />
      <rect
        x="124.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(486.88 226.25) rotate(90)"
        fill="#808184"
      />
      <rect
        x="123.94"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(486.59 226.54) rotate(90)"
        fill="#808184"
      />
      <rect
        x="123.65"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(486.3 226.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="123.36"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(486.01 227.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="123.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(485.72 227.41) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="166.27 342.74 165.18 342.74 165.18 334.47 190.76 334.47 190.76 341.33 190.76 342.74 190.76 349.6 166.27 349.6 166.27 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="161.04"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(503.78 174.58) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="162.55"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(509.51 181.19) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="172.68"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(525.17 171.02) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="166.54"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(540.02 185.88) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="160.01"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(534.17 192.6) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="165.44"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(552.77 200.33) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="172.48"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(559.33 200.91) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="160.25"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(556.59 213.5) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M162.2,398.9h12.67a3.08,3.08,0,0,0,2.19,2.74h-17v0A3.07,3.07,0,0,0,162.2,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="162.17"
        y="394.47"
        width="12.72"
        height="5.41"
        transform="translate(337.05 794.35) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="181.49 396.27 161.57 396.27 161.57 374.15 163.28 374.15 163.28 354.15 166.23 354.15 166.27 349.62 187.85 349.62 187.85 363.25 190.03 363.25 190.03 373.47 194.56 373.47 194.56 388.09 181.49 388.09 181.49 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="166.18 349.58 187.81 349.58 187.81 363.25 189.95 363.25 189.95 373.43 194.56 373.43 194.56 388.04 168.75 388.04 168.75 384.28 166.18 384.28 166.18 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M166.18,376h24V363.22H188V350.4H166.21l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="170.89"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(533.6 179.51) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="160.4"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(523.05 190.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="160.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(523.34 189.79) rotate(90)"
        fill="#808184"
      />
      <rect
        x="160.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(523.62 189.5) rotate(90)"
        fill="#808184"
      />
      <rect
        x="161.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(523.91 189.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="161.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(524.2 188.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="161.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(524.49 188.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="162.13"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(524.78 188.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="162.42"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(525.07 188.06) rotate(90)"
        fill="#808184"
      />
      <rect
        x="162.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(525.36 187.77) rotate(90)"
        fill="#808184"
      />
      <rect
        x="162.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(525.64 187.48) rotate(90)"
        fill="#808184"
      />
      <rect
        x="163.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(525.93 187.19) rotate(90)"
        fill="#808184"
      />
      <rect
        x="163.57"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(526.22 186.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="163.86"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(526.51 186.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="164.15"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(526.8 186.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="164.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(527.09 186.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="164.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(527.38 185.75) rotate(90)"
        fill="#808184"
      />
      <rect
        x="165.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(527.66 185.46) rotate(90)"
        fill="#808184"
      />
      <rect
        x="165.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(527.95 185.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="165.59"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(528.24 184.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="165.88"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(528.53 184.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="166.17"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(528.82 184.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="166.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(529.11 184.02) rotate(90)"
        fill="#808184"
      />
      <rect
        x="166.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(529.39 183.73) rotate(90)"
        fill="#808184"
      />
      <rect
        x="167.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(529.68 183.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="167.32"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(529.97 183.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="167.61"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(530.26 182.87) rotate(90)"
        fill="#808184"
      />
      <rect
        x="167.9"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(530.55 182.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="168.19"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(530.84 182.29) rotate(90)"
        fill="#808184"
      />
      <rect
        x="168.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(531.13 182) rotate(90)"
        fill="#808184"
      />
      <rect
        x="168.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(531.41 181.71) rotate(90)"
        fill="#808184"
      />
      <rect
        x="169.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(531.7 181.42) rotate(90)"
        fill="#808184"
      />
      <rect
        x="169.34"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(531.99 181.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="169.63"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(532.28 180.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="169.92"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(532.57 180.56) rotate(90)"
        fill="#808184"
      />
      <rect
        x="170.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(532.86 180.27) rotate(90)"
        fill="#808184"
      />
      <rect
        x="170.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(533.15 179.98) rotate(90)"
        fill="#808184"
      />
      <rect
        x="170.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(533.43 179.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="171.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(533.72 179.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="171.36"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(534.01 179.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="171.65"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(534.3 178.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="171.94"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(534.59 178.54) rotate(90)"
        fill="#808184"
      />
      <rect
        x="172.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(534.88 178.25) rotate(90)"
        fill="#808184"
      />
      <rect
        x="172.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(535.16 177.96) rotate(90)"
        fill="#808184"
      />
      <rect
        x="172.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(535.45 177.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="173.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(535.74 177.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="173.38"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(536.03 177.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="173.67"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(536.32 176.81) rotate(90)"
        fill="#808184"
      />
      <rect
        x="173.96"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(536.61 176.52) rotate(90)"
        fill="#808184"
      />
      <rect
        x="174.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(536.9 176.23) rotate(90)"
        fill="#808184"
      />
      <rect
        x="174.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(537.18 175.94) rotate(90)"
        fill="#808184"
      />
      <rect
        x="174.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(537.47 175.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="175.11"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(537.76 175.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="175.4"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(538.05 175.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="175.69"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(538.34 174.79) rotate(90)"
        fill="#808184"
      />
      <rect
        x="175.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(538.63 174.5) rotate(90)"
        fill="#808184"
      />
      <rect
        x="176.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(538.92 174.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="176.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(539.2 173.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="176.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(539.49 173.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="177.13"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(539.78 173.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="177.42"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(540.07 173.06) rotate(90)"
        fill="#808184"
      />
      <rect
        x="177.71"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(540.36 172.77) rotate(90)"
        fill="#808184"
      />
      <rect
        x="177.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(540.65 172.48) rotate(90)"
        fill="#808184"
      />
      <rect
        x="178.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(540.94 172.19) rotate(90)"
        fill="#808184"
      />
      <rect
        x="178.57"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(541.22 171.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="178.86"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(541.51 171.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="179.15"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(541.8 171.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="179.44"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(542.09 171.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="179.73"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(542.38 170.75) rotate(90)"
        fill="#808184"
      />
      <rect
        x="180.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(542.67 170.46) rotate(90)"
        fill="#808184"
      />
      <rect
        x="180.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(542.95 170.17) rotate(90)"
        fill="#808184"
      />
      <rect
        x="180.59"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(543.24 169.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="180.88"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(543.53 169.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="181.17"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(543.82 169.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="181.46"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(544.11 169.02) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="227.93 342.74 229.02 342.74 229.02 334.47 203.44 334.47 203.44 341.33 203.44 342.74 203.44 349.6 227.93 349.6 227.93 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="226.04"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(568.78 109.58) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="228.43"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(575.39 115.31) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="212.73"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(565.22 130.97) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="206.6"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(580.08 145.82) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="212.64"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(586.8 139.97) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="207.21"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(594.53 158.57) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="208.26"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(595.11 165.13) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="211.35"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(607.7 162.39) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M232,398.9H219.33a3.08,3.08,0,0,1-2.19,2.74h17v0A3.07,3.07,0,0,1,232,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="219.32"
        y="394.47"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="212.72 396.27 232.63 396.27 232.63 374.15 230.92 374.15 230.92 354.15 227.97 354.15 227.93 349.62 206.35 349.62 206.35 363.25 204.17 363.25 204.17 373.47 199.64 373.47 199.64 388.09 212.72 388.09 212.72 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="228.02 349.58 206.39 349.58 206.39 363.25 204.25 363.25 204.25 373.43 199.64 373.43 199.64 388.04 225.45 388.04 225.45 384.28 228.02 384.28 228.02 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M228,368.48h.81v-7.09h-.78l-.06-11H206.25v12.82H204V376h24Zm-23.55,6V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="211"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(573.71 139.4) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="221.63"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(584.28 128.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="221.34"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(583.99 129.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="221.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(583.7 129.42) rotate(90)"
        fill="#808184"
      />
      <rect
        x="220.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(583.41 129.71) rotate(90)"
        fill="#808184"
      />
      <rect
        x="220.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(583.13 130) rotate(90)"
        fill="#808184"
      />
      <rect
        x="220.19"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(582.84 130.29) rotate(90)"
        fill="#808184"
      />
      <rect
        x="219.9"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(582.55 130.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="219.61"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(582.26 130.87) rotate(90)"
        fill="#808184"
      />
      <rect
        x="219.32"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(581.97 131.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="219.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(581.68 131.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="218.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(581.39 131.73) rotate(90)"
        fill="#808184"
      />
      <rect
        x="218.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(581.11 132.02) rotate(90)"
        fill="#808184"
      />
      <rect
        x="218.17"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(580.82 132.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="217.88"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(580.53 132.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="217.59"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(580.24 132.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="217.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(579.95 133.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="217.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(579.66 133.46) rotate(90)"
        fill="#808184"
      />
      <rect
        x="216.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(579.38 133.75) rotate(90)"
        fill="#808184"
      />
      <rect
        x="216.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(579.09 134.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="216.15"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(578.8 134.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="215.86"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(578.51 134.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="215.57"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(578.22 134.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="215.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(577.93 135.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="214.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(577.64 135.48) rotate(90)"
        fill="#808184"
      />
      <rect
        x="214.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(577.36 135.77) rotate(90)"
        fill="#808184"
      />
      <rect
        x="214.42"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(577.07 136.06) rotate(90)"
        fill="#808184"
      />
      <rect
        x="214.13"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(576.78 136.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="213.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(576.49 136.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="213.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(576.2 136.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="213.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(575.91 137.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="212.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(575.62 137.5) rotate(90)"
        fill="#808184"
      />
      <rect
        x="212.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(575.34 137.79) rotate(90)"
        fill="#808184"
      />
      <rect
        x="212.4"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(575.05 138.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="212.11"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(574.76 138.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="211.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(574.47 138.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="211.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(574.18 138.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="211.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(573.89 139.23) rotate(90)"
        fill="#808184"
      />
      <rect
        x="210.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(573.61 139.52) rotate(90)"
        fill="#808184"
      />
      <rect
        x="210.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(573.32 139.81) rotate(90)"
        fill="#808184"
      />
      <rect
        x="210.38"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(573.03 140.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="210.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(572.74 140.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="209.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(572.45 140.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="209.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(572.16 140.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="209.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(571.87 141.25) rotate(90)"
        fill="#808184"
      />
      <rect
        x="208.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(571.59 141.54) rotate(90)"
        fill="#808184"
      />
      <rect
        x="208.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(571.3 141.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="208.36"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(571.01 142.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="208.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(570.72 142.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="207.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(570.43 142.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="207.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(570.14 142.98) rotate(90)"
        fill="#808184"
      />
      <rect
        x="207.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(569.85 143.27) rotate(90)"
        fill="#808184"
      />
      <rect
        x="206.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(569.57 143.56) rotate(90)"
        fill="#808184"
      />
      <rect
        x="206.63"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(569.28 143.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="206.34"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(568.99 144.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="206.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(568.7 144.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="205.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(568.41 144.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="205.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(568.12 145) rotate(90)"
        fill="#808184"
      />
      <rect
        x="205.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(567.84 145.29) rotate(90)"
        fill="#808184"
      />
      <rect
        x="204.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(567.55 145.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="204.61"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(567.26 145.87) rotate(90)"
        fill="#808184"
      />
      <rect
        x="204.32"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(566.97 146.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="204.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(566.68 146.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="203.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(566.39 146.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="203.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(566.1 147.02) rotate(90)"
        fill="#808184"
      />
      <rect
        x="203.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(565.82 147.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="202.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(565.53 147.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="202.59"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(565.24 147.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="202.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(564.95 148.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="202.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(564.66 148.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="201.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(564.37 148.75) rotate(90)"
        fill="#808184"
      />
      <rect
        x="201.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(564.08 149.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="201.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(563.8 149.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="200.86"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(563.51 149.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="200.57"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(563.22 149.91) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="243.77 342.74 242.68 342.74 242.68 334.47 268.26 334.47 268.26 341.33 268.26 342.74 268.26 349.6 243.77 349.6 243.77 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="238.54"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(581.28 97.08) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="240.05"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(587.01 103.69) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="250.17"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(602.66 93.53) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="244.04"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(617.52 108.38) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="237.51"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(611.67 115.1) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="242.94"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(630.26 122.84) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="249.97"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(636.83 123.42) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="237.75"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(634.09 136) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M239.7,398.9h12.66a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.09,3.09,0,0,0,239.7,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="239.66"
        y="394.47"
        width="12.72"
        height="5.41"
        transform="translate(492.04 794.35) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="258.98 396.27 239.06 396.27 239.06 374.15 240.77 374.15 240.77 354.15 243.72 354.15 243.76 349.62 265.35 349.62 265.35 363.25 267.53 363.25 267.53 373.47 272.06 373.47 272.06 388.09 258.98 388.09 258.98 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="243.68 349.58 265.31 349.58 265.31 363.25 267.44 363.25 267.44 373.43 272.06 373.43 272.06 388.04 246.24 388.04 246.24 384.28 243.68 384.28 243.68 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M243.68,376h24V363.22h-2.23V350.4H243.71l-.07,11h-.77v7.09h.81Zm12.65-1.5V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="248.39"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(611.1 102.01) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="237.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(600.54 112.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="238.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(600.83 112.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="238.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(601.12 112.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="238.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(601.41 111.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="239.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(601.7 111.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="239.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(601.99 111.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="239.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(602.28 110.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="239.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(602.56 110.56) rotate(90)"
        fill="#808184"
      />
      <rect
        x="240.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(602.85 110.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="240.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(603.14 109.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="240.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(603.43 109.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="241.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(603.72 109.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="241.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(604.01 109.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="241.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(604.29 108.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="241.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(604.58 108.54) rotate(90)"
        fill="#808184"
      />
      <rect
        x="242.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(604.87 108.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="242.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(605.16 107.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="242.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(605.45 107.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="243.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(605.74 107.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="243.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(606.03 107.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="243.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(606.31 106.81) rotate(90)"
        fill="#808184"
      />
      <rect
        x="243.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(606.6 106.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="244.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(606.89 106.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="244.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(607.18 105.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="244.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(607.47 105.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="245.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(607.76 105.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="245.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(608.05 105.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="245.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(608.33 104.79) rotate(90)"
        fill="#808184"
      />
      <rect
        x="245.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(608.62 104.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="246.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(608.91 104.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="246.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(609.2 103.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="246.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(609.49 103.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="247.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(609.78 103.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="247.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(610.06 103.06) rotate(90)"
        fill="#808184"
      />
      <rect
        x="247.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(610.35 102.77) rotate(90)"
        fill="#808184"
      />
      <rect
        x="247.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(610.64 102.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="248.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(610.93 102.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="248.57"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(611.22 101.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="248.86"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(611.51 101.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="249.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(611.8 101.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="249.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(612.08 101.04) rotate(90)"
        fill="#808184"
      />
      <rect
        x="249.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(612.37 100.75) rotate(90)"
        fill="#808184"
      />
      <rect
        x="250.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(612.66 100.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="250.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(612.95 100.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="250.59"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(613.24 99.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="250.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(613.53 99.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="251.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(613.82 99.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="251.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(614.1 99.02) rotate(90)"
        fill="#808184"
      />
      <rect
        x="251.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(614.39 98.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="252.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(614.68 98.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="252.32"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(614.97 98.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="252.61"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(615.26 97.87) rotate(90)"
        fill="#808184"
      />
      <rect
        x="252.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(615.55 97.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="253.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(615.83 97.29) rotate(90)"
        fill="#808184"
      />
      <rect
        x="253.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(616.12 97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="253.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(616.41 96.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="254.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(616.7 96.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="254.34"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(616.99 96.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="254.63"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(617.28 95.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="254.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(617.57 95.56) rotate(90)"
        fill="#808184"
      />
      <rect
        x="255.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(617.85 95.27) rotate(90)"
        fill="#808184"
      />
      <rect
        x="255.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(618.14 94.98) rotate(90)"
        fill="#808184"
      />
      <rect
        x="255.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(618.43 94.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="256.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(618.72 94.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="256.36"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(619.01 94.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="256.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(619.3 93.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="256.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(619.59 93.54) rotate(90)"
        fill="#808184"
      />
      <rect
        x="257.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(619.87 93.25) rotate(90)"
        fill="#808184"
      />
      <rect
        x="257.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(620.16 92.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="257.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(620.45 92.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="258.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(620.74 92.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="258.38"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(621.03 92.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="258.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(621.32 91.81) rotate(90)"
        fill="#808184"
      />
      <rect
        x="258.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(621.61 91.52) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="305.42 342.74 306.52 342.74 306.52 334.47 280.94 334.47 280.94 341.33 280.94 342.74 280.94 349.6 305.42 349.6 305.42 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="303.54"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(646.27 32.08) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="305.93"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(652.88 37.81) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="290.23"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(642.72 53.47) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="284.09"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(657.57 68.32) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="290.13"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(664.29 62.48) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="284.7"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(672.03 81.07) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="285.76"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(672.61 87.64) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="288.85"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(685.2 84.9) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M309.5,398.9H296.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,309.5,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="296.81"
        y="394.47"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="290.21 396.27 310.13 396.27 310.13 374.15 308.42 374.15 308.42 354.15 305.47 354.15 305.43 349.62 283.84 349.62 283.84 363.25 281.66 363.25 281.66 373.47 277.13 373.47 277.13 388.09 290.21 388.09 290.21 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="305.51 349.58 283.89 349.58 283.89 363.25 281.75 363.25 281.75 373.43 277.13 373.43 277.13 388.04 302.95 388.04 302.95 384.28 305.51 384.28 305.51 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M305.52,368.48h.81v-7.09h-.78l-.06-11H283.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="288.49"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(651.2 61.9) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="299.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(661.78 51.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="298.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(661.49 51.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="298.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(661.2 51.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="298.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(660.91 52.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="297.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(660.62 52.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="297.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(660.33 52.79) rotate(90)"
        fill="#808184"
      />
      <rect
        x="297.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(660.05 53.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="297.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(659.76 53.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="296.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(659.47 53.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="296.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(659.18 53.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="296.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(658.89 54.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="295.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(658.6 54.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="295.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(658.31 54.81) rotate(90)"
        fill="#808184"
      />
      <rect
        x="295.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(658.03 55.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="295.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(657.74 55.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="294.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(657.45 55.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="294.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(657.16 55.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="294.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(656.87 56.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="293.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(656.58 56.54) rotate(90)"
        fill="#808184"
      />
      <rect
        x="293.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(656.29 56.83) rotate(90)"
        fill="#808184"
      />
      <rect
        x="293.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(656.01 57.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="293.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(655.72 57.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="292.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(655.43 57.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="292.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(655.14 57.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="292.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(654.85 58.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="291.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(654.56 58.56) rotate(90)"
        fill="#808184"
      />
      <rect
        x="291.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(654.28 58.85) rotate(90)"
        fill="#808184"
      />
      <rect
        x="291.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(653.99 59.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="291.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(653.7 59.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="290.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(653.41 59.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="290.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(653.12 60.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="290.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(652.83 60.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="289.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(652.54 60.58) rotate(90)"
        fill="#808184"
      />
      <rect
        x="289.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(652.26 60.87) rotate(90)"
        fill="#808184"
      />
      <rect
        x="289.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(651.97 61.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="289.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(651.68 61.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="288.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(651.39 61.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="288.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(651.1 62.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="288.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(650.81 62.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="287.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(650.52 62.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="287.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(650.24 62.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="287.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(649.95 63.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="287.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(649.66 63.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="286.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(649.37 63.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="286.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(649.08 64.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="286.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(648.79 64.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="285.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(648.5 64.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="285.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(648.22 64.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="285.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(647.93 65.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="284.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(647.64 65.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="284.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(647.35 65.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="284.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(647.06 66.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="284.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(646.77 66.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="283.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(646.49 66.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="283.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(646.2 66.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="283.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(645.91 67.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="282.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(645.62 67.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="282.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(645.33 67.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="282.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(645.04 68.08) rotate(90)"
        fill="#808184"
      />
      <rect
        x="282.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(644.75 68.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="281.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(644.47 68.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="281.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(644.18 68.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="281.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(643.89 69.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="280.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(643.6 69.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="280.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(643.31 69.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="280.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(643.02 70.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="280.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(642.73 70.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="279.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(642.45 70.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="279.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(642.16 70.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="279.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(641.87 71.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="278.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(641.58 71.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="278.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(641.29 71.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="278.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(641 72.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="278.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(640.72 72.41) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="321.27 342.74 320.17 342.74 320.17 334.47 345.75 334.47 345.75 341.33 345.75 342.74 345.75 349.6 321.27 349.6 321.27 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="316.04"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(658.77 19.58) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="317.55"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(664.5 26.2) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="327.67"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(680.16 16.03) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="321.53"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(695.01 30.88) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="315.01"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(689.17 37.6) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="320.43"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(707.76 45.34) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="327.47"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(714.32 45.92) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="315.24"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(711.59 58.51) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M317.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,317.19,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="317.16"
        y="394.47"
        width="12.72"
        height="5.41"
        transform="translate(647.04 794.35) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="336.48 396.27 316.56 396.27 316.56 374.15 318.27 374.15 318.27 354.15 321.22 354.15 321.26 349.62 342.85 349.62 342.85 363.25 345.03 363.25 345.03 373.47 349.56 373.47 349.56 388.09 336.48 388.09 336.48 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="321.18 349.58 342.8 349.58 342.8 363.25 344.94 363.25 344.94 373.43 349.56 373.43 349.56 388.04 323.74 388.04 323.74 384.28 321.18 384.28 321.18 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M321.17,376h24V363.22H343V350.4H321.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="325.88"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(688.59 24.51) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="315.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(678.04 35.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="315.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(678.33 34.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="315.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(678.62 34.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="316.25"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(678.91 34.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="316.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(679.19 33.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="316.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(679.48 33.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="317.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(679.77 33.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="317.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(680.06 33.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="317.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(680.35 32.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="317.98"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(680.64 32.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="318.27"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(680.93 32.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="318.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(681.21 31.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="318.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(681.5 31.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="319.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(681.79 31.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="319.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(682.08 31.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="319.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(682.37 30.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="320"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(682.66 30.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="320.29"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(682.94 30.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="320.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(683.23 29.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="320.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(683.52 29.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="321.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(683.81 29.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="321.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(684.1 29.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="321.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(684.39 28.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="322.02"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(684.68 28.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="322.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(684.96 28.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="322.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(685.25 27.87) rotate(90)"
        fill="#808184"
      />
      <rect
        x="322.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(685.54 27.59) rotate(90)"
        fill="#808184"
      />
      <rect
        x="323.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(685.83 27.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="323.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(686.12 27.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="323.75"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(686.41 26.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="324.04"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(686.7 26.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="324.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(686.98 26.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="324.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(687.27 25.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="324.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(687.56 25.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="325.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(687.85 25.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="325.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(688.14 24.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="325.77"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(688.43 24.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="326.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(688.72 24.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="326.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(689 24.12) rotate(90)"
        fill="#808184"
      />
      <rect
        x="326.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(689.29 23.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="326.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(689.58 23.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="327.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(689.87 23.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="327.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(690.16 22.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="327.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(690.45 22.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="328.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(690.73 22.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="328.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(691.02 22.1) rotate(90)"
        fill="#808184"
      />
      <rect
        x="328.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(691.31 21.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="328.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(691.6 21.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="329.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(691.89 21.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="329.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(692.18 20.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="329.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(692.47 20.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="330.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(692.75 20.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="330.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(693.04 20.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="330.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(693.33 19.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="330.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(693.62 19.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="331.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(693.91 19.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="331.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(694.2 18.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="331.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(694.49 18.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="332.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(694.77 18.35) rotate(90)"
        fill="#808184"
      />
      <rect
        x="332.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(695.06 18.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="332.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(695.35 17.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="332.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(695.64 17.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="333.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(695.93 17.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="333.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(696.22 16.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="333.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(696.5 16.62) rotate(90)"
        fill="#808184"
      />
      <rect
        x="334.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(696.79 16.33) rotate(90)"
        fill="#808184"
      />
      <rect
        x="334.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(697.08 16.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="334.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(697.37 15.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="335.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(697.66 15.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="335.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(697.95 15.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="335.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(698.24 14.89) rotate(90)"
        fill="#808184"
      />
      <rect
        x="335.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(698.52 14.6) rotate(90)"
        fill="#808184"
      />
      <rect
        x="336.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(698.81 14.31) rotate(90)"
        fill="#808184"
      />
      <rect
        x="336.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(699.1 14.03) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="150.43 321.38 151.53 321.38 151.53 329.65 125.94 329.65 125.94 322.79 125.94 321.38 125.94 314.52 150.43 314.52 150.43 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="148.54"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(-172.84 477.04) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="150.94"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(-166.23 471.31) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="135.24"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(-176.39 455.66) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="129.1"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(-161.54 440.8) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="135.14"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(-154.82 446.65) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="129.71"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(-147.08 428.06) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="130.76"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(-146.5 421.49) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="133.86"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(-133.92 424.23) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M154.5,267.61H141.84a3.09,3.09,0,0,0-2.19-2.74h17v0A3.09,3.09,0,0,0,154.5,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="141.82"
        y="266.62"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="135.22 267.85 155.14 267.85 155.14 289.97 153.43 289.97 153.43 309.97 150.48 309.97 150.44 314.5 128.85 314.5 128.85 300.87 126.67 300.87 126.67 290.65 122.14 290.65 122.14 276.03 135.22 276.03 135.22 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="150.52 314.54 128.89 314.54 128.89 300.87 126.76 300.87 126.76 290.69 122.14 290.69 122.14 276.08 147.96 276.08 147.96 279.84 150.52 279.84 150.52 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M150.52,288.17h-24V300.9h2.23v12.82h21.74l.07-11h.77v-7.09h-.81Zm-12.65,1.5v7.48H127v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="133.5"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(-167.91 447.22) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="144.13"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-157.34 457.78) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="143.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-157.62 457.49) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="143.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-157.91 457.2) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="143.27"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-158.2 456.91) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="142.98"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-158.49 456.62) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="142.69"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-158.78 456.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="142.4"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-159.07 456.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="142.11"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-159.36 455.76) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="141.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-159.64 455.47) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="141.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-159.93 455.18) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="141.25"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-160.22 454.89) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="140.96"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-160.51 454.6) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="140.67"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-160.8 454.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="140.38"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-161.09 454.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="140.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-161.38 453.74) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="139.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-161.66 453.45) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="139.52"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-161.95 453.16) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="139.23"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-162.24 452.87) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="138.94"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-162.53 452.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="138.65"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-162.82 452.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="138.36"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-163.11 452.01) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="138.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-163.4 451.72) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="137.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-163.68 451.43) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="137.5"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-163.97 451.14) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="137.21"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-164.26 450.85) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="136.92"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-164.55 450.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="136.63"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-164.84 450.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="136.34"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-165.13 449.99) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="136.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-165.41 449.7) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="135.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-165.7 449.41) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="135.48"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-165.99 449.12) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="135.19"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-166.28 448.83) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="134.9"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-166.57 448.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="134.61"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-166.86 448.26) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="134.32"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-167.15 447.97) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="134.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-167.43 447.68) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="133.75"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-167.72 447.39) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="133.46"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-168.01 447.1) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="133.17"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-168.3 446.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="132.88"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-168.59 446.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="132.59"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-168.88 446.24) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="132.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-169.17 445.95) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="132.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-169.45 445.66) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="131.73"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-169.74 445.37) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="131.44"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-170.03 445.08) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="131.15"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-170.32 444.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="130.86"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-170.61 444.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="130.57"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-170.9 444.22) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="130.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-171.18 443.93) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="129.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-171.47 443.64) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="129.71"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-171.76 443.35) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="129.42"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-172.05 443.06) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="129.13"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-172.34 442.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="128.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-172.63 442.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="128.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-172.92 442.2) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="128.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-173.2 441.91) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="127.98"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-173.49 441.62) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="127.69"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-173.78 441.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="127.4"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-174.07 441.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="127.11"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-174.36 440.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="126.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-174.65 440.47) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="126.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-174.94 440.18) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="126.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-175.22 439.89) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="125.96"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-175.51 439.6) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="125.67"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-175.8 439.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="125.38"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-176.09 439.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="125.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-176.38 438.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="124.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-176.67 438.45) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="124.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-176.95 438.16) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="124.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-177.24 437.87) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="123.94"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-177.53 437.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="123.65"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-177.82 437.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="123.36"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-178.11 437) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="123.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-178.4 436.71) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="166.27 321.38 165.18 321.38 165.18 329.65 190.76 329.65 190.76 322.79 190.76 321.38 190.76 314.52 166.27 314.52 166.27 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="161.04"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(-160.34 489.54) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="162.55"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(-154.61 482.93) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="172.68"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(-138.95 493.1) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="166.54"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(-124.1 478.24) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="160.01"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(-129.95 471.52) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="165.44"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(-111.35 463.79) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="172.48"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(-104.79 463.21) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="160.25"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(-107.53 450.62) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M162.2,267.61h12.67a3.08,3.08,0,0,1,2.19-2.74h-17v0A3.07,3.07,0,0,1,162.2,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="162.17"
        y="266.62"
        width="12.72"
        height="5.41"
        transform="translate(337.05 538.66) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="181.49 267.85 161.57 267.85 161.57 289.97 163.28 289.97 163.28 309.97 166.23 309.97 166.27 314.5 187.85 314.5 187.85 300.87 190.03 300.87 190.03 290.65 194.56 290.65 194.56 276.03 181.49 276.03 181.49 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="166.18 314.54 187.81 314.54 187.81 300.87 189.95 300.87 189.95 290.69 194.56 290.69 194.56 276.08 168.75 276.08 168.75 279.84 166.18 279.84 166.18 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M166.18,295.64h-.81v7.09h.78l.06,11H188V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="170.89"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(-130.52 484.61) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="160.4"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-141.07 474.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="160.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-140.78 474.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="160.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-140.5 474.62) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="161.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-140.21 474.91) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="161.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-139.92 475.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="161.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-139.63 475.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="162.13"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-139.34 475.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="162.42"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-139.05 476.06) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="162.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-138.76 476.35) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="162.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-138.48 476.64) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="163.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-138.19 476.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="163.57"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-137.9 477.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="163.86"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-137.61 477.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="164.15"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-137.32 477.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="164.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-137.03 478.08) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="164.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-136.74 478.37) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="165.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-136.46 478.66) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="165.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-136.17 478.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="165.59"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-135.88 479.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="165.88"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-135.59 479.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="166.17"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-135.3 479.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="166.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-135.01 480.1) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="166.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-134.73 480.39) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="167.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-134.44 480.68) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="167.32"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-134.15 480.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="167.61"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-133.86 481.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="167.9"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-133.57 481.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="168.19"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-133.28 481.83) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="168.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-132.99 482.12) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="168.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-132.71 482.41) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="169.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-132.42 482.7) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="169.34"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-132.13 482.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="169.63"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-131.84 483.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="169.92"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-131.55 483.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="170.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-131.26 483.85) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="170.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-130.97 484.14) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="170.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-130.69 484.43) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="171.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-130.4 484.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="171.36"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-130.11 485) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="171.65"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-129.82 485.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="171.94"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-129.53 485.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="172.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-129.24 485.87) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="172.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-128.95 486.16) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="172.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-128.67 486.45) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="173.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-128.38 486.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="173.38"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-128.09 487.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="173.67"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-127.8 487.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="173.96"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-127.51 487.6) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="174.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-127.22 487.89) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="174.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-126.94 488.18) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="174.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-126.65 488.47) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="175.11"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-126.36 488.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="175.4"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-126.07 489.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="175.69"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-125.78 489.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="175.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-125.49 489.62) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="176.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-125.2 489.91) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="176.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-124.92 490.2) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="176.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-124.63 490.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="177.13"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-124.34 490.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="177.42"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-124.05 491.06) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="177.71"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-123.76 491.35) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="177.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-123.47 491.64) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="178.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-123.18 491.93) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="178.57"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-122.9 492.22) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="178.86"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-122.61 492.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="179.15"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-122.32 492.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="179.44"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-122.03 493.08) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="179.73"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-121.74 493.37) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="180.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-121.45 493.66) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="180.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-121.17 493.95) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="180.59"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-120.88 494.24) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="180.88"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-120.59 494.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="181.17"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-120.3 494.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="181.46"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-120.01 495.1) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="227.93 321.38 229.02 321.38 229.02 329.65 203.44 329.65 203.44 322.79 203.44 321.38 203.44 314.52 227.93 314.52 227.93 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="226.04"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(-95.34 554.54) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="228.43"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(-88.73 548.81) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="212.73"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(-98.9 533.15) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="206.6"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(-84.04 518.3) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="212.64"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(-77.32 524.15) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="207.21"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(-69.59 505.55) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="208.26"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(-69.01 498.99) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="211.35"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(-56.42 501.73) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M232,267.61H219.33a3.08,3.08,0,0,0-2.19-2.74h17v0A3.07,3.07,0,0,0,232,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="219.32"
        y="266.62"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="212.72 267.85 232.63 267.85 232.63 289.97 230.92 289.97 230.92 309.97 227.97 309.97 227.93 314.5 206.35 314.5 206.35 300.87 204.17 300.87 204.17 290.65 199.64 290.65 199.64 276.03 212.72 276.03 212.72 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="228.02 314.54 206.39 314.54 206.39 300.87 204.25 300.87 204.25 290.69 199.64 290.69 199.64 276.08 225.45 276.08 225.45 279.84 228.02 279.84 228.02 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M228,288.17H204V300.9h2.23v12.82H228l.06-11h.78v-7.09H228Zm-12.65,1.5v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="211"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(-90.41 524.72) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="221.63"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-79.84 535.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="221.34"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-80.13 534.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="221.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-80.42 534.7) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="220.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-80.71 534.41) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="220.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-80.99 534.12) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="220.19"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-81.28 533.83) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="219.9"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-81.57 533.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="219.61"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-81.86 533.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="219.32"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-82.15 532.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="219.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-82.44 532.68) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="218.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-82.73 532.39) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="218.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-83.01 532.1) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="218.17"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-83.3 531.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="217.88"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-83.59 531.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="217.59"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-83.88 531.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="217.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-84.17 530.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="217.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-84.46 530.66) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="216.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-84.74 530.37) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="216.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-85.03 530.08) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="216.15"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-85.32 529.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="215.86"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-85.61 529.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="215.57"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-85.9 529.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="215.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-86.19 528.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="214.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-86.48 528.64) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="214.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-86.76 528.35) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="214.42"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-87.05 528.06) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="214.13"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-87.34 527.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="213.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-87.63 527.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="213.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-87.92 527.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="213.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-88.21 526.91) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="212.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-88.5 526.62) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="212.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-88.78 526.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="212.4"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-89.07 526.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="212.11"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-89.36 525.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="211.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-89.65 525.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="211.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-89.94 525.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="211.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-90.23 524.89) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="210.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-90.51 524.6) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="210.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-90.8 524.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="210.38"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-91.09 524.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="210.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-91.38 523.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="209.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-91.67 523.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="209.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-91.96 523.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="209.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-92.25 522.87) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="208.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-92.53 522.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="208.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-92.82 522.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="208.36"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-93.11 522) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="208.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-93.4 521.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="207.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-93.69 521.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="207.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-93.98 521.14) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="207.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-94.27 520.85) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="206.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-94.55 520.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="206.63"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-94.84 520.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="206.34"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-95.13 519.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="206.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-95.42 519.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="205.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-95.71 519.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="205.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-96 519.12) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="205.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-96.28 518.83) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="204.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-96.57 518.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="204.61"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-96.86 518.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="204.32"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-97.15 517.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="204.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-97.44 517.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="203.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-97.73 517.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="203.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-98.02 517.1) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="203.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-98.3 516.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="202.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-98.59 516.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="202.59"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-98.88 516.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="202.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-99.17 515.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="202.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-99.46 515.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="201.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-99.75 515.37) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="201.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-100.04 515.08) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="201.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-100.32 514.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="200.86"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-100.61 514.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="200.57"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-100.9 514.21) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="243.77 321.38 242.68 321.38 242.68 329.65 268.26 329.65 268.26 322.79 268.26 321.38 268.26 314.52 243.77 314.52 243.77 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="238.54"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(-82.84 567.04) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="240.05"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(-77.11 560.43) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="250.17"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(-61.46 570.59) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="244.04"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(-46.6 555.74) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="237.51"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(-52.45 549.02) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="242.94"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(-33.86 541.28) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="249.97"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(-27.29 540.7) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="237.75"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(-30.03 528.12) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M239.7,267.61h12.66a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.09,3.09,0,0,1,239.7,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="239.66"
        y="266.62"
        width="12.72"
        height="5.41"
        transform="translate(492.04 538.66) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="258.98 267.85 239.06 267.85 239.06 289.97 240.77 289.97 240.77 309.97 243.72 309.97 243.76 314.5 265.35 314.5 265.35 300.87 267.53 300.87 267.53 290.65 272.06 290.65 272.06 276.03 258.98 276.03 258.98 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="243.68 314.54 265.31 314.54 265.31 300.87 267.44 300.87 267.44 290.69 272.06 290.69 272.06 276.08 246.24 276.08 246.24 279.84 243.68 279.84 243.68 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M243.68,295.64h-.81v7.09h.77l.07,11h21.74V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="248.39"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(-53.02 562.11) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="237.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-63.58 551.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="238.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-63.29 551.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="238.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-63 552.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="238.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-62.71 552.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="239.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-62.42 552.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="239.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-62.13 552.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="239.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-61.84 553.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="239.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-61.56 553.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="240.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-61.27 553.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="240.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-60.98 554.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="240.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-60.69 554.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="241.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-60.4 554.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="241.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-60.11 555) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="241.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-59.83 555.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="241.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-59.54 555.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="242.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-59.25 555.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="242.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-58.96 556.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="242.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-58.67 556.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="243.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-58.38 556.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="243.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-58.09 557.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="243.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-57.81 557.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="243.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-57.52 557.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="244.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-57.23 557.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="244.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-56.94 558.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="244.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-56.65 558.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="245.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-56.36 558.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="245.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-56.07 559.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="245.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-55.79 559.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="245.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-55.5 559.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="246.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-55.21 559.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="246.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-54.92 560.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="246.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-54.63 560.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="247.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-54.34 560.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="247.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-54.06 561.06) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="247.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-53.77 561.35) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="247.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-53.48 561.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="248.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-53.19 561.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="248.57"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-52.9 562.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="248.86"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-52.61 562.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="249.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-52.32 562.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="249.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-52.04 563.08) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="249.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-51.75 563.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="250.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-51.46 563.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="250.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-51.17 563.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="250.59"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-50.88 564.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="250.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-50.59 564.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="251.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-50.3 564.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="251.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-50.02 565.1) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="251.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-49.73 565.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="252.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-49.44 565.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="252.32"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-49.15 565.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="252.61"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-48.86 566.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="252.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-48.57 566.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="253.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-48.29 566.83) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="253.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-48 567.12) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="253.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-47.71 567.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="254.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-47.42 567.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="254.34"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-47.13 567.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="254.63"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-46.84 568.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="254.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-46.55 568.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="255.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-46.27 568.85) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="255.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-45.98 569.14) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="255.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-45.69 569.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="256.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-45.4 569.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="256.36"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-45.11 570) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="256.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-44.82 570.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="256.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-44.53 570.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="257.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-44.25 570.87) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="257.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-43.96 571.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="257.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-43.67 571.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="258.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-43.38 571.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="258.38"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-43.09 572.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="258.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-42.8 572.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="258.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-42.51 572.6) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="305.42 321.38 306.52 321.38 306.52 329.65 280.94 329.65 280.94 322.79 280.94 321.38 280.94 314.52 305.42 314.52 305.42 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="303.54"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(-17.85 632.04) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="305.93"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(-11.24 626.31) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="290.23"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(-21.4 610.65) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="284.09"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(-6.55 595.8) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="290.13"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(0.17 601.64) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="284.7"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(7.91 583.05) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="285.76"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(8.49 576.48) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="288.85"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(21.08 579.22) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M309.5,267.61H296.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,309.5,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="296.81"
        y="266.62"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="290.21 267.85 310.13 267.85 310.13 289.97 308.42 289.97 308.42 309.97 305.47 309.97 305.43 314.5 283.84 314.5 283.84 300.87 281.66 300.87 281.66 290.65 277.13 290.65 277.13 276.03 290.21 276.03 290.21 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="305.51 314.54 283.89 314.54 283.89 300.87 281.75 300.87 281.75 290.69 277.13 290.69 277.13 276.08 302.95 276.08 302.95 279.84 305.51 279.84 305.51 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M305.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H282v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="288.49"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(-12.92 602.22) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="299.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-2.34 612.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="298.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-2.63 612.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="298.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-2.92 612.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="298.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-3.21 611.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="297.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-3.5 611.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="297.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-3.79 611.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="297.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-4.07 611.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="297.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-4.36 610.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="296.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-4.65 610.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="296.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-4.94 610.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="296.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-5.23 609.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="295.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-5.52 609.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="295.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-5.81 609.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="295.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-6.09 609.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="295.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-6.38 608.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="294.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-6.67 608.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="294.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-6.96 608.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="294.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-7.25 607.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="293.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-7.54 607.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="293.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-7.83 607.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="293.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-8.11 607) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="293.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-8.4 606.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="292.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-8.69 606.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="292.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-8.98 606.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="292.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-9.27 605.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="291.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-9.56 605.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="291.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-9.84 605.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="291.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-10.13 604.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="291.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-10.42 604.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="290.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-10.71 604.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="290.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-11 604.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="290.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-11.29 603.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="289.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-11.58 603.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="289.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-11.86 603.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="289.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-12.15 602.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="289.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-12.44 602.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="288.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-12.73 602.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="288.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-13.02 602.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="288.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-13.31 601.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="287.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-13.6 601.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="287.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-13.88 601.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="287.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-14.17 600.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="287.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-14.46 600.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="286.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-14.75 600.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="286.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-15.04 600.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="286.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-15.33 599.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="285.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-15.62 599.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="285.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-15.9 599.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="285.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-16.19 598.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="284.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-16.48 598.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="284.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-16.77 598.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="284.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-17.06 598.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="284.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-17.35 597.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="283.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-17.63 597.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="283.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-17.92 597.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="283.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-18.21 596.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="282.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-18.5 596.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="282.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-18.79 596.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="282.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-19.08 596.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="282.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-19.37 595.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="281.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-19.65 595.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="281.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-19.94 595.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="281.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-20.23 594.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="280.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-20.52 594.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="280.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-20.81 594.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="280.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-21.1 594.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="280.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-21.39 593.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="279.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-21.67 593.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="279.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-21.96 593.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="279.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-22.25 592.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="278.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-22.54 592.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="278.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-22.83 592.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="278.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-23.12 592) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="278.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(-23.4 591.71) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="321.27 321.38 320.17 321.38 320.17 329.65 345.75 329.65 345.75 322.79 345.75 321.38 345.75 314.52 321.27 314.52 321.27 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="316.04"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(-5.35 644.54) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="317.55"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(0.38 637.92) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="327.67"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(16.04 648.09) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="321.53"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(30.89 633.24) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="315.01"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(25.05 626.52) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="320.43"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(43.64 618.78) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="327.47"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(50.2 618.2) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="315.24"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(47.47 605.61) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M317.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,317.19,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="317.16"
        y="266.62"
        width="12.72"
        height="5.41"
        transform="translate(647.04 538.66) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="336.48 267.85 316.56 267.85 316.56 289.97 318.27 289.97 318.27 309.97 321.22 309.97 321.26 314.5 342.85 314.5 342.85 300.87 345.03 300.87 345.03 290.65 349.56 290.65 349.56 276.03 336.48 276.03 336.48 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="321.18 314.54 342.8 314.54 342.8 300.87 344.94 300.87 344.94 290.69 349.56 290.69 349.56 276.08 323.74 276.08 323.74 279.84 321.18 279.84 321.18 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M321.17,295.64h-.81v7.09h.78l.06,11H343V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="325.88"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(24.47 639.61) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="315.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(13.92 629.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="315.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(14.21 629.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="315.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(14.5 629.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="316.25"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(14.79 629.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="316.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(15.07 630.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="316.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(15.36 630.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="317.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(15.65 630.76) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="317.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(15.94 631.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="317.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(16.23 631.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="317.98"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(16.52 631.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="318.27"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(16.81 631.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="318.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(17.09 632.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="318.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(17.38 632.49) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="319.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(17.67 632.78) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="319.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(17.96 633.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="319.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(18.25 633.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="320"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(18.54 633.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="320.29"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(18.83 633.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="320.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(19.11 634.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="320.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(19.4 634.51) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="321.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(19.69 634.8) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="321.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(19.98 635.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="321.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(20.27 635.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="322.02"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(20.56 635.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="322.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(20.84 635.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="322.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(21.13 636.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="322.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(21.42 636.53) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="323.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(21.71 636.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="323.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(22 637.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="323.75"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(22.29 637.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="324.04"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(22.58 637.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="324.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(22.86 637.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="324.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(23.15 638.26) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="324.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(23.44 638.55) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="325.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(23.73 638.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="325.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(24.02 639.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="325.77"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(24.31 639.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="326.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(24.6 639.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="326.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(24.88 640) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="326.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(25.17 640.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="326.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(25.46 640.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="327.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(25.75 640.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="327.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(26.04 641.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="327.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(26.33 641.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="328.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(26.61 641.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="328.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(26.9 642.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="328.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(27.19 642.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="328.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(27.48 642.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="329.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(27.77 642.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="329.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(28.06 643.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="329.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(28.35 643.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="330.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(28.63 643.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="330.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(28.92 644.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="330.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(29.21 644.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="330.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(29.5 644.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="331.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(29.79 644.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="331.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(30.08 645.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="331.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(30.37 645.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="332.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(30.65 645.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="332.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(30.94 646.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="332.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(31.23 646.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="332.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(31.52 646.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="333.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(31.81 646.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="333.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(32.1 647.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="333.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(32.38 647.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="334.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(32.67 647.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="334.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(32.96 648.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="334.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(33.25 648.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="335.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(33.54 648.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="335.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(33.83 648.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="335.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(34.12 649.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="335.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(34.4 649.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="336.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(34.69 649.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="336.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(34.98 650.09) rotate(-90)"
        fill="#808184"
      />
      <text
        transform="translate(170.88 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V4
        </tspan>
      </text>
      <text
        transform="translate(131.55 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V1
        </tspan>
      </text>
      <text
        transform="translate(286.22 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V9
        </tspan>
      </text>
      <text
        transform="translate(248.88 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V8
        </tspan>
      </text>
      <text
        transform="translate(248.88 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V7
        </tspan>
      </text>
      <text
        transform="translate(208.88 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V6
        </tspan>
      </text>
      <text
        transform="translate(286.22 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V10
        </tspan>
      </text>
      <text
        transform="translate(326.88 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V12
        </tspan>
      </text>
      <text
        transform="translate(326.88 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0.29" y="9.6">
          V
        </tspan>
        <tspan x="5.63" y="9.6" letter-spacing="-0.07em">
          1
        </tspan>
        <tspan x="9.49" y="9.6">
          1
        </tspan>
      </text>
      <text
        transform="translate(170.88 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V3
        </tspan>
      </text>
      <text
        transform="translate(131.55 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V2
        </tspan>
      </text>
      <text
        transform="translate(208.88 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="2.22" y="9.6">
          V5
        </tspan>
      </text>
      <line
        x1="118.53"
        y1="331.98"
        x2="352.54"
        y2="331.98"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="158.28"
        y1="267.59"
        x2="158.28"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="197.17"
        y1="267.59"
        x2="197.17"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="235.91"
        y1="267.59"
        x2="235.91"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="274.66"
        y1="267.59"
        x2="274.66"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="313.41"
        y1="267.59"
        x2="313.41"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
    </g>
    <g id="Villas" data-name="Villas">
      <rect
        x="363.53"
        y="267.59"
        width="271.47"
        height="129.07"
        fill="#4f9656"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.34"
      />
      <rect x="635" y="267.59" width="9.5" height="129.07" fill="#dcddde" />
      <rect x="363.33" y="332.18" width="38.67" height="64.67" fill="#fff" />
      <polygon
        points="375.77 321.38 374.68 321.38 374.68 329.65 400.26 329.65 400.26 322.79 400.26 321.38 400.26 314.52 375.77 314.52 375.77 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="370.54"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(49.16 699.04) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="372.05"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(54.89 692.43) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="382.17"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(70.54 702.59) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="376.04"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(85.4 687.74) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="369.51"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(79.55 681.02) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="374.94"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(98.14 673.28) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="381.97"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(104.71 672.7) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="369.75"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(101.97 660.12) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M371.7,267.61h12.66a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.09,3.09,0,0,1,371.7,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="371.66"
        y="266.62"
        width="12.72"
        height="5.41"
        transform="translate(756.04 538.66) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="390.98 267.85 371.06 267.85 371.06 289.97 372.77 289.97 372.77 309.97 375.72 309.97 375.76 314.5 397.35 314.5 397.35 300.87 399.53 300.87 399.53 290.65 404.06 290.65 404.06 276.03 390.98 276.03 390.98 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="375.68 314.54 397.31 314.54 397.31 300.87 399.44 300.87 399.44 290.69 404.06 290.69 404.06 276.08 378.24 276.08 378.24 279.84 375.68 279.84 375.68 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M375.68,295.64h-.81v7.09h.77l.07,11h21.74V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="380.39"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(78.98 694.11) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="369.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(68.42 683.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="370.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(68.71 683.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="370.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(69 684.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="370.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(69.29 684.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="371.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(69.58 684.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="371.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(69.87 684.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="371.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(70.16 685.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="371.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(70.44 685.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="372.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(70.73 685.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="372.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(71.02 686.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="372.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(71.31 686.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="373.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(71.6 686.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="373.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(71.89 687) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="373.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(72.17 687.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="373.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(72.46 687.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="374.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(72.75 687.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="374.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(73.04 688.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="374.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(73.33 688.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="375.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(73.62 688.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="375.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(73.91 689.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="375.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(74.19 689.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="375.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(74.48 689.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="376.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(74.77 689.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="376.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(75.06 690.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="376.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(75.35 690.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="377.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(75.64 690.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="377.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(75.93 691.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="377.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(76.21 691.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="377.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(76.5 691.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="378.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(76.79 691.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="378.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(77.08 692.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="378.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(77.37 692.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="379.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(77.66 692.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="379.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(77.94 693.06) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="379.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(78.23 693.35) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="379.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(78.52 693.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="380.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(78.81 693.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="380.57"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(79.1 694.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="380.86"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(79.39 694.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="381.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(79.68 694.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="381.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(79.96 695.08) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="381.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(80.25 695.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="382.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(80.54 695.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="382.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(80.83 695.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="382.59"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(81.12 696.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="382.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(81.41 696.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="383.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(81.7 696.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="383.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(81.98 697.1) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="383.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(82.27 697.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="384.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(82.56 697.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="384.32"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(82.85 697.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="384.61"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(83.14 698.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="384.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(83.43 698.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="385.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(83.71 698.83) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="385.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(84 699.12) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="385.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(84.29 699.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="386.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(84.58 699.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="386.34"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(84.87 699.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="386.63"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(85.16 700.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="386.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(85.45 700.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="387.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(85.73 700.85) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="387.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(86.02 701.14) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="387.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(86.31 701.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="388.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(86.6 701.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="388.36"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(86.89 702) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="388.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(87.18 702.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="388.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(87.47 702.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="389.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(87.75 702.87) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="389.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(88.04 703.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="389.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(88.33 703.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="390.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(88.62 703.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="390.38"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(88.91 704.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="390.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(89.2 704.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="390.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(89.49 704.6) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="437.42 321.38 438.52 321.38 438.52 329.65 412.94 329.65 412.94 322.79 412.94 321.38 412.94 314.52 437.42 314.52 437.42 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="435.54"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(114.15 764.04) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="437.93"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(120.76 758.31) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="422.23"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(110.6 742.65) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="416.09"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(125.45 727.8) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="422.13"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(132.17 733.64) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="416.7"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(139.91 715.05) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="417.76"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(140.49 708.48) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="420.85"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(153.08 711.22) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M441.5,267.61H428.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,441.5,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="428.81"
        y="266.62"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="422.21 267.85 442.13 267.85 442.13 289.97 440.42 289.97 440.42 309.97 437.47 309.97 437.43 314.5 415.84 314.5 415.84 300.87 413.66 300.87 413.66 290.65 409.13 290.65 409.13 276.03 422.21 276.03 422.21 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="437.51 314.54 415.89 314.54 415.89 300.87 413.75 300.87 413.75 290.69 409.13 290.69 409.13 276.08 434.95 276.08 434.95 279.84 437.51 279.84 437.51 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M437.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H414v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="420.49"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(119.08 734.22) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="431.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(129.66 744.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="430.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(129.37 744.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="430.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(129.08 744.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="430.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(128.79 743.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="429.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(128.5 743.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="429.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(128.21 743.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="429.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(127.93 743.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="429.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(127.64 742.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="428.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(127.35 742.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="428.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(127.06 742.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="428.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(126.77 741.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="427.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(126.48 741.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="427.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(126.19 741.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="427.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(125.91 741.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="427.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(125.62 740.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="426.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(125.33 740.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="426.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(125.04 740.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="426.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(124.75 739.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="425.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(124.46 739.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="425.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(124.17 739.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="425.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(123.89 739) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="425.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(123.6 738.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="424.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(123.31 738.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="424.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(123.02 738.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="424.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(122.73 737.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="423.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(122.44 737.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="423.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(122.16 737.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="423.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(121.87 736.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="423.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(121.58 736.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="422.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(121.29 736.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="422.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(121 736.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="422.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(120.71 735.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="421.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(120.42 735.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="421.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(120.14 735.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="421.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(119.85 734.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="421.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(119.56 734.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="420.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(119.27 734.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="420.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(118.98 734.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="420.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(118.69 733.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="419.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(118.4 733.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="419.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(118.12 733.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="419.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(117.83 732.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="419.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(117.54 732.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="418.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(117.25 732.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="418.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(116.96 732.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="418.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(116.67 731.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="417.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(116.38 731.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="417.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(116.1 731.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="417.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(115.81 730.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="416.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(115.52 730.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="416.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(115.23 730.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="416.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(114.94 730.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="416.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(114.65 729.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="415.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(114.37 729.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="415.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(114.08 729.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="415.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(113.79 728.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="414.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(113.5 728.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="414.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(113.21 728.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="414.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(112.92 728.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="414.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(112.63 727.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="413.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(112.35 727.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="413.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(112.06 727.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="413.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(111.77 726.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="412.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(111.48 726.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="412.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(111.19 726.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="412.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(110.9 726.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="412.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(110.61 725.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="411.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(110.33 725.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="411.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(110.04 725.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="411.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(109.75 724.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="410.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(109.46 724.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="410.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(109.17 724.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="410.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(108.88 724) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="410.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(108.6 723.71) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="453.27 321.38 452.17 321.38 452.17 329.65 477.75 329.65 477.75 322.79 477.75 321.38 477.75 314.52 453.27 314.52 453.27 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="448.04"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(126.65 776.54) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="449.55"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(132.38 769.92) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="459.67"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(148.04 780.09) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="453.53"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(162.89 765.24) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="447.01"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(157.05 758.52) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="452.43"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(175.64 750.78) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="459.47"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(182.2 750.2) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="447.24"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(179.47 737.61) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M449.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,449.19,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="449.16"
        y="266.62"
        width="12.72"
        height="5.41"
        transform="translate(911.04 538.66) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="468.48 267.85 448.56 267.85 448.56 289.97 450.27 289.97 450.27 309.97 453.22 309.97 453.26 314.5 474.85 314.5 474.85 300.87 477.03 300.87 477.03 290.65 481.56 290.65 481.56 276.03 468.48 276.03 468.48 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="453.18 314.54 474.8 314.54 474.8 300.87 476.94 300.87 476.94 290.69 481.56 290.69 481.56 276.08 455.74 276.08 455.74 279.84 453.18 279.84 453.18 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M453.17,295.64h-.81v7.09h.78l.06,11H475V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="457.88"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(156.47 771.61) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="447.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(145.92 761.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="447.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(146.21 761.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="447.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(146.5 761.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="448.25"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(146.79 761.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="448.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(147.07 762.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="448.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(147.36 762.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="449.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(147.65 762.76) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="449.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(147.94 763.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="449.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(148.23 763.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="449.98"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(148.52 763.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="450.27"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(148.81 763.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="450.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(149.09 764.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="450.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(149.38 764.49) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="451.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(149.67 764.78) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="451.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(149.96 765.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="451.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(150.25 765.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="452"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(150.54 765.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="452.29"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(150.83 765.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="452.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(151.11 766.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="452.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(151.4 766.51) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="453.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(151.69 766.8) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="453.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(151.98 767.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="453.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(152.27 767.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="454.02"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(152.56 767.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="454.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(152.84 767.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="454.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(153.13 768.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="454.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(153.42 768.53) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="455.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(153.71 768.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="455.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(154 769.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="455.75"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(154.29 769.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="456.04"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(154.58 769.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="456.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(154.86 769.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="456.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(155.15 770.26) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="456.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(155.44 770.55) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="457.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(155.73 770.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="457.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(156.02 771.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="457.77"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(156.31 771.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="458.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(156.6 771.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="458.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(156.88 772) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="458.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(157.17 772.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="458.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(157.46 772.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="459.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(157.75 772.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="459.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(158.04 773.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="459.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(158.33 773.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="460.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(158.61 773.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="460.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(158.9 774.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="460.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(159.19 774.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="460.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(159.48 774.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="461.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(159.77 774.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="461.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(160.06 775.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="461.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(160.35 775.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="462.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(160.63 775.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="462.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(160.92 776.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="462.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(161.21 776.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="462.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(161.5 776.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="463.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(161.79 776.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="463.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(162.08 777.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="463.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(162.37 777.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="464.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(162.65 777.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="464.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(162.94 778.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="464.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(163.23 778.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="464.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(163.52 778.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="465.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(163.81 778.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="465.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(164.1 779.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="465.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(164.38 779.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="466.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(164.67 779.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="466.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(164.96 780.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="466.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(165.25 780.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="467.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(165.54 780.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="467.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(165.83 780.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="467.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(166.12 781.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="467.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(166.4 781.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="468.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(166.69 781.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="468.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(166.98 782.09) rotate(-90)"
        fill="#808184"
      />
      <rect x="368.9" y="352.82" width="24.64" height="30.82" fill="#939598" />
      <path
        d="M393.55,352.66V335.9H368.9v11.62h-4.77v5.14Zm-15.74-5.15h-6.34v-10.4h6.34Zm13,0H384.5v-10.4h6.34Z"
        fill="#939598"
      />
      <line
        x1="406.5"
        y1="267.59"
        x2="406.5"
        y2="332.05"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="402.17"
        y1="332.19"
        x2="402.17"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="445.25"
        y1="267.59"
        x2="445.25"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="484"
        y1="267.59"
        x2="484"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="521.66"
        y1="267.59"
        x2="521.66"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="559.33"
        y1="267.59"
        x2="559.33"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="597"
        y1="267.59"
        x2="597"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="635"
        y1="267.59"
        x2="635"
        y2="396.65"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="363.53"
        y1="331.98"
        x2="634.67"
        y2="331.98"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <polygon
        points="437.42 342.74 438.52 342.74 438.52 334.47 412.94 334.47 412.94 341.33 412.94 342.74 412.94 349.6 437.42 349.6 437.42 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="435.54"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(778.27 -99.92) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="437.93"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(784.88 -94.19) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="422.23"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(774.72 -78.53) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="416.09"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(789.57 -63.68) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="422.13"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(796.29 -69.52) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="416.7"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(804.03 -50.93) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="417.76"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(804.61 -44.36) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="420.85"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(817.2 -47.1) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M441.5,398.9H428.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,441.5,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="428.81"
        y="394.47"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="422.21 396.27 442.13 396.27 442.13 374.15 440.42 374.15 440.42 354.15 437.47 354.15 437.43 349.62 415.84 349.62 415.84 363.25 413.66 363.25 413.66 373.47 409.13 373.47 409.13 388.09 422.21 388.09 422.21 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="437.51 349.58 415.89 349.58 415.89 363.25 413.75 363.25 413.75 373.43 409.13 373.43 409.13 388.04 434.95 388.04 434.95 384.28 437.51 384.28 437.51 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M437.52,368.48h.81v-7.09h-.78l-.06-11H415.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="420.49"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(783.2 -70.1) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="431.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(793.78 -80.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="430.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(793.49 -80.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="430.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(793.2 -80.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="430.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(792.91 -79.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="429.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(792.62 -79.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="429.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(792.33 -79.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="429.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(792.05 -78.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="429.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(791.76 -78.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="428.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(791.47 -78.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="428.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(791.18 -78.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="428.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(790.89 -77.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="427.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(790.6 -77.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="427.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(790.31 -77.19) rotate(90)"
        fill="#808184"
      />
      <rect
        x="427.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(790.03 -76.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="427.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(789.74 -76.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="426.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(789.45 -76.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="426.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(789.16 -76.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="426.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(788.87 -75.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="425.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(788.58 -75.46) rotate(90)"
        fill="#808184"
      />
      <rect
        x="425.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(788.29 -75.17) rotate(90)"
        fill="#808184"
      />
      <rect
        x="425.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(788.01 -74.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="425.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(787.72 -74.59) rotate(90)"
        fill="#808184"
      />
      <rect
        x="424.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(787.43 -74.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="424.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(787.14 -74.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="424.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(786.85 -73.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="423.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(786.56 -73.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="423.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(786.28 -73.15) rotate(90)"
        fill="#808184"
      />
      <rect
        x="423.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(785.99 -72.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="423.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(785.7 -72.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="422.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(785.41 -72.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="422.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(785.12 -71.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="422.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(784.83 -71.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="421.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(784.54 -71.42) rotate(90)"
        fill="#808184"
      />
      <rect
        x="421.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(784.26 -71.13) rotate(90)"
        fill="#808184"
      />
      <rect
        x="421.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(783.97 -70.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="421.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(783.68 -70.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="420.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(783.39 -70.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="420.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(783.1 -69.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="420.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(782.81 -69.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="419.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(782.52 -69.4) rotate(90)"
        fill="#808184"
      />
      <rect
        x="419.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(782.24 -69.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="419.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(781.95 -68.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="419.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(781.66 -68.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="418.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(781.37 -68.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="418.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(781.08 -67.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="418.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(780.79 -67.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="417.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(780.5 -67.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="417.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(780.22 -67.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="417.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(779.93 -66.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="416.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(779.64 -66.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="416.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(779.35 -66.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="416.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(779.06 -65.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="416.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(778.77 -65.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="415.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(778.49 -65.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="415.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(778.2 -65.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="415.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(777.91 -64.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="414.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(777.62 -64.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="414.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(777.33 -64.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="414.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(777.04 -63.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="414.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(776.75 -63.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="413.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(776.47 -63.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="413.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(776.18 -63.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="413.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(775.89 -62.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="412.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(775.6 -62.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="412.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(775.31 -62.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="412.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(775.02 -61.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="412.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(774.73 -61.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="411.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(774.45 -61.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="411.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(774.16 -61.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="411.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(773.87 -60.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="410.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(773.58 -60.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="410.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(773.29 -60.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="410.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(773 -59.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="410.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(772.72 -59.59) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="453.27 342.74 452.17 342.74 452.17 334.47 477.75 334.47 477.75 341.33 477.75 342.74 477.75 349.6 453.27 349.6 453.27 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="448.04"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(790.77 -112.42) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="449.55"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(796.5 -105.8) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="459.67"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(812.16 -115.97) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="453.53"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(827.01 -101.12) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="447.01"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(821.17 -94.4) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="452.43"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(839.76 -86.66) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="459.47"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(846.32 -86.08) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="447.24"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(843.59 -73.49) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M449.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,449.19,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="449.16"
        y="394.47"
        width="12.72"
        height="5.41"
        transform="translate(911.04 794.35) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="468.48 396.27 448.56 396.27 448.56 374.15 450.27 374.15 450.27 354.15 453.22 354.15 453.26 349.62 474.85 349.62 474.85 363.25 477.03 363.25 477.03 373.47 481.56 373.47 481.56 388.09 468.48 388.09 468.48 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="453.18 349.58 474.8 349.58 474.8 363.25 476.94 363.25 476.94 373.43 481.56 373.43 481.56 388.04 455.74 388.04 455.74 384.28 453.18 384.28 453.18 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M453.17,376h24V363.22H475V350.4H453.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="457.88"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(820.59 -107.49) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="447.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(810.04 -96.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="447.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(810.33 -97.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="447.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(810.62 -97.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="448.25"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(810.91 -97.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="448.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(811.19 -98.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="448.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(811.48 -98.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="449.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(811.77 -98.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="449.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(812.06 -98.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="449.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(812.35 -99.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="449.98"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(812.64 -99.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="450.27"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(812.93 -99.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="450.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(813.21 -100.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="450.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(813.5 -100.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="451.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(813.79 -100.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="451.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(814.08 -100.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="451.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(814.37 -101.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="452"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(814.66 -101.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="452.29"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(814.94 -101.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="452.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(815.23 -102.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="452.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(815.52 -102.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="453.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(815.81 -102.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="453.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(816.1 -102.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="453.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(816.39 -103.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="454.02"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(816.68 -103.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="454.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(816.96 -103.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="454.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(817.25 -104.13) rotate(90)"
        fill="#808184"
      />
      <rect
        x="454.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(817.54 -104.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="455.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(817.83 -104.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="455.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(818.12 -104.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="455.75"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(818.41 -105.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="456.04"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(818.7 -105.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="456.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(818.98 -105.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="456.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(819.27 -106.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="456.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(819.56 -106.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="457.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(819.85 -106.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="457.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(820.14 -107.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="457.77"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(820.43 -107.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="458.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(820.72 -107.59) rotate(90)"
        fill="#808184"
      />
      <rect
        x="458.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(821 -107.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="458.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(821.29 -108.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="458.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(821.58 -108.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="459.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(821.87 -108.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="459.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(822.16 -109.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="459.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(822.45 -109.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="460.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(822.73 -109.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="460.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(823.02 -109.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="460.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(823.31 -110.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="460.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(823.6 -110.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="461.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(823.89 -110.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="461.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(824.18 -111.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="461.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(824.47 -111.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="462.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(824.75 -111.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="462.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(825.04 -111.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="462.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(825.33 -112.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="462.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(825.62 -112.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="463.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(825.91 -112.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="463.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(826.2 -113.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="463.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(826.49 -113.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="464.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(826.77 -113.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="464.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(827.06 -113.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="464.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(827.35 -114.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="464.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(827.64 -114.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="465.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(827.93 -114.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="465.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(828.22 -115.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="465.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(828.5 -115.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="466.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(828.79 -115.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="466.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(829.08 -115.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="466.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(829.37 -116.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="467.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(829.66 -116.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="467.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(829.95 -116.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="467.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(830.24 -117.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="467.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(830.52 -117.4) rotate(90)"
        fill="#808184"
      />
      <rect
        x="468.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(830.81 -117.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="468.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(831.1 -117.97) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="513.42 321.38 514.52 321.38 514.52 329.65 488.94 329.65 488.94 322.79 488.94 321.38 488.94 314.52 513.42 314.52 513.42 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="511.54"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(190.15 840.04) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="513.93"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(196.76 834.31) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="498.23"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(186.6 818.65) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="492.09"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(201.45 803.8) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="498.13"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(208.17 809.64) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="492.7"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(215.91 791.05) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="493.76"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(216.49 784.48) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="496.85"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(229.08 787.22) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M517.5,267.61H504.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,517.5,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="504.81"
        y="266.62"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="498.21 267.85 518.13 267.85 518.13 289.97 516.42 289.97 516.42 309.97 513.47 309.97 513.43 314.5 491.84 314.5 491.84 300.87 489.66 300.87 489.66 290.65 485.13 290.65 485.13 276.03 498.21 276.03 498.21 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="513.51 314.54 491.89 314.54 491.89 300.87 489.75 300.87 489.75 290.69 485.13 290.69 485.13 276.08 510.95 276.08 510.95 279.84 513.51 279.84 513.51 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M513.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H490v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="496.49"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(195.08 810.22) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="507.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(205.66 820.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="506.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(205.37 820.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="506.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(205.08 820.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="506.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(204.79 819.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="505.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(204.5 819.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="505.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(204.21 819.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="505.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(203.93 819.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="505.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(203.64 818.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="504.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(203.35 818.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="504.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(203.06 818.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="504.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(202.77 817.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="503.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(202.48 817.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="503.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(202.19 817.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="503.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(201.91 817.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="503.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(201.62 816.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="502.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(201.33 816.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="502.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(201.04 816.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="502.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(200.75 815.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="501.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(200.46 815.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="501.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(200.17 815.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="501.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(199.89 815) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="501.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(199.6 814.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="500.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(199.31 814.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="500.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(199.02 814.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="500.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(198.73 813.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="499.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(198.44 813.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="499.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(198.16 813.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="499.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(197.87 812.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="499.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(197.58 812.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="498.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(197.29 812.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="498.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(197 812.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="498.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(196.71 811.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="497.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(196.42 811.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="497.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(196.14 811.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="497.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(195.85 810.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="497.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(195.56 810.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="496.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(195.27 810.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="496.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(194.98 810.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="496.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(194.69 809.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="495.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(194.4 809.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="495.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(194.12 809.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="495.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(193.83 808.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="495.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(193.54 808.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="494.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(193.25 808.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="494.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(192.96 808.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="494.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(192.67 807.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="493.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(192.38 807.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="493.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(192.1 807.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="493.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(191.81 806.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="492.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(191.52 806.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="492.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(191.23 806.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="492.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(190.94 806.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="492.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(190.65 805.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="491.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(190.37 805.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="491.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(190.08 805.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="491.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(189.79 804.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="490.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(189.5 804.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="490.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(189.21 804.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="490.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(188.92 804.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="490.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(188.63 803.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="489.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(188.35 803.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="489.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(188.06 803.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="489.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(187.77 802.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="488.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(187.48 802.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="488.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(187.19 802.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="488.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(186.9 802.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="488.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(186.61 801.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="487.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(186.33 801.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="487.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(186.04 801.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="487.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(185.75 800.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="486.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(185.46 800.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="486.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(185.17 800.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="486.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(184.88 800) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="486.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(184.6 799.71) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="529.27 321.38 528.17 321.38 528.17 329.65 553.75 329.65 553.75 322.79 553.75 321.38 553.75 314.52 529.27 314.52 529.27 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="524.04"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(202.65 852.54) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="525.55"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(208.38 845.92) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="535.67"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(224.04 856.09) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="529.53"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(238.89 841.24) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="523.01"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(233.05 834.52) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="528.43"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(251.64 826.78) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="535.47"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(258.2 826.2) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="523.24"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(255.47 813.61) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M525.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,525.19,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="525.16"
        y="266.62"
        width="12.72"
        height="5.41"
        transform="translate(1063.04 538.66) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="544.48 267.85 524.56 267.85 524.56 289.97 526.27 289.97 526.27 309.97 529.22 309.97 529.26 314.5 550.85 314.5 550.85 300.87 553.03 300.87 553.03 290.65 557.56 290.65 557.56 276.03 544.48 276.03 544.48 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="529.18 314.54 550.8 314.54 550.8 300.87 552.94 300.87 552.94 290.69 557.56 290.69 557.56 276.08 531.74 276.08 531.74 279.84 529.18 279.84 529.18 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M529.17,295.64h-.81v7.09h.78l.06,11H551V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="533.88"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(232.47 847.61) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="523.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(221.92 837.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="523.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(222.21 837.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="523.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(222.5 837.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="524.25"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(222.79 837.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="524.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(223.07 838.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="524.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(223.36 838.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="525.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(223.65 838.76) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="525.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(223.94 839.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="525.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(224.23 839.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="525.98"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(224.52 839.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="526.27"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(224.81 839.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="526.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(225.09 840.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="526.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(225.38 840.49) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="527.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(225.67 840.78) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="527.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(225.96 841.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="527.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(226.25 841.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="528"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(226.54 841.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="528.29"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(226.83 841.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="528.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(227.11 842.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="528.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(227.4 842.51) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="529.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(227.69 842.8) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="529.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(227.98 843.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="529.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(228.27 843.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="530.02"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(228.56 843.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="530.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(228.84 843.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="530.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(229.13 844.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="530.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(229.42 844.53) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="531.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(229.71 844.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="531.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(230 845.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="531.75"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(230.29 845.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="532.04"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(230.58 845.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="532.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(230.86 845.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="532.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(231.15 846.26) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="532.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(231.44 846.55) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="533.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(231.73 846.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="533.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(232.02 847.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="533.77"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(232.31 847.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="534.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(232.6 847.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="534.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(232.88 848) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="534.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(233.17 848.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="534.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(233.46 848.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="535.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(233.75 848.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="535.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(234.04 849.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="535.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(234.33 849.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="536.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(234.61 849.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="536.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(234.9 850.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="536.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(235.19 850.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="536.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(235.48 850.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="537.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(235.77 850.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="537.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(236.06 851.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="537.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(236.35 851.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="538.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(236.63 851.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="538.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(236.92 852.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="538.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(237.21 852.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="538.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(237.5 852.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="539.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(237.79 852.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="539.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(238.08 853.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="539.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(238.37 853.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="540.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(238.65 853.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="540.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(238.94 854.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="540.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(239.23 854.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="540.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(239.52 854.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="541.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(239.81 854.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="541.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(240.1 855.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="541.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(240.38 855.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="542.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(240.67 855.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="542.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(240.96 856.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="542.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(241.25 856.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="543.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(241.54 856.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="543.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(241.83 856.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="543.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(242.12 857.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="543.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(242.4 857.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="544.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(242.69 857.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="544.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(242.98 858.09) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="513.42 342.74 514.52 342.74 514.52 334.47 488.94 334.47 488.94 341.33 488.94 342.74 488.94 349.6 513.42 349.6 513.42 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="511.54"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(854.27 -175.92) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="513.93"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(860.88 -170.19) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="498.23"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(850.72 -154.53) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="492.09"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(865.57 -139.68) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="498.13"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(872.29 -145.52) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="492.7"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(880.03 -126.93) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="493.76"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(880.61 -120.36) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="496.85"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(893.2 -123.1) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M517.5,398.9H504.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,517.5,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="504.81"
        y="394.47"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="498.21 396.27 518.13 396.27 518.13 374.15 516.42 374.15 516.42 354.15 513.47 354.15 513.43 349.62 491.84 349.62 491.84 363.25 489.66 363.25 489.66 373.47 485.13 373.47 485.13 388.09 498.21 388.09 498.21 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="513.51 349.58 491.89 349.58 491.89 363.25 489.75 363.25 489.75 373.43 485.13 373.43 485.13 388.04 510.95 388.04 510.95 384.28 513.51 384.28 513.51 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M513.52,368.48h.81v-7.09h-.78l-.06-11H491.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="496.49"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(859.2 -146.1) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="507.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(869.78 -156.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="506.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(869.49 -156.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="506.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(869.2 -156.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="506.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(868.91 -155.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="505.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(868.62 -155.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="505.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(868.33 -155.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="505.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(868.05 -154.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="505.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(867.76 -154.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="504.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(867.47 -154.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="504.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(867.18 -154.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="504.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(866.89 -153.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="503.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(866.6 -153.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="503.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(866.31 -153.19) rotate(90)"
        fill="#808184"
      />
      <rect
        x="503.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(866.03 -152.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="503.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(865.74 -152.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="502.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(865.45 -152.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="502.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(865.16 -152.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="502.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(864.87 -151.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="501.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(864.58 -151.46) rotate(90)"
        fill="#808184"
      />
      <rect
        x="501.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(864.29 -151.17) rotate(90)"
        fill="#808184"
      />
      <rect
        x="501.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(864.01 -150.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="501.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(863.72 -150.59) rotate(90)"
        fill="#808184"
      />
      <rect
        x="500.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(863.43 -150.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="500.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(863.14 -150.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="500.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(862.85 -149.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="499.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(862.56 -149.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="499.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(862.28 -149.15) rotate(90)"
        fill="#808184"
      />
      <rect
        x="499.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(861.99 -148.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="499.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(861.7 -148.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="498.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(861.41 -148.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="498.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(861.12 -147.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="498.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(860.83 -147.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="497.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(860.54 -147.42) rotate(90)"
        fill="#808184"
      />
      <rect
        x="497.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(860.26 -147.13) rotate(90)"
        fill="#808184"
      />
      <rect
        x="497.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(859.97 -146.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="497.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(859.68 -146.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="496.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(859.39 -146.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="496.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(859.1 -145.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="496.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(858.81 -145.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="495.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(858.52 -145.4) rotate(90)"
        fill="#808184"
      />
      <rect
        x="495.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(858.24 -145.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="495.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(857.95 -144.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="495.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(857.66 -144.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="494.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(857.37 -144.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="494.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(857.08 -143.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="494.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(856.79 -143.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="493.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(856.5 -143.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="493.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(856.22 -143.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="493.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(855.93 -142.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="492.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(855.64 -142.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="492.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(855.35 -142.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="492.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(855.06 -141.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="492.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(854.77 -141.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="491.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(854.49 -141.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="491.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(854.2 -141.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="491.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(853.91 -140.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="490.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(853.62 -140.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="490.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(853.33 -140.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="490.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(853.04 -139.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="490.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(852.75 -139.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="489.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(852.47 -139.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="489.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(852.18 -139.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="489.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(851.89 -138.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="488.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(851.6 -138.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="488.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(851.31 -138.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="488.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(851.02 -137.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="488.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(850.73 -137.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="487.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(850.45 -137.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="487.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(850.16 -137.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="487.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(849.87 -136.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="486.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(849.58 -136.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="486.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(849.29 -136.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="486.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(849 -135.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="486.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(848.72 -135.59) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="529.27 342.74 528.17 342.74 528.17 334.47 553.75 334.47 553.75 341.33 553.75 342.74 553.75 349.6 529.27 349.6 529.27 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="524.04"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(866.77 -188.42) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="525.55"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(872.5 -181.8) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="535.67"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(888.16 -191.97) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="529.53"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(903.01 -177.12) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="523.01"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(897.17 -170.4) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="528.43"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(915.76 -162.66) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="535.47"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(922.32 -162.08) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="523.24"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(919.59 -149.49) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M525.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,525.19,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="525.16"
        y="394.47"
        width="12.72"
        height="5.41"
        transform="translate(1063.04 794.35) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="544.48 396.27 524.56 396.27 524.56 374.15 526.27 374.15 526.27 354.15 529.22 354.15 529.26 349.62 550.85 349.62 550.85 363.25 553.03 363.25 553.03 373.47 557.56 373.47 557.56 388.09 544.48 388.09 544.48 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="529.18 349.58 550.8 349.58 550.8 363.25 552.94 363.25 552.94 373.43 557.56 373.43 557.56 388.04 531.74 388.04 531.74 384.28 529.18 384.28 529.18 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M529.17,376h24V363.22H551V350.4H529.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="533.88"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(896.59 -183.49) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="523.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(886.04 -172.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="523.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(886.33 -173.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="523.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(886.62 -173.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="524.25"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(886.91 -173.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="524.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(887.19 -174.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="524.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(887.48 -174.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="525.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(887.77 -174.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="525.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(888.06 -174.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="525.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(888.35 -175.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="525.98"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(888.64 -175.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="526.27"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(888.93 -175.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="526.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(889.21 -176.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="526.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(889.5 -176.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="527.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(889.79 -176.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="527.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(890.08 -176.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="527.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(890.37 -177.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="528"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(890.66 -177.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="528.29"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(890.94 -177.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="528.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(891.23 -178.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="528.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(891.52 -178.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="529.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(891.81 -178.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="529.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(892.1 -178.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="529.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(892.39 -179.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="530.02"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(892.68 -179.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="530.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(892.96 -179.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="530.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(893.25 -180.13) rotate(90)"
        fill="#808184"
      />
      <rect
        x="530.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(893.54 -180.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="531.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(893.83 -180.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="531.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(894.12 -180.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="531.75"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(894.41 -181.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="532.04"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(894.7 -181.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="532.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(894.98 -181.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="532.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(895.27 -182.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="532.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(895.56 -182.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="533.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(895.85 -182.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="533.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(896.14 -183.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="533.77"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(896.43 -183.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="534.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(896.72 -183.59) rotate(90)"
        fill="#808184"
      />
      <rect
        x="534.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(897 -183.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="534.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(897.29 -184.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="534.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(897.58 -184.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="535.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(897.87 -184.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="535.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(898.16 -185.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="535.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(898.45 -185.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="536.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(898.73 -185.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="536.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(899.02 -185.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="536.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(899.31 -186.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="536.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(899.6 -186.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="537.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(899.89 -186.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="537.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(900.18 -187.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="537.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(900.47 -187.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="538.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(900.75 -187.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="538.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(901.04 -187.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="538.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(901.33 -188.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="538.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(901.62 -188.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="539.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(901.91 -188.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="539.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(902.2 -189.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="539.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(902.49 -189.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="540.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(902.77 -189.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="540.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(903.06 -189.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="540.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(903.35 -190.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="540.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(903.64 -190.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="541.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(903.93 -190.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="541.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(904.22 -191.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="541.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(904.5 -191.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="542.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(904.79 -191.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="542.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(905.08 -191.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="542.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(905.37 -192.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="543.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(905.66 -192.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="543.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(905.95 -192.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="543.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(906.24 -193.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="543.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(906.52 -193.4) rotate(90)"
        fill="#808184"
      />
      <rect
        x="544.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(906.81 -193.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="544.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(907.1 -193.97) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="589.42 321.38 590.52 321.38 590.52 329.65 564.94 329.65 564.94 322.79 564.94 321.38 564.94 314.52 589.42 314.52 589.42 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="587.54"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(266.15 916.04) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="589.93"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(272.76 910.31) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="574.23"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(262.6 894.65) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="568.09"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(277.45 879.8) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="574.13"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(284.17 885.64) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="568.7"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(291.91 867.05) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="569.76"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(292.49 860.48) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="572.85"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(305.08 863.22) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M593.5,267.61H580.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,593.5,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="580.81"
        y="266.62"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="574.21 267.85 594.13 267.85 594.13 289.97 592.42 289.97 592.42 309.97 589.47 309.97 589.43 314.5 567.84 314.5 567.84 300.87 565.66 300.87 565.66 290.65 561.13 290.65 561.13 276.03 574.21 276.03 574.21 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="589.51 314.54 567.89 314.54 567.89 300.87 565.75 300.87 565.75 290.69 561.13 290.69 561.13 276.08 586.95 276.08 586.95 279.84 589.51 279.84 589.51 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M589.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H566v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="572.49"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(271.08 886.22) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="583.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(281.66 896.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="582.84"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(281.37 896.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="582.55"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(281.08 896.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="582.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(280.79 895.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="581.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(280.5 895.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="581.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(280.21 895.33) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="581.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(279.93 895.04) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="581.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(279.64 894.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="580.82"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(279.35 894.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="580.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(279.06 894.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="580.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(278.77 893.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="579.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(278.48 893.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="579.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(278.19 893.31) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="579.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(277.91 893.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="579.09"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(277.62 892.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="578.8"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(277.33 892.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="578.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(277.04 892.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="578.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(276.75 891.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="577.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(276.46 891.58) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="577.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(276.17 891.29) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="577.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(275.89 891) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="577.07"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(275.6 890.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="576.78"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(275.31 890.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="576.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(275.02 890.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="576.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(274.73 889.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="575.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(274.44 889.56) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="575.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(274.16 889.27) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="575.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(273.87 888.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="575.05"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(273.58 888.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="574.76"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(273.29 888.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="574.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(273 888.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="574.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(272.71 887.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="573.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(272.42 887.54) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="573.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(272.14 887.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="573.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(271.85 886.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="573.03"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(271.56 886.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="572.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(271.27 886.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="572.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(270.98 886.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="572.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(270.69 885.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="571.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(270.4 885.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="571.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(270.12 885.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="571.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(269.83 884.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="571.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(269.54 884.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="570.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(269.25 884.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="570.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(268.96 884.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="570.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(268.67 883.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="569.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(268.38 883.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="569.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(268.1 883.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="569.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(267.81 882.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="568.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(267.52 882.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="568.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(267.23 882.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="568.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(266.94 882.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="568.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(266.65 881.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="567.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(266.37 881.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="567.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(266.08 881.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="567.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(265.79 880.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="566.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(265.5 880.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="566.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(265.21 880.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="566.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(264.92 880.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="566.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(264.63 879.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="565.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(264.35 879.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="565.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(264.06 879.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="565.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(263.77 878.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="564.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(263.48 878.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="564.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(263.19 878.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="564.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(262.9 878.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="564.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(262.61 877.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="563.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(262.33 877.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="563.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(262.04 877.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="563.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(261.75 876.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="562.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(261.46 876.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="562.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(261.17 876.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="562.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(260.88 876) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="562.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(260.6 875.71) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="605.27 321.38 604.17 321.38 604.17 329.65 629.75 329.65 629.75 322.79 629.75 321.38 629.75 314.52 605.27 314.52 605.27 321.38"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="600.04"
        y="322.89"
        width="7.12"
        height="4.1"
        transform="translate(278.65 928.54) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="601.55"
        y="317.16"
        width="3.21"
        height="3.22"
        transform="translate(284.38 921.92) rotate(-90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="611.67"
        y="305.22"
        width="8.79"
        height="21.61"
        transform="translate(300.04 932.09) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="605.53"
        y="290.37"
        width="21.06"
        height="21.61"
        transform="translate(314.89 917.24) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="599.01"
        y="289.93"
        width="21.55"
        height="21.61"
        transform="translate(309.05 910.52) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="604.43"
        y="276.77"
        width="21.55"
        height="21.61"
        transform="translate(327.64 902.78) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="611.47"
        y="273.19"
        width="13.46"
        height="21.61"
        transform="translate(334.2 902.2) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="599.24"
        y="269.16"
        width="22.6"
        height="19.83"
        transform="translate(331.47 889.61) rotate(-90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M601.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,601.19,267.61Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="601.16"
        y="266.62"
        width="12.72"
        height="5.41"
        transform="translate(1215.04 538.66) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="620.48 267.85 600.56 267.85 600.56 289.97 602.27 289.97 602.27 309.97 605.22 309.97 605.26 314.5 626.85 314.5 626.85 300.87 629.03 300.87 629.03 290.65 633.56 290.65 633.56 276.03 620.48 276.03 620.48 267.85"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="605.18 314.54 626.8 314.54 626.8 300.87 628.94 300.87 628.94 290.69 633.56 290.69 633.56 276.08 607.74 276.08 607.74 279.84 605.18 279.84 605.18 314.54"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M605.17,295.64h-.81v7.09h.78l.06,11H627V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="609.88"
        y="296.67"
        width="12.31"
        height="21.78"
        transform="translate(308.47 923.61) rotate(-90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="599.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(297.92 913.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="599.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(298.21 913.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="599.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(298.5 913.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="600.25"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(298.79 913.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="600.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(299.07 914.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="600.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(299.36 914.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="601.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(299.65 914.76) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="601.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(299.94 915.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="601.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(300.23 915.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="601.98"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(300.52 915.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="602.27"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(300.81 915.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="602.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(301.09 916.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="602.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(301.38 916.49) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="603.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(301.67 916.78) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="603.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(301.96 917.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="603.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(302.25 917.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="604"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(302.54 917.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="604.29"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(302.83 917.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="604.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(303.11 918.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="604.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(303.4 918.51) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="605.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(303.69 918.8) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="605.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(303.98 919.09) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="605.74"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(304.27 919.38) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="606.02"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(304.56 919.67) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="606.31"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(304.84 919.96) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="606.6"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(305.13 920.25) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="606.89"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(305.42 920.53) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="607.18"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(305.71 920.82) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="607.47"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(306 921.11) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="607.75"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(306.29 921.4) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="608.04"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(306.58 921.69) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="608.33"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(306.86 921.98) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="608.62"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(307.15 922.26) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="608.91"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(307.44 922.55) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="609.2"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(307.73 922.84) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="609.49"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(308.02 923.13) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="609.77"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(308.31 923.42) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="610.06"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(308.6 923.71) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="610.35"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(308.88 924) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="610.64"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(309.17 924.28) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="610.93"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(309.46 924.57) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="611.22"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(309.75 924.86) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="611.51"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(310.04 925.15) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="611.79"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(310.33 925.44) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="612.08"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(310.61 925.73) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="612.37"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(310.9 926.02) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="612.66"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(311.19 926.3) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="612.95"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(311.48 926.59) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="613.24"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(311.77 926.88) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="613.53"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(312.06 927.17) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="613.81"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(312.35 927.46) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="614.1"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(312.63 927.75) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="614.39"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(312.92 928.03) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="614.68"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(313.21 928.32) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="614.97"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(313.5 928.61) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="615.26"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(313.79 928.9) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="615.54"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(314.08 929.19) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="615.83"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(314.37 929.48) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="616.12"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(314.65 929.77) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="616.41"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(314.94 930.05) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="616.7"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(315.23 930.34) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="616.99"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(315.52 930.63) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="617.28"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(315.81 930.92) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="617.56"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(316.1 931.21) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="617.85"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(316.38 931.5) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="618.14"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(316.67 931.79) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="618.43"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(316.96 932.07) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="618.72"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(317.25 932.36) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="619.01"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(317.54 932.65) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="619.3"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(317.83 932.94) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="619.58"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(318.12 933.23) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="619.87"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(318.4 933.52) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="620.16"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(318.69 933.81) rotate(-90)"
        fill="#808184"
      />
      <rect
        x="620.45"
        y="307.49"
        width="12.18"
        height="0.12"
        transform="translate(318.98 934.09) rotate(-90)"
        fill="#808184"
      />
      <polygon
        points="589.42 342.74 590.52 342.74 590.52 334.47 564.94 334.47 564.94 341.33 564.94 342.74 564.94 349.6 589.42 349.6 589.42 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="587.54"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(930.27 -251.92) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="589.93"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(936.88 -246.19) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="574.23"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(926.72 -230.53) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="568.09"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(941.57 -215.68) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="574.13"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(948.29 -221.52) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="568.7"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(956.03 -202.93) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="569.76"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(956.61 -196.36) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="572.85"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(969.2 -199.1) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M593.5,398.9H580.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,593.5,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="580.81"
        y="394.47"
        width="12.72"
        height="5.41"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="574.21 396.27 594.13 396.27 594.13 374.15 592.42 374.15 592.42 354.15 589.47 354.15 589.43 349.62 567.84 349.62 567.84 363.25 565.66 363.25 565.66 373.47 561.13 373.47 561.13 388.09 574.21 388.09 574.21 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="589.51 349.58 567.89 349.58 567.89 363.25 565.75 363.25 565.75 373.43 561.13 373.43 561.13 388.04 586.95 388.04 586.95 384.28 589.51 384.28 589.51 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M589.52,368.48h.81v-7.09h-.78l-.06-11H567.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="572.49"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(935.2 -222.1) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="583.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(945.78 -232.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="582.84"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(945.49 -232.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="582.55"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(945.2 -232.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="582.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(944.91 -231.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="581.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(944.62 -231.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="581.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(944.33 -231.21) rotate(90)"
        fill="#808184"
      />
      <rect
        x="581.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(944.05 -230.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="581.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(943.76 -230.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="580.82"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(943.47 -230.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="580.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(943.18 -230.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="580.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(942.89 -229.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="579.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(942.6 -229.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="579.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(942.31 -229.19) rotate(90)"
        fill="#808184"
      />
      <rect
        x="579.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(942.03 -228.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="579.09"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(941.74 -228.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="578.8"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(941.45 -228.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="578.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(941.16 -228.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="578.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(940.87 -227.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="577.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(940.58 -227.46) rotate(90)"
        fill="#808184"
      />
      <rect
        x="577.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(940.29 -227.17) rotate(90)"
        fill="#808184"
      />
      <rect
        x="577.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(940.01 -226.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="577.07"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(939.72 -226.59) rotate(90)"
        fill="#808184"
      />
      <rect
        x="576.78"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(939.43 -226.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="576.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(939.14 -226.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="576.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(938.85 -225.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="575.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(938.56 -225.44) rotate(90)"
        fill="#808184"
      />
      <rect
        x="575.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(938.28 -225.15) rotate(90)"
        fill="#808184"
      />
      <rect
        x="575.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(937.99 -224.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="575.05"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(937.7 -224.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="574.76"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(937.41 -224.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="574.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(937.12 -223.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="574.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(936.83 -223.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="573.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(936.54 -223.42) rotate(90)"
        fill="#808184"
      />
      <rect
        x="573.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(936.26 -223.13) rotate(90)"
        fill="#808184"
      />
      <rect
        x="573.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(935.97 -222.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="573.03"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(935.68 -222.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="572.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(935.39 -222.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="572.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(935.1 -221.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="572.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(934.81 -221.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="571.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(934.52 -221.4) rotate(90)"
        fill="#808184"
      />
      <rect
        x="571.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(934.24 -221.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="571.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(933.95 -220.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="571.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(933.66 -220.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="570.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(933.37 -220.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="570.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(933.08 -219.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="570.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(932.79 -219.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="569.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(932.5 -219.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="569.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(932.22 -219.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="569.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(931.93 -218.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="568.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(931.64 -218.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="568.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(931.35 -218.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="568.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(931.06 -217.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="568.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(930.77 -217.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="567.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(930.49 -217.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="567.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(930.2 -217.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="567.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(929.91 -216.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="566.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(929.62 -216.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="566.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(929.33 -216.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="566.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(929.04 -215.92) rotate(90)"
        fill="#808184"
      />
      <rect
        x="566.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(928.75 -215.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="565.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(928.47 -215.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="565.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(928.18 -215.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="565.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(927.89 -214.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="564.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(927.6 -214.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="564.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(927.31 -214.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="564.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(927.02 -213.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="564.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(926.73 -213.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="563.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(926.45 -213.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="563.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(926.16 -213.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="563.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(925.87 -212.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="562.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(925.58 -212.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="562.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(925.29 -212.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="562.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(925 -211.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="562.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(924.72 -211.59) rotate(90)"
        fill="#808184"
      />
      <polygon
        points="605.27 342.74 604.17 342.74 604.17 334.47 629.75 334.47 629.75 341.33 629.75 342.74 629.75 349.6 605.27 349.6 605.27 342.74"
        fill="#aee2fa"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="600.04"
        y="337.13"
        width="7.12"
        height="4.1"
        transform="translate(942.77 -264.42) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="601.55"
        y="343.74"
        width="3.21"
        height="3.22"
        transform="translate(948.5 -257.8) rotate(90)"
        fill="#e0e0de"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="611.67"
        y="337.29"
        width="8.79"
        height="21.61"
        transform="translate(964.16 -267.97) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="605.53"
        y="352.15"
        width="21.06"
        height="21.61"
        transform="translate(979.01 -253.12) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="599.01"
        y="352.58"
        width="21.55"
        height="21.61"
        transform="translate(973.17 -246.4) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="604.43"
        y="365.75"
        width="21.55"
        height="21.61"
        transform="translate(991.76 -238.66) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="611.47"
        y="369.32"
        width="13.46"
        height="21.61"
        transform="translate(998.32 -238.08) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="599.24"
        y="375.13"
        width="22.6"
        height="19.83"
        transform="translate(995.59 -225.49) rotate(90)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M601.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,601.19,398.9Z"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="601.16"
        y="394.47"
        width="12.72"
        height="5.41"
        transform="translate(1215.04 794.35) rotate(-180)"
        fill="#838484"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="620.48 396.27 600.56 396.27 600.56 374.15 602.27 374.15 602.27 354.15 605.22 354.15 605.26 349.62 626.85 349.62 626.85 363.25 629.03 363.25 629.03 373.47 633.56 373.47 633.56 388.09 620.48 388.09 620.48 396.27"
        fill="#a7a9ac"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <polygon
        points="605.18 349.58 626.8 349.58 626.8 363.25 628.94 363.25 628.94 373.43 633.56 373.43 633.56 388.04 607.74 388.04 607.74 384.28 605.18 384.28 605.18 349.58"
        fill="#c5c6c8"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <path
        d="M605.17,376h24V363.22H627V350.4H605.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z"
        fill="#e6e7e7"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="609.88"
        y="345.66"
        width="12.31"
        height="21.78"
        transform="translate(972.59 -259.49) rotate(90)"
        fill="#6e6f71"
        stroke="#808184"
        stroke-miterlimit="10"
        stroke-width="0.13"
      />
      <rect
        x="599.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(962.04 -248.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="599.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(962.33 -249.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="599.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(962.62 -249.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="600.25"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(962.91 -249.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="600.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(963.19 -250.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="600.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(963.48 -250.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="601.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(963.77 -250.64) rotate(90)"
        fill="#808184"
      />
      <rect
        x="601.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(964.06 -250.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="601.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(964.35 -251.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="601.98"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(964.64 -251.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="602.27"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(964.93 -251.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="602.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(965.21 -252.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="602.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(965.5 -252.37) rotate(90)"
        fill="#808184"
      />
      <rect
        x="603.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(965.79 -252.66) rotate(90)"
        fill="#808184"
      />
      <rect
        x="603.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(966.08 -252.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="603.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(966.37 -253.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="604"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(966.66 -253.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="604.29"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(966.94 -253.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="604.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(967.23 -254.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="604.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(967.52 -254.39) rotate(90)"
        fill="#808184"
      />
      <rect
        x="605.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(967.81 -254.68) rotate(90)"
        fill="#808184"
      />
      <rect
        x="605.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(968.1 -254.97) rotate(90)"
        fill="#808184"
      />
      <rect
        x="605.74"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(968.39 -255.26) rotate(90)"
        fill="#808184"
      />
      <rect
        x="606.02"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(968.68 -255.55) rotate(90)"
        fill="#808184"
      />
      <rect
        x="606.31"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(968.96 -255.84) rotate(90)"
        fill="#808184"
      />
      <rect
        x="606.6"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(969.25 -256.13) rotate(90)"
        fill="#808184"
      />
      <rect
        x="606.89"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(969.54 -256.41) rotate(90)"
        fill="#808184"
      />
      <rect
        x="607.18"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(969.83 -256.7) rotate(90)"
        fill="#808184"
      />
      <rect
        x="607.47"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(970.12 -256.99) rotate(90)"
        fill="#808184"
      />
      <rect
        x="607.75"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(970.41 -257.28) rotate(90)"
        fill="#808184"
      />
      <rect
        x="608.04"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(970.7 -257.57) rotate(90)"
        fill="#808184"
      />
      <rect
        x="608.33"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(970.98 -257.86) rotate(90)"
        fill="#808184"
      />
      <rect
        x="608.62"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(971.27 -258.14) rotate(90)"
        fill="#808184"
      />
      <rect
        x="608.91"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(971.56 -258.43) rotate(90)"
        fill="#808184"
      />
      <rect
        x="609.2"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(971.85 -258.72) rotate(90)"
        fill="#808184"
      />
      <rect
        x="609.49"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(972.14 -259.01) rotate(90)"
        fill="#808184"
      />
      <rect
        x="609.77"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(972.43 -259.3) rotate(90)"
        fill="#808184"
      />
      <rect
        x="610.06"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(972.72 -259.59) rotate(90)"
        fill="#808184"
      />
      <rect
        x="610.35"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(973 -259.88) rotate(90)"
        fill="#808184"
      />
      <rect
        x="610.64"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(973.29 -260.16) rotate(90)"
        fill="#808184"
      />
      <rect
        x="610.93"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(973.58 -260.45) rotate(90)"
        fill="#808184"
      />
      <rect
        x="611.22"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(973.87 -260.74) rotate(90)"
        fill="#808184"
      />
      <rect
        x="611.51"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(974.16 -261.03) rotate(90)"
        fill="#808184"
      />
      <rect
        x="611.79"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(974.45 -261.32) rotate(90)"
        fill="#808184"
      />
      <rect
        x="612.08"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(974.73 -261.61) rotate(90)"
        fill="#808184"
      />
      <rect
        x="612.37"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(975.02 -261.9) rotate(90)"
        fill="#808184"
      />
      <rect
        x="612.66"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(975.31 -262.18) rotate(90)"
        fill="#808184"
      />
      <rect
        x="612.95"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(975.6 -262.47) rotate(90)"
        fill="#808184"
      />
      <rect
        x="613.24"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(975.89 -262.76) rotate(90)"
        fill="#808184"
      />
      <rect
        x="613.53"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(976.18 -263.05) rotate(90)"
        fill="#808184"
      />
      <rect
        x="613.81"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(976.47 -263.34) rotate(90)"
        fill="#808184"
      />
      <rect
        x="614.1"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(976.75 -263.63) rotate(90)"
        fill="#808184"
      />
      <rect
        x="614.39"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(977.04 -263.91) rotate(90)"
        fill="#808184"
      />
      <rect
        x="614.68"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(977.33 -264.2) rotate(90)"
        fill="#808184"
      />
      <rect
        x="614.97"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(977.62 -264.49) rotate(90)"
        fill="#808184"
      />
      <rect
        x="615.26"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(977.91 -264.78) rotate(90)"
        fill="#808184"
      />
      <rect
        x="615.54"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(978.2 -265.07) rotate(90)"
        fill="#808184"
      />
      <rect
        x="615.83"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(978.49 -265.36) rotate(90)"
        fill="#808184"
      />
      <rect
        x="616.12"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(978.77 -265.65) rotate(90)"
        fill="#808184"
      />
      <rect
        x="616.41"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(979.06 -265.93) rotate(90)"
        fill="#808184"
      />
      <rect
        x="616.7"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(979.35 -266.22) rotate(90)"
        fill="#808184"
      />
      <rect
        x="616.99"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(979.64 -266.51) rotate(90)"
        fill="#808184"
      />
      <rect
        x="617.28"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(979.93 -266.8) rotate(90)"
        fill="#808184"
      />
      <rect
        x="617.56"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(980.22 -267.09) rotate(90)"
        fill="#808184"
      />
      <rect
        x="617.85"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(980.5 -267.38) rotate(90)"
        fill="#808184"
      />
      <rect
        x="618.14"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(980.79 -267.67) rotate(90)"
        fill="#808184"
      />
      <rect
        x="618.43"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(981.08 -267.95) rotate(90)"
        fill="#808184"
      />
      <rect
        x="618.72"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(981.37 -268.24) rotate(90)"
        fill="#808184"
      />
      <rect
        x="619.01"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(981.66 -268.53) rotate(90)"
        fill="#808184"
      />
      <rect
        x="619.3"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(981.95 -268.82) rotate(90)"
        fill="#808184"
      />
      <rect
        x="619.58"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(982.24 -269.11) rotate(90)"
        fill="#808184"
      />
      <rect
        x="619.87"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(982.52 -269.4) rotate(90)"
        fill="#808184"
      />
      <rect
        x="620.16"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(982.81 -269.69) rotate(90)"
        fill="#808184"
      />
      <rect
        x="620.45"
        y="356.5"
        width="12.18"
        height="0.12"
        transform="translate(983.1 -269.97) rotate(90)"
        fill="#808184"
      />
      <text
        transform="translate(381.55 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V14
        </tspan>
      </text>
      <text
        transform="translate(418.88 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V16
        </tspan>
      </text>
      <text
        transform="translate(459.55 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V18
        </tspan>
      </text>
      <text
        transform="translate(496.05 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V20
        </tspan>
      </text>
      <text
        transform="translate(536.05 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V22
        </tspan>
      </text>
      <text
        transform="translate(571.55 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V24
        </tspan>
      </text>
      <text
        transform="translate(612.05 287.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V26
        </tspan>
      </text>
      <text
        transform="translate(418.88 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V15
        </tspan>
      </text>
      <text
        transform="translate(459.55 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V17
        </tspan>
      </text>
      <text
        transform="translate(495.05 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V19
        </tspan>
      </text>
      <text
        transform="translate(536.05 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V21
        </tspan>
      </text>
      <text
        transform="translate(571.55 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V23
        </tspan>
      </text>
      <text
        transform="translate(612.05 373.05)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="0" y="9.6">
          V25
        </tspan>
      </text>
    </g>
    <g id="Townhomes" data-name="Townhomes">
      <rect
        x="344.71"
        y="128"
        width="103"
        height="116.16"
        fill="#b3d337"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.23"
        stroke-dasharray="12"
      />
      <rect
        x="447.71"
        y="186.08"
        width="51.5"
        height="58.08"
        fill="#b3d337"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.23"
        stroke-dasharray="12"
      />
      <line
        x1="345.1"
        y1="187.36"
        x2="551.5"
        y2="187.36"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="370.94"
        y1="243.94"
        x2="370.94"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="396.77"
        y1="243.94"
        x2="396.77"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="422.61"
        y1="243.94"
        x2="422.61"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="448.44"
        y1="243.94"
        x2="448.44"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="474.27"
        y1="243.94"
        x2="474.27"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="500.27"
        y1="243.94"
        x2="500.27"
        y2="130.55"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <line
        x1="551.27"
        y1="243.94"
        x2="551.27"
        y2="187.38"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="0.68"
      />
      <rect
        x="376.65"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(585.89 -176.25) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="368.83"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(612.8 -147.01) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="387.27 236.91 391.18 236.91 391.18 226.05 387.27 226.05 387.27 206.07 373.6 206.07 373.6 208.06 371.2 208.06 371.2 233.86 372.58 233.86 372.58 242.53 387.27 242.53 387.27 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M387.28,226.08s0-18,0-18h-8.15v-2h-5.49v2h-2.45v25.73h1.41V237h18.65v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="368.25"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(599.19 -159.25) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="379.17"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(579.58 -187.67) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M387.32,227.68l0-21.86H373.65v2.08h-2.46V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="371.16"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(571.14 -179.26) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="391.35"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(599.48 -187.08) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="376.29"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(595.91 -170.55) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="380.11"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(599.69 -174.34) rotate(90)"
        fill="#808083"
      />
      <rect
        x="379.78"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(599.37 -174.01) rotate(90)"
        fill="#808083"
      />
      <rect
        x="379.46"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(599.04 -173.69) rotate(90)"
        fill="#808083"
      />
      <rect
        x="379.13"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(598.71 -173.36) rotate(90)"
        fill="#808083"
      />
      <rect
        x="378.81"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(598.39 -173.03) rotate(90)"
        fill="#808083"
      />
      <rect
        x="378.48"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(598.06 -172.71) rotate(90)"
        fill="#808083"
      />
      <rect
        x="378.15"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(597.74 -172.38) rotate(90)"
        fill="#808083"
      />
      <rect
        x="377.83"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(597.41 -172.06) rotate(90)"
        fill="#808083"
      />
      <rect
        x="377.5"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(597.09 -171.73) rotate(90)"
        fill="#808083"
      />
      <rect
        x="377.18"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(596.76 -171.41) rotate(90)"
        fill="#808083"
      />
      <rect
        x="376.85"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(596.44 -171.08) rotate(90)"
        fill="#808083"
      />
      <rect
        x="376.53"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(596.11 -170.76) rotate(90)"
        fill="#808083"
      />
      <rect
        x="376.2"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(595.78 -170.43) rotate(90)"
        fill="#808083"
      />
      <rect
        x="375.88"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(595.46 -170.1) rotate(90)"
        fill="#808083"
      />
      <rect
        x="375.55"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(595.13 -169.78) rotate(90)"
        fill="#808083"
      />
      <rect
        x="375.22"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(594.81 -169.45) rotate(90)"
        fill="#808083"
      />
      <rect
        x="374.9"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(594.48 -169.13) rotate(90)"
        fill="#808083"
      />
      <rect
        x="374.57"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(594.16 -168.8) rotate(90)"
        fill="#808083"
      />
      <rect
        x="374.25"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(593.83 -168.48) rotate(90)"
        fill="#808083"
      />
      <rect
        x="373.92"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(593.5 -168.15) rotate(90)"
        fill="#808083"
      />
      <rect
        x="373.6"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(593.18 -167.83) rotate(90)"
        fill="#808083"
      />
      <rect
        x="373.27"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(592.85 -167.5) rotate(90)"
        fill="#808083"
      />
      <rect
        x="372.95"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(592.53 -167.17) rotate(90)"
        fill="#808083"
      />
      <rect
        x="372.62"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(592.2 -166.85) rotate(90)"
        fill="#808083"
      />
      <path
        d="M389,246.65a3.56,3.56,0,0,1-1.81-3.27H372.62c-.09,1.48,0,2.72-1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="356.13"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(565.37 -155.72) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="350.63"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(594.61 -128.81) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="354.35 236.91 350.44 236.91 350.44 226.05 354.35 226.05 354.35 206.07 368.02 206.07 368.02 208.06 370.41 208.06 370.41 233.86 369.04 233.86 369.04 242.53 354.35 242.53 354.35 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M354.33,226.08s0-18,0-18h8.15v-2H368v2h2.45v25.73H369V237H350.37v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="351.42"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(582.36 -142.43) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="353.54"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(553.95 -162.04) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M368,227.68V227h2.46V207.9H368v-2.08H354.34l0,21.86Zm-4-2.32H355v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="362.37"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(562.35 -170.48) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="346.41"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(554.54 -142.14) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="351.45"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(571.07 -145.71) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="347.7"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(567.28 -141.93) rotate(90)"
        fill="#808083"
      />
      <rect
        x="348.02"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(567.61 -142.25) rotate(90)"
        fill="#808083"
      />
      <rect
        x="348.35"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(567.93 -142.58) rotate(90)"
        fill="#808083"
      />
      <rect
        x="348.68"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(568.26 -142.9) rotate(90)"
        fill="#808083"
      />
      <rect
        x="349"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(568.58 -143.23) rotate(90)"
        fill="#808083"
      />
      <rect
        x="349.33"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(568.91 -143.56) rotate(90)"
        fill="#808083"
      />
      <rect
        x="349.65"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(569.23 -143.88) rotate(90)"
        fill="#808083"
      />
      <rect
        x="349.98"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(569.56 -144.21) rotate(90)"
        fill="#808083"
      />
      <rect
        x="350.3"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(569.89 -144.53) rotate(90)"
        fill="#808083"
      />
      <rect
        x="350.63"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(570.21 -144.86) rotate(90)"
        fill="#808083"
      />
      <rect
        x="350.95"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(570.54 -145.18) rotate(90)"
        fill="#808083"
      />
      <rect
        x="351.28"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(570.86 -145.51) rotate(90)"
        fill="#808083"
      />
      <rect
        x="351.61"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(571.19 -145.83) rotate(90)"
        fill="#808083"
      />
      <rect
        x="351.93"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(571.51 -146.16) rotate(90)"
        fill="#808083"
      />
      <rect
        x="352.26"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(571.84 -146.49) rotate(90)"
        fill="#808083"
      />
      <rect
        x="352.58"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(572.16 -146.81) rotate(90)"
        fill="#808083"
      />
      <rect
        x="352.91"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(572.49 -147.14) rotate(90)"
        fill="#808083"
      />
      <rect
        x="353.23"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(572.82 -147.46) rotate(90)"
        fill="#808083"
      />
      <rect
        x="353.56"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(573.14 -147.79) rotate(90)"
        fill="#808083"
      />
      <rect
        x="353.88"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(573.47 -148.11) rotate(90)"
        fill="#808083"
      />
      <rect
        x="354.21"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(573.79 -148.44) rotate(90)"
        fill="#808083"
      />
      <rect
        x="354.54"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(574.12 -148.76) rotate(90)"
        fill="#808083"
      />
      <rect
        x="354.86"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(574.44 -149.09) rotate(90)"
        fill="#808083"
      />
      <rect
        x="355.19"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(574.77 -149.42) rotate(90)"
        fill="#808083"
      />
      <path
        d="M352.62,246.65a3.56,3.56,0,0,0,1.81-3.27H369c.09,1.48,0,2.72,1.06,3.27Z"
        fill="#838383"
      />
      <rect
        x="428.37"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(637.61 -227.96) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="420.54"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(664.51 -198.72) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="438.99 236.91 442.89 236.91 442.89 226.05 438.99 226.05 438.99 206.07 425.31 206.07 425.31 208.06 422.92 208.06 422.92 233.86 424.29 233.86 424.29 242.53 438.99 242.53 438.99 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M439,226.08s0-18,0-18h-8.15v-2h-5.5v2H422.9v25.73h1.41V237H443v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="419.96"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(650.9 -210.97) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="430.88"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(631.29 -239.38) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M439,227.68l0-21.86H425.36v2.08H422.9V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="422.87"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(622.85 -230.98) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="443.06"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(651.19 -238.79) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="428"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(647.62 -222.26) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="431.82"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(651.4 -226.05) rotate(90)"
        fill="#808083"
      />
      <rect
        x="431.49"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(651.08 -225.72) rotate(90)"
        fill="#808083"
      />
      <rect
        x="431.17"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(650.75 -225.4) rotate(90)"
        fill="#808083"
      />
      <rect
        x="430.84"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(650.43 -225.07) rotate(90)"
        fill="#808083"
      />
      <rect
        x="430.52"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(650.1 -224.75) rotate(90)"
        fill="#808083"
      />
      <rect
        x="430.19"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(649.77 -224.42) rotate(90)"
        fill="#808083"
      />
      <rect
        x="429.87"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(649.45 -224.1) rotate(90)"
        fill="#808083"
      />
      <rect
        x="429.54"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(649.12 -223.77) rotate(90)"
        fill="#808083"
      />
      <rect
        x="429.22"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(648.8 -223.44) rotate(90)"
        fill="#808083"
      />
      <rect
        x="428.89"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(648.47 -223.12) rotate(90)"
        fill="#808083"
      />
      <rect
        x="428.56"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(648.15 -222.79) rotate(90)"
        fill="#808083"
      />
      <rect
        x="428.24"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(647.82 -222.47) rotate(90)"
        fill="#808083"
      />
      <rect
        x="427.91"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(647.5 -222.14) rotate(90)"
        fill="#808083"
      />
      <rect
        x="427.59"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(647.17 -221.82) rotate(90)"
        fill="#808083"
      />
      <rect
        x="427.26"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(646.84 -221.49) rotate(90)"
        fill="#808083"
      />
      <rect
        x="426.94"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(646.52 -221.17) rotate(90)"
        fill="#808083"
      />
      <rect
        x="426.61"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(646.19 -220.84) rotate(90)"
        fill="#808083"
      />
      <rect
        x="426.29"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(645.87 -220.51) rotate(90)"
        fill="#808083"
      />
      <rect
        x="425.96"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(645.54 -220.19) rotate(90)"
        fill="#808083"
      />
      <rect
        x="425.63"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(645.22 -219.86) rotate(90)"
        fill="#808083"
      />
      <rect
        x="425.31"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(644.89 -219.54) rotate(90)"
        fill="#808083"
      />
      <rect
        x="424.98"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(644.57 -219.21) rotate(90)"
        fill="#808083"
      />
      <rect
        x="424.66"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(644.24 -218.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="424.33"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(643.91 -218.56) rotate(90)"
        fill="#808083"
      />
      <path
        d="M440.71,246.65a3.56,3.56,0,0,1-1.81-3.27H424.33c-.09,1.48,0,2.72-1.06,3.27Z"
        fill="#838383"
      />
      <rect
        x="407.84"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(617.08 -207.43) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="402.34"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(646.32 -180.53) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="406.06 236.91 402.15 236.91 402.15 226.05 406.06 226.05 406.06 206.07 419.73 206.07 419.73 208.06 422.13 208.06 422.13 233.86 420.75 233.86 420.75 242.53 406.06 242.53 406.06 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M406.05,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H402.08v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="403.13"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(634.08 -194.14) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="405.25"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(605.66 -213.75) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M419.68,227.68V227h2.46V207.9h-2.46v-2.08H406.05l0,21.86Zm-4-2.32H406.7v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="414.08"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(614.06 -222.19) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="398.12"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(606.25 -193.85) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="403.16"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(622.78 -197.42) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="399.41"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(618.99 -193.64) rotate(90)"
        fill="#808083"
      />
      <rect
        x="399.74"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(619.32 -193.96) rotate(90)"
        fill="#808083"
      />
      <rect
        x="400.06"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(619.64 -194.29) rotate(90)"
        fill="#808083"
      />
      <rect
        x="400.39"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(619.97 -194.62) rotate(90)"
        fill="#808083"
      />
      <rect
        x="400.71"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(620.3 -194.94) rotate(90)"
        fill="#808083"
      />
      <rect
        x="401.04"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(620.62 -195.27) rotate(90)"
        fill="#808083"
      />
      <rect
        x="401.36"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(620.95 -195.59) rotate(90)"
        fill="#808083"
      />
      <rect
        x="401.69"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(621.27 -195.92) rotate(90)"
        fill="#808083"
      />
      <rect
        x="402.01"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(621.6 -196.24) rotate(90)"
        fill="#808083"
      />
      <rect
        x="402.34"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(621.92 -196.57) rotate(90)"
        fill="#808083"
      />
      <rect
        x="402.67"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(622.25 -196.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="402.99"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(622.57 -197.22) rotate(90)"
        fill="#808083"
      />
      <rect
        x="403.32"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(622.9 -197.55) rotate(90)"
        fill="#808083"
      />
      <rect
        x="403.64"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(623.23 -197.87) rotate(90)"
        fill="#808083"
      />
      <rect
        x="403.97"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(623.55 -198.2) rotate(90)"
        fill="#808083"
      />
      <rect
        x="404.29"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(623.88 -198.52) rotate(90)"
        fill="#808083"
      />
      <rect
        x="404.62"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(624.2 -198.85) rotate(90)"
        fill="#808083"
      />
      <rect
        x="404.94"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(624.53 -199.17) rotate(90)"
        fill="#808083"
      />
      <rect
        x="405.27"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(624.85 -199.5) rotate(90)"
        fill="#808083"
      />
      <rect
        x="405.6"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(625.18 -199.82) rotate(90)"
        fill="#808083"
      />
      <rect
        x="405.92"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(625.5 -200.15) rotate(90)"
        fill="#808083"
      />
      <rect
        x="406.25"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(625.83 -200.48) rotate(90)"
        fill="#808083"
      />
      <rect
        x="406.57"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(626.16 -200.8) rotate(90)"
        fill="#808083"
      />
      <rect
        x="406.9"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(626.48 -201.13) rotate(90)"
        fill="#808083"
      />
      <path
        d="M404.33,246.65a3.56,3.56,0,0,0,1.81-3.27h14.57c.09,1.48,0,2.72,1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="480.08"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(689.32 -279.67) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="472.25"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(716.23 -250.43) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="490.7 236.91 494.6 236.91 494.6 226.05 490.7 226.05 490.7 206.07 477.02 206.07 477.02 208.06 474.63 208.06 474.63 233.86 476 233.86 476 242.53 490.7 242.53 490.7 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M490.71,226.08s0-18,0-18h-8.15v-2h-5.5v2h-2.44v25.73H476V237h18.65v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="471.67"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(702.61 -262.68) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="482.59"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(683 -291.1) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M490.74,227.68l0-21.86H477.07v2.08h-2.45V227h2.45v.66Zm-9.64-6.19h8.95v3.87H481.1Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="474.58"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(674.56 -282.69) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="494.78"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(702.91 -290.5) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="479.72"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(699.33 -273.97) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="483.53"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(703.11 -277.76) rotate(90)"
        fill="#808083"
      />
      <rect
        x="483.21"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(702.79 -277.43) rotate(90)"
        fill="#808083"
      />
      <rect
        x="482.88"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(702.46 -277.11) rotate(90)"
        fill="#808083"
      />
      <rect
        x="482.55"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(702.14 -276.78) rotate(90)"
        fill="#808083"
      />
      <rect
        x="482.23"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(701.81 -276.46) rotate(90)"
        fill="#808083"
      />
      <rect
        x="481.9"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(701.49 -276.13) rotate(90)"
        fill="#808083"
      />
      <rect
        x="481.58"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(701.16 -275.81) rotate(90)"
        fill="#808083"
      />
      <rect
        x="481.25"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(700.84 -275.48) rotate(90)"
        fill="#808083"
      />
      <rect
        x="480.93"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(700.51 -275.16) rotate(90)"
        fill="#808083"
      />
      <rect
        x="480.6"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(700.18 -274.83) rotate(90)"
        fill="#808083"
      />
      <rect
        x="480.28"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(699.86 -274.5) rotate(90)"
        fill="#808083"
      />
      <rect
        x="479.95"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(699.53 -274.18) rotate(90)"
        fill="#808083"
      />
      <rect
        x="479.62"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(699.21 -273.85) rotate(90)"
        fill="#808083"
      />
      <rect
        x="479.3"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(698.88 -273.53) rotate(90)"
        fill="#808083"
      />
      <rect
        x="478.97"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(698.56 -273.2) rotate(90)"
        fill="#808083"
      />
      <rect
        x="478.65"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(698.23 -272.88) rotate(90)"
        fill="#808083"
      />
      <rect
        x="478.32"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(697.91 -272.55) rotate(90)"
        fill="#808083"
      />
      <rect
        x="478"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(697.58 -272.23) rotate(90)"
        fill="#808083"
      />
      <rect
        x="477.67"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(697.25 -271.9) rotate(90)"
        fill="#808083"
      />
      <rect
        x="477.35"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(696.93 -271.57) rotate(90)"
        fill="#808083"
      />
      <rect
        x="477.02"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(696.6 -271.25) rotate(90)"
        fill="#808083"
      />
      <rect
        x="476.69"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(696.28 -270.92) rotate(90)"
        fill="#808083"
      />
      <rect
        x="476.37"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(695.95 -270.6) rotate(90)"
        fill="#808083"
      />
      <rect
        x="476.04"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(695.63 -270.27) rotate(90)"
        fill="#808083"
      />
      <path
        d="M492.42,246.65a3.56,3.56,0,0,1-1.81-3.27H476.05c-.1,1.48,0,2.72-1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="459.56"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(668.8 -259.15) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="454.05"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(698.03 -232.24) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="457.77 236.91 453.86 236.91 453.86 226.05 457.77 226.05 457.77 206.07 471.44 206.07 471.44 208.06 473.84 208.06 473.84 233.86 472.46 233.86 472.46 242.53 457.77 242.53 457.77 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M457.76,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H453.79v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="454.85"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(685.79 -245.85) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="456.96"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(657.37 -265.46) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M471.39,227.68V227h2.46V207.9h-2.46v-2.08H457.76l0,21.86Zm-4-2.32h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="465.79"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(665.78 -273.9) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="449.83"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(657.96 -245.56) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="454.87"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(674.49 -249.13) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="451.12"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(670.7 -245.35) rotate(90)"
        fill="#808083"
      />
      <rect
        x="451.45"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(671.03 -245.68) rotate(90)"
        fill="#808083"
      />
      <rect
        x="451.77"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(671.36 -246) rotate(90)"
        fill="#808083"
      />
      <rect
        x="452.1"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(671.68 -246.33) rotate(90)"
        fill="#808083"
      />
      <rect
        x="452.42"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(672.01 -246.65) rotate(90)"
        fill="#808083"
      />
      <rect
        x="452.75"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(672.33 -246.98) rotate(90)"
        fill="#808083"
      />
      <rect
        x="453.08"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(672.66 -247.3) rotate(90)"
        fill="#808083"
      />
      <rect
        x="453.4"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(672.98 -247.63) rotate(90)"
        fill="#808083"
      />
      <rect
        x="453.73"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(673.31 -247.96) rotate(90)"
        fill="#808083"
      />
      <rect
        x="454.05"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(673.63 -248.28) rotate(90)"
        fill="#808083"
      />
      <rect
        x="454.38"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(673.96 -248.61) rotate(90)"
        fill="#808083"
      />
      <rect
        x="454.7"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(674.29 -248.93) rotate(90)"
        fill="#808083"
      />
      <rect
        x="455.03"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(674.61 -249.26) rotate(90)"
        fill="#808083"
      />
      <rect
        x="455.35"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(674.94 -249.58) rotate(90)"
        fill="#808083"
      />
      <rect
        x="455.68"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(675.26 -249.91) rotate(90)"
        fill="#808083"
      />
      <rect
        x="456.01"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(675.59 -250.23) rotate(90)"
        fill="#808083"
      />
      <rect
        x="456.33"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(675.91 -250.56) rotate(90)"
        fill="#808083"
      />
      <rect
        x="456.66"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(676.24 -250.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="456.98"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(676.56 -251.21) rotate(90)"
        fill="#808083"
      />
      <rect
        x="457.31"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(676.89 -251.54) rotate(90)"
        fill="#808083"
      />
      <rect
        x="457.63"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(677.22 -251.86) rotate(90)"
        fill="#808083"
      />
      <rect
        x="457.96"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(677.54 -252.19) rotate(90)"
        fill="#808083"
      />
      <rect
        x="458.28"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(677.87 -252.51) rotate(90)"
        fill="#808083"
      />
      <rect
        x="458.61"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(678.19 -252.84) rotate(90)"
        fill="#808083"
      />
      <path
        d="M456,246.65a3.54,3.54,0,0,0,1.81-3.27h14.57c.09,1.48,0,2.72,1.07,3.27Z"
        fill="#838383"
      />
      {/* <rect
        x="531.79"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(741.03 -331.38) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="523.96"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(767.94 -302.15) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="542.41 236.91 546.32 236.91 546.32 226.05 542.41 226.05 542.41 206.07 528.73 206.07 528.73 208.06 526.34 208.06 526.34 233.86 527.72 233.86 527.72 242.53 542.41 242.53 542.41 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M542.42,226.08s0-18,0-18h-8.15v-2h-5.49v2h-2.45v25.73h1.41V237h18.65v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="523.38"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(754.33 -314.39) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="534.3"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(734.71 -342.81) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M542.46,227.68l-.05-21.86H528.78v2.08h-2.45V227h2.45v.66Zm-9.65-6.19h9v3.87h-9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="526.29"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(726.28 -334.4) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="546.49"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(754.62 -342.21) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="531.43"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(751.05 -325.69) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="535.24"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(754.83 -329.47) rotate(90)"
        fill="#808083"
      />
      <rect
        x="534.92"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(754.5 -329.15) rotate(90)"
        fill="#808083"
      />
      <rect
        x="534.59"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(754.17 -328.82) rotate(90)"
        fill="#808083"
      />
      <rect
        x="534.27"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(753.85 -328.5) rotate(90)"
        fill="#808083"
      />
      <rect
        x="533.94"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(753.52 -328.17) rotate(90)"
        fill="#808083"
      />
      <rect
        x="533.62"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(753.2 -327.84) rotate(90)"
        fill="#808083"
      />
      <rect
        x="533.29"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(752.87 -327.52) rotate(90)"
        fill="#808083"
      />
      <rect
        x="532.96"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(752.55 -327.19) rotate(90)"
        fill="#808083"
      />
      <rect
        x="532.64"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(752.22 -326.87) rotate(90)"
        fill="#808083"
      />
      <rect
        x="532.31"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(751.9 -326.54) rotate(90)"
        fill="#808083"
      />
      <rect
        x="531.99"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(751.57 -326.22) rotate(90)"
        fill="#808083"
      />
      <rect
        x="531.66"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(751.24 -325.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="531.34"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(750.92 -325.57) rotate(90)"
        fill="#808083"
      />
      <rect
        x="531.01"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(750.59 -325.24) rotate(90)"
        fill="#808083"
      />
      <rect
        x="530.69"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(750.27 -324.91) rotate(90)"
        fill="#808083"
      />
      <rect
        x="530.36"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(749.94 -324.59) rotate(90)"
        fill="#808083"
      />
      <rect
        x="530.03"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(749.62 -324.26) rotate(90)"
        fill="#808083"
      />
      <rect
        x="529.71"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(749.29 -323.94) rotate(90)"
        fill="#808083"
      />
      <rect
        x="529.38"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(748.97 -323.61) rotate(90)"
        fill="#808083"
      />
      <rect
        x="529.06"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(748.64 -323.29) rotate(90)"
        fill="#808083"
      />
      <rect
        x="528.73"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(748.31 -322.96) rotate(90)"
        fill="#808083"
      />
      <rect
        x="528.41"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(747.99 -322.63) rotate(90)"
        fill="#808083"
      />
      <rect
        x="528.08"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(747.66 -322.31) rotate(90)"
        fill="#808083"
      />
      <rect
        x="527.76"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(747.34 -321.98) rotate(90)"
        fill="#808083"
      />
      <path
        d="M544.13,246.65a3.57,3.57,0,0,1-1.81-3.27H527.76c-.09,1.48,0,2.72-1.07,3.27Z"
        fill="#838383"
      /> */}
      {/* <rect
        x="511.27"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(720.51 -310.86) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="505.76"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(749.74 -283.95) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="509.48 236.91 505.57 236.91 505.57 226.05 509.48 226.05 509.48 206.07 523.15 206.07 523.15 208.06 525.55 208.06 525.55 233.86 524.17 233.86 524.17 242.53 509.48 242.53 509.48 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M509.47,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H505.5v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="506.56"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(737.5 -297.56) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="508.67"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(709.08 -317.17) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M523.11,227.68V227h2.45V207.9h-2.45v-2.08H509.47l0,21.86Zm-4-2.32h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="517.5"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(717.49 -325.61) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="501.54"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(709.67 -297.27) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="506.58"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(726.2 -300.84) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="502.83"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(722.42 -297.06) rotate(90)"
        fill="#808083"
      />
      <rect
        x="503.16"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(722.74 -297.39) rotate(90)"
        fill="#808083"
      />
      <rect
        x="503.48"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(723.07 -297.71) rotate(90)"
        fill="#808083"
      />
      <rect
        x="503.81"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(723.39 -298.04) rotate(90)"
        fill="#808083"
      />
      <rect
        x="504.14"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(723.72 -298.36) rotate(90)"
        fill="#808083"
      />
      <rect
        x="504.46"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(724.04 -298.69) rotate(90)"
        fill="#808083"
      />
      <rect
        x="504.79"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(724.37 -299.02) rotate(90)"
        fill="#808083"
      />
      <rect
        x="505.11"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(724.7 -299.34) rotate(90)"
        fill="#808083"
      />
      <rect
        x="505.44"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(725.02 -299.67) rotate(90)"
        fill="#808083"
      />
      <rect
        x="505.76"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(725.35 -299.99) rotate(90)"
        fill="#808083"
      />
      <rect
        x="506.09"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(725.67 -300.32) rotate(90)"
        fill="#808083"
      />
      <rect
        x="506.41"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(726 -300.64) rotate(90)"
        fill="#808083"
      />
      <rect
        x="506.74"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(726.32 -300.97) rotate(90)"
        fill="#808083"
      />
      <rect
        x="507.07"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(726.65 -301.29) rotate(90)"
        fill="#808083"
      />
      <rect
        x="507.39"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(726.97 -301.62) rotate(90)"
        fill="#808083"
      />
      <rect
        x="507.72"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(727.3 -301.95) rotate(90)"
        fill="#808083"
      />
      <rect
        x="508.04"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(727.63 -302.27) rotate(90)"
        fill="#808083"
      />
      <rect
        x="508.37"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(727.95 -302.6) rotate(90)"
        fill="#808083"
      />
      <rect
        x="508.69"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(728.28 -302.92) rotate(90)"
        fill="#808083"
      />
      <rect
        x="509.02"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(728.6 -303.25) rotate(90)"
        fill="#808083"
      />
      <rect
        x="509.34"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(728.93 -303.57) rotate(90)"
        fill="#808083"
      />
      <rect
        x="509.67"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(729.25 -303.9) rotate(90)"
        fill="#808083"
      />
      <rect
        x="510"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(729.58 -304.22) rotate(90)"
        fill="#808083"
      />
      <rect
        x="510.32"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(729.9 -304.55) rotate(90)"
        fill="#808083"
      />
      <path
        d="M507.76,246.65a3.57,3.57,0,0,0,1.81-3.27h14.56c.09,1.48,0,2.72,1.07,3.27Z"
        fill="#838383"
      /> */}
      {/* <rect
        x="531.79"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(366.38 706.03) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="523.96"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(393.29 676.79) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="542.41 137.73 546.32 137.73 546.32 148.6 542.41 148.6 542.41 168.58 528.73 168.58 528.73 166.59 526.34 166.59 526.34 140.78 527.72 140.78 527.72 132.12 542.41 132.12 542.41 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M542.42,148.57s0,17.94,0,18h-8.15v2h-5.49v-2.05h-2.45V140.78h1.41v-3.11h18.65v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="523.38"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(379.68 689.04) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="534.3"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(360.07 717.45) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M528.78,147v.65h-2.45v19.13h2.45v2.07h13.63l.05-21.85Zm4,2.32h9v3.87h-9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="526.29"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(351.63 709.05) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="546.49"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(379.97 716.86) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="531.43"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(376.4 700.33) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="535.24"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(380.18 704.12) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="534.92"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(379.85 703.79) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="534.59"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(379.53 703.47) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="534.27"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(379.2 703.14) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="533.94"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(378.88 702.82) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="533.62"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(378.55 702.49) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="533.29"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(378.23 702.16) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="532.96"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(377.9 701.84) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="532.64"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(377.58 701.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="532.31"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(377.25 701.19) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="531.99"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(376.92 700.86) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="531.66"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(376.6 700.54) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="531.34"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(376.27 700.21) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="531.01"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(375.95 699.89) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="530.69"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(375.62 699.56) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="530.36"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(375.3 699.23) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="530.03"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(374.97 698.91) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="529.71"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(374.65 698.58) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="529.38"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(374.32 698.26) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="529.06"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(373.99 697.93) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="528.73"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(373.67 697.61) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="528.41"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(373.34 697.28) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="528.08"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(373.02 696.96) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="527.76"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(372.69 696.63) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M544.13,128a3.56,3.56,0,0,0-1.81,3.27H527.76c-.09-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      /> */}
      {/* <rect
        x="511.27"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(345.86 685.5) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="505.76"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(375.1 658.6) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="509.48 137.73 505.57 137.73 505.57 148.6 509.48 148.6 509.48 168.58 523.15 168.58 523.15 166.59 525.55 166.59 525.55 140.78 524.17 140.78 524.17 132.12 509.48 132.12 509.48 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M509.47,148.57s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.78h-1.41v-3.11H505.5v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="506.56"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(362.85 672.21) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="508.67"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(334.44 691.82) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M509.43,147l0,21.85h13.64v-2.07h2.45V147.62h-2.45V147Zm9.65,6.19h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="517.5"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(342.84 700.26) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="501.54"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(335.03 671.92) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="506.58"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(351.56 675.49) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="502.83"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(347.77 671.71) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="503.16"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(348.1 672.03) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="503.48"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(348.42 672.36) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="503.81"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(348.75 672.69) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="504.14"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(349.07 673.01) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="504.46"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(349.4 673.34) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="504.79"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(349.72 673.66) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="505.11"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(350.05 673.99) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="505.44"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(350.37 674.31) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="505.76"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(350.7 674.64) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="506.09"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(351.03 674.96) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="506.41"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(351.35 675.29) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="506.74"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(351.68 675.62) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="507.07"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(352 675.94) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="507.39"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(352.33 676.27) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="507.72"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(352.65 676.59) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="508.04"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(352.98 676.92) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="508.37"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(353.3 677.24) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="508.69"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(353.63 677.57) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="509.02"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(353.96 677.89) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="509.34"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(354.28 678.22) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="509.67"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(354.61 678.55) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="510"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(354.93 678.87) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="510.32"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(355.26 679.2) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M507.76,128a3.56,3.56,0,0,1,1.81,3.27h14.56c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      /> */}
      <rect
        x="376.65"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(211.25 550.89) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="368.83"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(238.16 521.66) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="387.27 137.73 391.18 137.73 391.18 148.6 387.27 148.6 387.27 168.58 373.6 168.58 373.6 166.59 371.2 166.59 371.2 140.78 372.58 140.78 372.58 132.12 387.27 132.12 387.27 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M387.28,148.57s0,17.94,0,18h-8.15v2h-5.49v-2.05h-2.45V140.78h1.41v-3.11h18.65v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="368.25"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(224.55 533.9) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="379.17"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(204.93 562.32) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M373.65,147v.65h-2.46v19.13h2.46v2.07h13.63l0-21.85Zm4,2.32h8.95v3.87h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="371.16"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(196.5 553.91) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="391.35"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(224.84 561.73) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="376.29"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(221.26 545.2) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="380.11"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(225.04 548.98) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="379.78"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(224.72 548.66) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="379.46"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(224.39 548.33) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="379.13"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(224.07 548.01) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="378.81"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(223.74 547.68) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="378.48"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(223.42 547.36) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="378.15"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(223.09 547.03) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="377.83"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(222.77 546.7) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="377.5"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(222.44 546.38) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="377.18"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(222.11 546.05) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="376.85"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(221.79 545.73) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="376.53"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(221.46 545.4) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="376.2"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(221.14 545.08) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="375.88"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(220.81 544.75) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="375.55"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(220.49 544.42) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="375.22"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(220.16 544.1) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="374.9"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(219.84 543.77) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="374.57"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(219.51 543.45) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="374.25"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(219.18 543.12) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="373.92"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(218.86 542.8) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="373.6"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(218.53 542.47) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="373.27"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(218.21 542.15) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="372.95"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(217.88 541.82) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="372.62"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(217.56 541.49) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M389,128a3.54,3.54,0,0,0-1.81,3.27H372.62c-.09-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="356.13"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(190.73 530.37) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="350.63"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(219.96 503.46) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="354.35 137.73 350.44 137.73 350.44 148.6 354.35 148.6 354.35 168.58 368.02 168.58 368.02 166.59 370.41 166.59 370.41 140.78 369.04 140.78 369.04 132.12 354.35 132.12 354.35 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M354.33,148.57s0,17.94,0,18h8.15v2H368v-2.05h2.45V140.78H369v-3.11H350.37v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="351.42"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(207.72 517.07) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="353.54"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(179.3 536.69) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M354.3,147l0,21.85H368v-2.07h2.46V147.62H368V147Zm9.64,6.19H355v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="362.37"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(187.71 545.12) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="346.41"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(179.89 516.78) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="351.45"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(196.42 520.35) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="347.7"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(192.64 516.57) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="348.02"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(192.96 516.9) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="348.35"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(193.29 517.22) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="348.68"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(193.61 517.55) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="349"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(193.94 517.88) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="349.33"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(194.26 518.2) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="349.65"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(194.59 518.53) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="349.98"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(194.91 518.85) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="350.3"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(195.24 519.18) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="350.63"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(195.57 519.5) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="350.95"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(195.89 519.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="351.28"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(196.22 520.15) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="351.61"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(196.54 520.48) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="351.93"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(196.87 520.81) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="352.26"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(197.19 521.13) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="352.58"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(197.52 521.46) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="352.91"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(197.84 521.78) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="353.23"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(198.17 522.11) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="353.56"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(198.5 522.43) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="353.88"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(198.82 522.76) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="354.21"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(199.15 523.08) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="354.54"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(199.47 523.41) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="354.86"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(199.8 523.74) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="355.19"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(200.12 524.06) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M352.62,128a3.54,3.54,0,0,1,1.81,3.27H369c.09-1.48,0-2.73,1.06-3.27Z"
        fill="#838383"
      />
      <rect
        x="428.37"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(262.96 602.6) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="420.54"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(289.87 573.37) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="438.99 137.73 442.89 137.73 442.89 148.6 438.99 148.6 438.99 168.58 425.31 168.58 425.31 166.59 422.92 166.59 422.92 140.78 424.29 140.78 424.29 132.12 438.99 132.12 438.99 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M439,148.57s0,17.94,0,18h-8.15v2h-5.5v-2.05H422.9V140.78h1.41v-3.11H443v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="419.96"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(276.26 585.61) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="430.88"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(256.64 614.03) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M425.36,147v.65H422.9v19.13h2.46v2.07H439L439,147Zm4,2.32h8.95v3.87h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="422.87"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(248.21 605.62) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="443.06"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(276.55 613.44) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="428"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(272.98 596.91) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="431.82"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(276.76 600.69) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="431.49"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(276.43 600.37) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="431.17"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(276.11 600.04) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="430.84"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(275.78 599.72) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="430.52"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(275.45 599.39) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="430.19"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(275.13 599.07) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="429.87"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(274.8 598.74) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="429.54"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(274.48 598.42) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="429.22"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(274.15 598.09) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="428.89"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(273.83 597.76) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="428.56"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(273.5 597.44) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="428.24"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(273.18 597.11) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="427.91"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(272.85 596.79) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="427.59"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(272.52 596.46) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="427.26"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(272.2 596.14) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="426.94"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(271.87 595.81) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="426.61"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(271.55 595.49) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="426.29"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(271.22 595.16) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="425.96"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(270.9 594.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="425.63"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(270.57 594.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="425.31"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(270.25 594.18) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="424.98"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(269.92 593.86) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="424.66"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(269.59 593.53) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="424.33"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(269.27 593.21) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M440.71,128a3.54,3.54,0,0,0-1.81,3.27H424.33c-.09-1.48,0-2.73-1.06-3.27Z"
        fill="#838383"
      />
      <rect
        x="407.84"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(242.44 582.08) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="402.34"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(271.67 555.17) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="406.06 137.73 402.15 137.73 402.15 148.6 406.06 148.6 406.06 168.58 419.73 168.58 419.73 166.59 422.13 166.59 422.13 140.78 420.75 140.78 420.75 132.12 406.06 132.12 406.06 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M406.05,148.57s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.78h-1.41v-3.11H402.08v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="403.13"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(259.43 568.78) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="405.25"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(231.01 588.4) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M406,147l0,21.85h13.63v-2.07h2.46V147.62h-2.46V147Zm9.64,6.19H406.7v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="414.08"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(239.42 596.83) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="398.12"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(231.6 568.49) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="403.16"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(248.13 572.07) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="399.41"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(244.35 568.28) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="399.74"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(244.67 568.61) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="400.06"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(245 568.94) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="400.39"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(245.32 569.26) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="400.71"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(245.65 569.59) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="401.04"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(245.97 569.91) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="401.36"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(246.3 570.24) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="401.69"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(246.63 570.56) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="402.01"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(246.95 570.89) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="402.34"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(247.28 571.22) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="402.67"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(247.6 571.54) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="402.99"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(247.93 571.87) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="403.32"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(248.25 572.19) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="403.64"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(248.58 572.52) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="403.97"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(248.9 572.84) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="404.29"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(249.23 573.17) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="404.62"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(249.56 573.49) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="404.94"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(249.88 573.82) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="405.27"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(250.21 574.15) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="405.6"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(250.53 574.47) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="405.92"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(250.86 574.8) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="406.25"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(251.18 575.12) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="406.57"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(251.51 575.45) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="406.9"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(251.83 575.77) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M404.33,128a3.54,3.54,0,0,1,1.81,3.27h14.57c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      />
      {/* <rect
        x="480.08"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(314.67 654.32) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="472.25"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(341.58 625.08) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="490.7 137.73 494.6 137.73 494.6 148.6 490.7 148.6 490.7 168.58 477.02 168.58 477.02 166.59 474.63 166.59 474.63 140.78 476 140.78 476 132.12 490.7 132.12 490.7 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M490.71,148.57s0,17.94,0,18h-8.15v2h-5.5v-2.05h-2.44V140.78H476v-3.11h18.65v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="471.67"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(327.97 637.32) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="482.59"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(308.36 665.74) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M477.07,147v.65h-2.45v19.13h2.45v2.07H490.7l0-21.85Zm4,2.32h8.95v3.87H481.1Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="474.58"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(299.92 657.33) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="494.78"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(328.26 665.15) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="479.72"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(324.69 648.62) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="483.53"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(328.47 652.41) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="483.21"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(328.14 652.08) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="482.88"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(327.82 651.76) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="482.55"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(327.49 651.43) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="482.23"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(327.17 651.1) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="481.9"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(326.84 650.78) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="481.58"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(326.51 650.45) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="481.25"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(326.19 650.13) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="480.93"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(325.86 649.8) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="480.6"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(325.54 649.48) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="480.28"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(325.21 649.15) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="479.95"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(324.89 648.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="479.62"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(324.56 648.5) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="479.3"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(324.24 648.17) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="478.97"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(323.91 647.85) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="478.65"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(323.58 647.52) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="478.32"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(323.26 647.2) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="478"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(322.93 646.87) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="477.67"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(322.61 646.55) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="477.35"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(322.28 646.22) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="477.02"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(321.96 645.89) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="476.69"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(321.63 645.57) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="476.37"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(321.31 645.24) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="476.04"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(320.98 644.92) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M492.42,128a3.54,3.54,0,0,0-1.81,3.27H476.05c-.1-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      /> */}
      {/* <rect
        x="459.56"
        y="159.95"
        width="8.83"
        height="19.74"
        transform="translate(294.15 633.79) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="454.05"
        y="134.41"
        width="22.16"
        height="14.68"
        transform="translate(323.38 606.88) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="457.77 137.73 453.86 137.73 453.86 148.6 457.77 148.6 457.77 168.58 471.44 168.58 471.44 166.59 473.84 166.59 473.84 140.78 472.46 140.78 472.46 132.12 457.77 132.12 457.77 137.73"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M457.76,148.57s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.78h-1.41v-3.11H453.79v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="454.85"
        y="146.65"
        width="21.95"
        height="16.05"
        transform="translate(311.14 620.5) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="456.96"
        y="171.38"
        width="8.91"
        height="14.63"
        transform="translate(282.72 640.11) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M457.72,147l0,21.85h13.63v-2.07h2.46V147.62h-2.46V147Zm9.65,6.19h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="465.79"
        y="177.14"
        width="8.1"
        height="3.14"
        transform="translate(291.13 648.55) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="449.83"
        y="166.51"
        width="3.86"
        height="3.86"
        transform="translate(283.32 620.2) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="454.87"
        y="157.88"
        width="13.88"
        height="8.18"
        transform="translate(299.84 623.78) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="451.12"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(296.06 620) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="451.45"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(296.38 620.32) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="451.77"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(296.71 620.65) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="452.1"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(297.04 620.97) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="452.42"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(297.36 621.3) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="452.75"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(297.69 621.62) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="453.08"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(298.01 621.95) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="453.4"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(298.34 622.28) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="453.73"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(298.66 622.6) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="454.05"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(298.99 622.93) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="454.38"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(299.31 623.25) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="454.7"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(299.64 623.58) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="455.03"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(299.97 623.9) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="455.35"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(300.29 624.23) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="455.68"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(300.62 624.55) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="456.01"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(300.94 624.88) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="456.33"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(301.27 625.21) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="456.66"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(301.59 625.53) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="456.98"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(301.92 625.86) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="457.31"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(302.24 626.18) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="457.63"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(302.57 626.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="457.96"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(302.9 626.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="458.28"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(303.22 627.16) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="458.61"
        y="161.89"
        width="13.81"
        height="0.15"
        transform="translate(303.55 627.48) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M456,128a3.53,3.53,0,0,1,1.81,3.27h14.57c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      /> */}
      <text
        transform="translate(352.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH19
        </tspan>
      </text>
      <text
        transform="translate(374.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH21
        </tspan>
      </text>
      <text
        transform="translate(404.38 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH23
        </tspan>
      </text>
      <text
        transform="translate(426.38 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH25
        </tspan>
      </text>
      <text
        transform="translate(455.63 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH27
        </tspan>
      </text>
      <text
        transform="translate(477.63 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH29
        </tspan>
      </text>
      {/* <text
        transform="translate(507.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH31
        </tspan>
      </text> */}
      {/* <text
        transform="translate(529.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH33
        </tspan>
      </text> */}
      <text
        transform="translate(352.63 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH20
        </tspan>
      </text>
      <text
        transform="translate(374.63 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH22
        </tspan>
      </text>
      <text
        transform="translate(404.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH24
        </tspan>
      </text>
      <text
        transform="translate(426.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH26
        </tspan>
      </text>
      {/* <text
        transform="translate(455.88 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH28
        </tspan>
      </text> */}
      {/* <text
        transform="translate(477.88 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH30
        </tspan>
      </text> */}
      {/* <text
        transform="translate(507.22 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH32
        </tspan>
      </text> */}
      {/* <text
        transform="translate(529.22 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH34
        </tspan>
      </text> */}
    </g>
    <g id="Townhomes" data-name="Townhomes">
      <polygon
        points="70.24 187.38 70.24 137.81 77.65 130.4 329.08 130.4 329.08 187.38 303.3 187.38 303.3 244.08 103.57 244.08 96.02 236.82 70.24 187.38"
        fill="#b3d337"
        stroke="#7d7f81"
        stroke-miterlimit="10"
        stroke-width="0.23"
      />
      <rect
        x="128.32"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(337.56 72.09) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="120.49"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(364.47 101.32) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="138.94 236.91 142.85 236.91 142.85 226.05 138.94 226.05 138.94 206.07 125.27 206.07 125.27 208.06 122.87 208.06 122.87 233.86 124.25 233.86 124.25 242.53 138.94 242.53 138.94 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M139,226.08s0-18,0-18H130.8v-2h-5.49v2h-2.45v25.73h1.41V237h18.65v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="119.92"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(350.86 89.08) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="130.84"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(331.25 60.66) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M139,227.68l0-21.86H125.31v2.08h-2.45V227h2.45v.66Zm-9.65-6.19h9v3.87h-9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="122.82"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(322.81 69.07) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="143.02"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(351.15 61.25) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="127.96"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(347.58 77.78) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="131.77"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(351.36 74) rotate(90)"
        fill="#808083"
      />
      <rect
        x="131.45"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(351.03 74.32) rotate(90)"
        fill="#808083"
      />
      <rect
        x="131.12"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(350.71 74.65) rotate(90)"
        fill="#808083"
      />
      <rect
        x="130.8"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(350.38 74.97) rotate(90)"
        fill="#808083"
      />
      <rect
        x="130.47"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(350.06 75.3) rotate(90)"
        fill="#808083"
      />
      <rect
        x="130.15"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(349.73 75.62) rotate(90)"
        fill="#808083"
      />
      <rect
        x="129.82"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(349.4 75.95) rotate(90)"
        fill="#808083"
      />
      <rect
        x="129.5"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(349.08 76.28) rotate(90)"
        fill="#808083"
      />
      <rect
        x="129.17"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(348.75 76.6) rotate(90)"
        fill="#808083"
      />
      <rect
        x="128.84"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(348.43 76.93) rotate(90)"
        fill="#808083"
      />
      <rect
        x="128.52"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(348.1 77.25) rotate(90)"
        fill="#808083"
      />
      <rect
        x="128.19"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(347.78 77.58) rotate(90)"
        fill="#808083"
      />
      <rect
        x="127.87"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(347.45 77.9) rotate(90)"
        fill="#808083"
      />
      <rect
        x="127.54"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(347.13 78.23) rotate(90)"
        fill="#808083"
      />
      <rect
        x="127.22"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(346.8 78.55) rotate(90)"
        fill="#808083"
      />
      <rect
        x="126.89"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(346.47 78.88) rotate(90)"
        fill="#808083"
      />
      <rect
        x="126.57"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(346.15 79.21) rotate(90)"
        fill="#808083"
      />
      <rect
        x="126.24"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(345.82 79.53) rotate(90)"
        fill="#808083"
      />
      <rect
        x="125.91"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(345.5 79.86) rotate(90)"
        fill="#808083"
      />
      <rect
        x="125.59"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(345.17 80.18) rotate(90)"
        fill="#808083"
      />
      <rect
        x="125.26"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(344.85 80.51) rotate(90)"
        fill="#808083"
      />
      <rect
        x="124.94"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(344.52 80.83) rotate(90)"
        fill="#808083"
      />
      <rect
        x="124.61"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(344.19 81.16) rotate(90)"
        fill="#808083"
      />
      <rect
        x="124.29"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(343.87 81.48) rotate(90)"
        fill="#808083"
      />
      <path
        d="M140.66,246.65a3.57,3.57,0,0,1-1.81-3.27H124.29c-.09,1.48,0,2.72-1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="107.8"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(317.04 92.61) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="102.3"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(346.27 119.52) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="106.01 236.91 102.11 236.91 102.11 226.05 106.01 226.05 106.01 206.07 119.69 206.07 119.69 208.06 122.08 208.06 122.08 233.86 120.7 233.86 120.7 242.53 106.01 242.53 106.01 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M106,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H102v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="103.09"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(334.03 105.91) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="105.2"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(305.61 86.29) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M119.64,227.68V227h2.45V207.9h-2.45v-2.08H106L106,227.68Zm-4-2.32h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="114.03"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(314.02 77.86) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="98.08"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(306.21 106.2) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="103.12"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(322.73 102.63) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="99.37"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(318.95 106.41) rotate(90)"
        fill="#808083"
      />
      <rect
        x="99.69"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(319.27 106.08) rotate(90)"
        fill="#808083"
      />
      <rect
        x="100.02"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(319.6 105.75) rotate(90)"
        fill="#808083"
      />
      <rect
        x="100.34"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(319.92 105.43) rotate(90)"
        fill="#808083"
      />
      <rect
        x="100.67"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(320.25 105.1) rotate(90)"
        fill="#808083"
      />
      <rect
        x="100.99"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(320.58 104.78) rotate(90)"
        fill="#808083"
      />
      <rect
        x="101.32"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(320.9 104.45) rotate(90)"
        fill="#808083"
      />
      <rect
        x="101.64"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(321.23 104.13) rotate(90)"
        fill="#808083"
      />
      <rect
        x="101.97"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(321.55 103.8) rotate(90)"
        fill="#808083"
      />
      <rect
        x="102.3"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(321.88 103.48) rotate(90)"
        fill="#808083"
      />
      <rect
        x="102.62"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(322.2 103.15) rotate(90)"
        fill="#808083"
      />
      <rect
        x="102.95"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(322.53 102.82) rotate(90)"
        fill="#808083"
      />
      <rect
        x="103.27"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(322.85 102.5) rotate(90)"
        fill="#808083"
      />
      <rect
        x="103.6"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(323.18 102.17) rotate(90)"
        fill="#808083"
      />
      <rect
        x="103.92"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(323.51 101.85) rotate(90)"
        fill="#808083"
      />
      <rect
        x="104.25"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(323.83 101.52) rotate(90)"
        fill="#808083"
      />
      <rect
        x="104.57"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(324.16 101.2) rotate(90)"
        fill="#808083"
      />
      <rect
        x="104.9"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(324.48 100.87) rotate(90)"
        fill="#808083"
      />
      <rect
        x="105.23"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(324.81 100.55) rotate(90)"
        fill="#808083"
      />
      <rect
        x="105.55"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(325.13 100.22) rotate(90)"
        fill="#808083"
      />
      <rect
        x="105.88"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(325.46 99.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="106.2"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(325.78 99.57) rotate(90)"
        fill="#808083"
      />
      <rect
        x="106.53"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(326.11 99.24) rotate(90)"
        fill="#808083"
      />
      <rect
        x="106.85"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(326.44 98.92) rotate(90)"
        fill="#808083"
      />
      <path
        d="M104.29,246.65a3.57,3.57,0,0,0,1.81-3.27h14.56c.09,1.48,0,2.72,1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="102.46"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(-62.81 276.57) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="94.64"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(-35.9 247.34) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="113.08 137.6 116.99 137.6 116.99 148.47 113.08 148.47 113.08 168.45 99.41 168.45 99.41 166.46 97.02 166.46 97.02 140.65 98.39 140.65 98.39 131.99 113.08 131.99 113.08 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M113.09,148.44s0,17.94,0,18H105v2h-5.5v-2.05H97V140.65h1.41v-3.11h18.65v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="94.06"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(-49.51 259.58) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="104.98"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(-69.13 288) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M99.46,146.84v.65H97v19.13h2.46v2.07h13.63l0-21.85Zm4,2.32h9V153h-9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="96.97"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(-77.56 279.59) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="117.16"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(-49.22 287.41) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="102.1"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(-52.79 270.88) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="105.92"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-49.01 274.66) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="105.59"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-49.34 274.34) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="105.27"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-49.67 274.01) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="104.94"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-49.99 273.69) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="104.62"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-50.32 273.36) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="104.29"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-50.64 273.04) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="103.97"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-50.97 272.71) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="103.64"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-51.29 272.38) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="103.31"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-51.62 272.06) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="102.99"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-51.94 271.73) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="102.66"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-52.27 271.41) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="102.34"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-52.6 271.08) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="102.01"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-52.92 270.76) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="101.69"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-53.25 270.43) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="101.36"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-53.57 270.11) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="101.04"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-53.9 269.78) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="100.71"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-54.22 269.45) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="100.38"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-54.55 269.13) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="100.06"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-54.87 268.8) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="99.73"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-55.2 268.48) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="99.41"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-55.53 268.15) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="99.08"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-55.85 267.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="98.76"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-56.18 267.5) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="98.43"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-56.5 267.18) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M114.81,127.87a3.54,3.54,0,0,0-1.81,3.27H98.43c-.09-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="81.94"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(-83.33 256.05) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="76.44"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(-54.1 229.14) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="80.16 137.6 76.25 137.6 76.25 148.47 80.16 148.47 80.16 168.45 93.83 168.45 93.83 166.46 96.22 166.46 96.22 140.65 94.85 140.65 94.85 131.99 80.16 131.99 80.16 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M80.14,148.44s0,17.94,0,18h8.15v2h5.5v-2.05h2.45V140.65H94.83v-3.11H76.18v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="77.23"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(-66.34 242.75) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="79.35"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(-94.76 262.37) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M80.11,146.84l0,21.85H93.78v-2.07h2.46V147.49H93.78v-.65ZM89.75,153h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="88.18"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(-86.35 270.8) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="72.22"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(-94.17 242.46) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="77.26"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(-77.64 246.03) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="73.51"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-81.42 242.25) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="73.83"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-81.1 242.58) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="74.16"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-80.77 242.9) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="74.49"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-80.45 243.23) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="74.81"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-80.12 243.56) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="75.14"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-79.8 243.88) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="75.46"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-79.47 244.21) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="75.79"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-79.14 244.53) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="76.11"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-78.82 244.86) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="76.44"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-78.49 245.18) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="76.77"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-78.17 245.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="77.09"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-77.84 245.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="77.42"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-77.52 246.16) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="77.74"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-77.19 246.49) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="78.07"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-76.87 246.81) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="78.39"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-76.54 247.14) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="78.72"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-76.21 247.46) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="79.04"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-75.89 247.79) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="79.37"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-75.56 248.11) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="79.7"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-75.24 248.44) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="80.02"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-74.91 248.76) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="80.35"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-74.59 249.09) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="80.67"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-74.26 249.42) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="81"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-73.94 249.74) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M78.43,127.87a3.54,3.54,0,0,1,1.81,3.27H94.81c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="154.18"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(-11.1 328.28) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="146.35"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(15.81 299.05) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="164.8 137.6 168.7 137.6 168.7 148.47 164.8 148.47 164.8 168.45 151.12 168.45 151.12 166.46 148.73 166.46 148.73 140.65 150.1 140.65 150.1 131.99 164.8 131.99 164.8 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M164.81,148.44s0,17.94,0,18h-8.15v2h-5.5v-2.05h-2.45V140.65h1.42v-3.11h18.64v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="145.77"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(2.2 311.29) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="156.69"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(-17.41 339.71) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M151.17,146.84v.65h-2.46v19.13h2.46v2.07H164.8l0-21.85Zm4,2.32h9V153h-9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="148.68"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(-25.85 331.3) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="168.88"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(2.49 339.12) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="153.81"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(-1.08 322.59) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="157.63"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(2.7 326.37) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="157.31"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(2.37 326.05) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="156.98"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(2.05 325.72) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="156.65"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(1.72 325.4) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="156.33"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(1.4 325.07) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="156"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(1.07 324.75) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="155.68"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(0.74 324.42) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="155.35"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(0.42 324.1) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="155.03"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(0.09 323.77) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="154.7"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-0.23 323.44) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="154.37"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-0.56 323.12) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="154.05"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-0.88 322.79) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="153.72"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-1.21 322.47) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="153.4"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-1.53 322.14) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="153.07"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-1.86 321.82) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="152.75"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-2.19 321.49) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="152.42"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-2.51 321.17) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="152.1"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-2.84 320.84) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="151.77"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-3.16 320.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="151.44"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-3.49 320.19) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="151.12"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-3.81 319.86) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="150.79"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-4.14 319.54) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="150.47"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-4.46 319.21) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="150.14"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-4.79 318.89) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M166.52,127.87a3.54,3.54,0,0,0-1.81,3.27H150.15c-.1-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="133.65"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(-31.62 307.76) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="128.15"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(-2.39 280.85) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="131.87 137.6 127.96 137.6 127.96 148.47 131.87 148.47 131.87 168.45 145.54 168.45 145.54 166.46 147.94 166.46 147.94 140.65 146.56 140.65 146.56 131.99 131.87 131.99 131.87 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M131.86,148.44s0,17.94,0,18H140v2h5.49v-2.05H148V140.65h-1.41v-3.11H127.89v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="128.94"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(-14.63 294.46) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="131.06"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(-43.05 314.08) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M131.82,146.84l0,21.85h13.63v-2.07H148V147.49h-2.46v-.65Zm9.65,6.19h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="139.89"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(-34.64 322.51) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="123.93"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(-42.45 294.17) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="128.97"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(-25.93 297.75) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="125.22"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-29.71 293.97) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="125.55"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-29.39 294.29) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="125.87"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-29.06 294.62) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="126.2"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-28.74 294.94) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="126.52"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-28.41 295.27) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="126.85"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-28.08 295.59) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="127.17"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-27.76 295.92) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="127.5"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-27.43 296.24) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="127.83"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-27.11 296.57) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="128.15"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-26.78 296.9) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="128.48"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-26.46 297.22) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="128.8"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-26.13 297.55) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="129.13"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-25.8 297.87) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="129.45"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-25.48 298.2) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="129.78"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-25.15 298.52) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="130.1"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-24.83 298.85) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="130.43"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-24.5 299.17) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="130.76"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-24.18 299.5) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="131.08"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-23.85 299.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="131.41"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-23.53 300.15) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="131.73"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-23.2 300.48) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="132.06"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-22.87 300.8) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="132.38"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-22.55 301.13) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="132.71"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(-22.22 301.45) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M130.14,127.87a3.53,3.53,0,0,1,1.81,3.27h14.57c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="205.89"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(40.61 380) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="198.06"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(67.52 350.76) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="216.51 137.6 220.41 137.6 220.41 148.47 216.51 148.47 216.51 168.45 202.83 168.45 202.83 166.46 200.44 166.46 200.44 140.65 201.82 140.65 201.82 131.99 216.51 131.99 216.51 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M216.52,148.44s0,17.94,0,18h-8.15v2h-5.5v-2.05h-2.44V140.65h1.41v-3.11h18.65v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="197.48"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(53.91 363) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="208.4"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(34.3 391.42) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M202.88,146.84v.65h-2.45v19.13h2.45v2.07h13.63l0-21.85Zm4,2.32h9V153h-9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="200.39"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(25.86 383.01) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="220.59"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(54.2 390.83) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="205.53"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(50.63 374.3) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="209.34"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(54.41 378.09) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="209.02"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(54.08 377.76) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="208.69"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(53.76 377.44) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="208.37"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(53.43 377.11) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="208.04"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(53.11 376.78) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="207.71"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(52.78 376.46) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="207.39"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(52.46 376.13) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="207.06"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(52.13 375.81) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="206.74"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(51.8 375.48) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="206.41"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(51.48 375.16) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="206.09"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(51.15 374.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="205.76"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(50.83 374.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="205.44"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(50.5 374.18) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="205.11"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(50.18 373.85) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="204.78"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(49.85 373.53) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="204.46"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(49.53 373.2) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="204.13"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(49.2 372.88) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="203.81"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(48.87 372.55) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="203.48"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(48.55 372.23) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="203.16"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(48.22 371.9) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="202.83"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(47.9 371.58) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="202.51"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(47.57 371.25) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="202.18"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(47.25 370.92) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="201.85"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(46.92 370.6) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M218.23,127.87a3.54,3.54,0,0,0-1.81,3.27H201.86c-.1-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="185.37"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(20.09 359.47) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="179.86"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(49.33 332.56) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="183.58 137.6 179.67 137.6 179.67 148.47 183.58 148.47 183.58 168.45 197.25 168.45 197.25 166.46 199.65 166.46 199.65 140.65 198.27 140.65 198.27 131.99 183.58 131.99 183.58 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M183.57,148.44s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.65h-1.41v-3.11H179.6v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="180.66"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(37.08 346.18) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="182.77"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(8.67 365.79) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M183.53,146.84l0,21.85h13.64v-2.07h2.45V147.49h-2.45v-.65Zm9.65,6.19h-9v-3.87h9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="191.6"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(17.07 374.23) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="175.64"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(9.26 345.89) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="180.68"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(25.79 349.46) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="176.93"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(22 345.68) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="177.26"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(22.33 346) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="177.58"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(22.65 346.33) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="177.91"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(22.98 346.65) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="178.23"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(23.3 346.98) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="178.56"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(23.63 347.3) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="178.89"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(23.95 347.63) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="179.21"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(24.28 347.96) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="179.54"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(24.6 348.28) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="179.86"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(24.93 348.61) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="180.19"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(25.26 348.93) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="180.51"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(25.58 349.26) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="180.84"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(25.91 349.58) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="181.17"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(26.23 349.91) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="181.49"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(26.56 350.23) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="181.82"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(26.88 350.56) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="182.14"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(27.21 350.89) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="182.47"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(27.53 351.21) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="182.79"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(27.86 351.54) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="183.12"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(28.19 351.86) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="183.44"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(28.51 352.19) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="183.77"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(28.84 352.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="184.1"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(29.16 352.84) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="184.42"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(29.49 353.17) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M181.85,127.87a3.55,3.55,0,0,1,1.82,3.27h14.56c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="257.6"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(92.33 431.71) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="249.77"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(119.23 402.47) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="268.22 137.6 272.13 137.6 272.13 148.47 268.22 148.47 268.22 168.45 254.54 168.45 254.54 166.46 252.15 166.46 252.15 140.65 253.53 140.65 253.53 131.99 268.22 131.99 268.22 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M268.23,148.44s0,17.94,0,18h-8.15v2h-5.49v-2.05h-2.45V140.65h1.41v-3.11H272.2v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="249.2"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(105.62 414.72) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="260.11"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(86.01 443.13) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M254.59,146.84v.65h-2.45v19.13h2.45v2.07h13.64l0-21.85Zm4,2.32h8.95V153h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="252.1"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(77.57 434.73) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="272.3"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(105.91 442.54) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="257.24"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(102.34 426.01) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="261.05"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(106.12 429.8) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="260.73"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(105.8 429.47) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="260.4"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(105.47 429.15) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="260.08"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(105.14 428.82) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="259.75"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(104.82 428.5) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="259.43"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(104.49 428.17) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="259.1"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(104.17 427.84) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="258.78"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(103.84 427.52) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="258.45"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(103.52 427.19) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="258.12"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(103.19 426.87) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="257.8"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(102.87 426.54) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="257.47"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(102.54 426.22) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="257.15"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(102.21 425.89) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="256.82"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(101.89 425.57) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="256.5"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(101.56 425.24) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="256.17"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(101.24 424.91) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="255.84"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(100.91 424.59) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="255.52"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(100.59 424.26) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="255.19"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(100.26 423.94) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="254.87"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(99.94 423.61) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="254.54"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(99.61 423.29) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="254.22"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(99.28 422.96) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="253.89"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(98.96 422.64) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="253.57"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(98.63 422.31) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M269.94,127.87a3.56,3.56,0,0,0-1.81,3.27H253.57c-.09-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="237.08"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(71.8 411.18) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="231.58"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(101.04 384.28) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="235.29 137.6 231.38 137.6 231.38 148.47 235.29 148.47 235.29 168.45 248.97 168.45 248.97 166.46 251.36 166.46 251.36 140.65 249.98 140.65 249.98 131.99 235.29 131.99 235.29 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M235.28,148.44s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.65H250v-3.11H231.31v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="232.37"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(88.79 397.89) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="234.48"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(60.38 417.5) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M235.24,146.84l0,21.85h13.64v-2.07h2.45V147.49h-2.45v-.65Zm9.65,6.19h-8.95v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="243.31"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(68.78 425.94) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="227.36"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(60.97 397.6) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="232.39"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(77.5 401.17) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="228.64"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(73.71 397.39) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="228.97"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(74.04 397.71) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="229.3"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(74.36 398.04) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="229.62"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(74.69 398.37) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="229.95"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(75.01 398.69) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="230.27"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(75.34 399.02) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="230.6"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(75.66 399.34) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="230.92"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(75.99 399.67) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="231.25"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(76.32 399.99) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="231.57"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(76.64 400.32) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="231.9"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(76.97 400.64) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="232.23"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(77.29 400.97) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="232.55"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(77.62 401.3) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="232.88"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(77.94 401.62) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="233.2"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(78.27 401.95) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="233.53"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(78.6 402.27) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="233.85"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(78.92 402.6) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="234.18"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(79.25 402.92) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="234.5"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(79.57 403.25) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="234.83"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(79.9 403.57) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="235.16"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(80.22 403.9) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="235.48"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(80.55 404.23) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="235.81"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(80.87 404.55) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="236.13"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(81.2 404.88) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M233.57,127.87a3.56,3.56,0,0,1,1.81,3.27h14.56c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="309.24"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(143.97 483.35) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="301.41"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(170.87 454.11) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="319.86 137.6 323.77 137.6 323.77 148.47 319.86 148.47 319.86 168.45 306.19 168.45 306.19 166.46 303.79 166.46 303.79 140.65 305.17 140.65 305.17 131.99 319.86 131.99 319.86 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M319.87,148.44s0,17.94,0,18h-8.15v2h-5.49v-2.05h-2.45V140.65h1.41v-3.11h18.65v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="300.84"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(157.26 466.36) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="311.76"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(137.65 494.77) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M306.23,146.84v.65h-2.45v19.13h2.45v2.07h13.64l0-21.85Zm4,2.32h8.95V153h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="303.74"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(129.21 486.37) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="323.94"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(157.55 494.18) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="308.88"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(153.98 477.65) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="312.69"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(157.76 481.44) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="312.37"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(157.44 481.11) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="312.04"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(157.11 480.79) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="311.72"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(156.78 480.46) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="311.39"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(156.46 480.14) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="311.07"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(156.13 479.81) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="310.74"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(155.81 479.49) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="310.42"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(155.48 479.16) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="310.09"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(155.16 478.83) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="309.76"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(154.83 478.51) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="309.44"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(154.51 478.18) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="309.11"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(154.18 477.86) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="308.79"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(153.85 477.53) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="308.46"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(153.53 477.21) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="308.14"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(153.2 476.88) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="307.81"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(152.88 476.56) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="307.49"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(152.55 476.23) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="307.16"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(152.23 475.9) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="306.83"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(151.9 475.58) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="306.51"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(151.58 475.25) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="306.18"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(151.25 474.93) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="305.86"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(150.92 474.6) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="305.53"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(150.6 474.28) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="305.21"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(150.27 473.95) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M321.58,127.87a3.56,3.56,0,0,0-1.81,3.27H305.21c-.09-1.48,0-2.73-1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="288.72"
        y="159.82"
        width="8.83"
        height="19.74"
        transform="translate(123.44 462.83) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="283.22"
        y="134.28"
        width="22.16"
        height="14.68"
        transform="translate(152.68 435.92) rotate(-90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="286.93 137.6 283.02 137.6 283.02 148.47 286.93 148.47 286.93 168.45 300.61 168.45 300.61 166.46 303 166.46 303 140.65 301.62 140.65 301.62 131.99 286.93 131.99 286.93 137.6"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M286.92,148.44s0,17.94,0,18h8.15v2h5.49v-2.05H303V140.65H301.6v-3.11H283v10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="284.01"
        y="146.52"
        width="21.95"
        height="16.05"
        transform="translate(140.43 449.53) rotate(-90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="286.12"
        y="171.24"
        width="8.91"
        height="14.63"
        transform="translate(112.02 469.14) rotate(-90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M286.88,146.84l0,21.85h13.64v-2.07H303V147.49h-2.45v-.65Zm9.65,6.19h-8.95v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="294.95"
        y="177.01"
        width="8.1"
        height="3.14"
        transform="translate(120.42 477.58) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="279"
        y="166.38"
        width="3.86"
        height="3.86"
        transform="translate(112.61 449.24) rotate(-90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="284.04"
        y="157.75"
        width="13.88"
        height="8.18"
        transform="translate(129.14 452.81) rotate(-90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="280.28"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(125.35 449.03) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="280.61"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(125.68 449.35) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="280.94"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(126 449.68) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="281.26"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(126.33 450.01) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="281.59"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(126.65 450.33) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="281.91"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(126.98 450.66) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="282.24"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(127.31 450.98) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="282.56"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(127.63 451.31) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="282.89"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(127.96 451.63) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="283.21"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(128.28 451.96) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="283.54"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(128.61 452.28) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="283.87"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(128.93 452.61) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="284.19"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(129.26 452.94) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="284.52"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(129.58 453.26) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="284.84"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(129.91 453.59) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="285.17"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(130.24 453.91) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="285.49"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(130.56 454.24) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="285.82"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(130.89 454.56) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="286.15"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(131.21 454.89) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="286.47"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(131.54 455.21) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="286.8"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(131.86 455.54) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="287.12"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(132.19 455.87) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="287.45"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(132.51 456.19) rotate(-90)"
        fill="#808083"
      />
      <rect
        x="287.77"
        y="161.76"
        width="13.81"
        height="0.15"
        transform="translate(132.84 456.52) rotate(-90)"
        fill="#808083"
      />
      <path
        d="M285.21,127.87a3.56,3.56,0,0,1,1.81,3.27h14.56c.09-1.48,0-2.73,1.07-3.27Z"
        fill="#838383"
      />
      <rect
        x="180.03"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(389.27 20.38) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="172.2"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(416.18 49.61) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="190.65 236.91 194.56 236.91 194.56 226.05 190.65 226.05 190.65 206.07 176.98 206.07 176.98 208.06 174.58 208.06 174.58 233.86 175.96 233.86 175.96 242.53 190.65 242.53 190.65 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M190.66,226.08s0-18,0-18h-8.15v-2H177v2h-2.45v25.73H176V237h18.65v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="171.63"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(402.57 37.37) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="182.55"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(382.96 8.95) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M190.7,227.68l0-21.86H177v2.08h-2.45V227H177v.66Zm-9.65-6.19h9v3.87h-9Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="174.53"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(374.52 17.36) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="194.73"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(402.86 9.54) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="179.67"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(399.29 26.07) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="183.49"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(403.07 22.28) rotate(90)"
        fill="#808083"
      />
      <rect
        x="183.16"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(402.74 22.61) rotate(90)"
        fill="#808083"
      />
      <rect
        x="182.84"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(402.42 22.94) rotate(90)"
        fill="#808083"
      />
      <rect
        x="182.51"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(402.09 23.26) rotate(90)"
        fill="#808083"
      />
      <rect
        x="182.18"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(401.77 23.59) rotate(90)"
        fill="#808083"
      />
      <rect
        x="181.86"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(401.44 23.91) rotate(90)"
        fill="#808083"
      />
      <rect
        x="181.53"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(401.12 24.24) rotate(90)"
        fill="#808083"
      />
      <rect
        x="181.21"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(400.79 24.56) rotate(90)"
        fill="#808083"
      />
      <rect
        x="180.88"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(400.46 24.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="180.56"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(400.14 25.21) rotate(90)"
        fill="#808083"
      />
      <rect
        x="180.23"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(399.81 25.54) rotate(90)"
        fill="#808083"
      />
      <rect
        x="179.91"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(399.49 25.87) rotate(90)"
        fill="#808083"
      />
      <rect
        x="179.58"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(399.16 26.19) rotate(90)"
        fill="#808083"
      />
      <rect
        x="179.25"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(398.84 26.52) rotate(90)"
        fill="#808083"
      />
      <rect
        x="178.93"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(398.51 26.84) rotate(90)"
        fill="#808083"
      />
      <rect
        x="178.6"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(398.19 27.17) rotate(90)"
        fill="#808083"
      />
      <rect
        x="178.28"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(397.86 27.49) rotate(90)"
        fill="#808083"
      />
      <rect
        x="177.95"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(397.53 27.82) rotate(90)"
        fill="#808083"
      />
      <rect
        x="177.63"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(397.21 28.15) rotate(90)"
        fill="#808083"
      />
      <rect
        x="177.3"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(396.88 28.47) rotate(90)"
        fill="#808083"
      />
      <rect
        x="176.98"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(396.56 28.8) rotate(90)"
        fill="#808083"
      />
      <rect
        x="176.65"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(396.23 29.12) rotate(90)"
        fill="#808083"
      />
      <rect
        x="176.32"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(395.91 29.45) rotate(90)"
        fill="#808083"
      />
      <rect
        x="176"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(395.58 29.77) rotate(90)"
        fill="#808083"
      />
      <path
        d="M192.38,246.65a3.54,3.54,0,0,1-1.81-3.27H176c-.09,1.48,0,2.72-1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="159.51"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(368.75 40.9) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="154.01"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(397.99 67.81) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="157.72 236.91 153.82 236.91 153.82 226.05 157.72 226.05 157.72 206.07 171.4 206.07 171.4 208.06 173.79 208.06 173.79 233.86 172.41 233.86 172.41 242.53 157.72 242.53 157.72 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M157.71,226.08s0-18,0-18h8.15v-2h5.5v2h2.44v25.73h-1.41V237H153.74v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="154.8"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(385.74 54.19) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="156.92"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(357.32 34.58) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M171.35,227.68V227h2.45V207.9h-2.45v-2.08H157.72l0,21.86Zm-4-2.32h-8.95v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="165.75"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(365.73 26.14) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="149.79"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(357.92 54.49) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="154.83"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(374.45 50.91) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="151.08"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(370.66 54.69) rotate(90)"
        fill="#808083"
      />
      <rect
        x="151.4"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(370.99 54.37) rotate(90)"
        fill="#808083"
      />
      <rect
        x="151.73"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(371.31 54.04) rotate(90)"
        fill="#808083"
      />
      <rect
        x="152.05"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(371.64 53.72) rotate(90)"
        fill="#808083"
      />
      <rect
        x="152.38"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(371.96 53.39) rotate(90)"
        fill="#808083"
      />
      <rect
        x="152.7"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(372.29 53.07) rotate(90)"
        fill="#808083"
      />
      <rect
        x="153.03"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(372.61 52.74) rotate(90)"
        fill="#808083"
      />
      <rect
        x="153.36"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(372.94 52.42) rotate(90)"
        fill="#808083"
      />
      <rect
        x="153.68"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(373.26 52.09) rotate(90)"
        fill="#808083"
      />
      <rect
        x="154.01"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(373.59 51.76) rotate(90)"
        fill="#808083"
      />
      <rect
        x="154.33"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(373.92 51.44) rotate(90)"
        fill="#808083"
      />
      <rect
        x="154.66"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(374.24 51.11) rotate(90)"
        fill="#808083"
      />
      <rect
        x="154.98"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(374.57 50.79) rotate(90)"
        fill="#808083"
      />
      <rect
        x="155.31"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(374.89 50.46) rotate(90)"
        fill="#808083"
      />
      <rect
        x="155.63"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(375.22 50.14) rotate(90)"
        fill="#808083"
      />
      <rect
        x="155.96"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(375.54 49.81) rotate(90)"
        fill="#808083"
      />
      <rect
        x="156.29"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(375.87 49.49) rotate(90)"
        fill="#808083"
      />
      <rect
        x="156.61"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(376.19 49.16) rotate(90)"
        fill="#808083"
      />
      <rect
        x="156.94"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(376.52 48.83) rotate(90)"
        fill="#808083"
      />
      <rect
        x="157.26"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(376.85 48.51) rotate(90)"
        fill="#808083"
      />
      <rect
        x="157.59"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(377.17 48.18) rotate(90)"
        fill="#808083"
      />
      <rect
        x="157.91"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(377.5 47.86) rotate(90)"
        fill="#808083"
      />
      <rect
        x="158.24"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(377.82 47.53) rotate(90)"
        fill="#808083"
      />
      <rect
        x="158.56"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(378.15 47.21) rotate(90)"
        fill="#808083"
      />
      <path
        d="M156,246.65a3.56,3.56,0,0,0,1.81-3.27h14.56c.1,1.48,0,2.72,1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="231.74"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(440.98 -31.34) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="223.92"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(467.89 -2.1) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="242.36 236.91 246.27 236.91 246.27 226.05 242.36 226.05 242.36 206.07 228.69 206.07 228.69 208.06 226.29 208.06 226.29 233.86 227.67 233.86 227.67 242.53 242.36 242.53 242.36 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M242.37,226.08s0-18,0-18h-8.15v-2h-5.49v2h-2.45v25.73h1.41V237h18.65v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="223.34"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(454.28 -14.34) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="234.26"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(434.67 -42.76) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M242.41,227.68l0-21.86H228.74v2.08h-2.46V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="226.25"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(426.23 -34.35) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="246.44"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(454.57 -42.17) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="231.38"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(451 -25.64) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="235.2"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(454.78 -29.43) rotate(90)"
        fill="#808083"
      />
      <rect
        x="234.87"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(454.46 -29.1) rotate(90)"
        fill="#808083"
      />
      <rect
        x="234.55"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(454.13 -28.78) rotate(90)"
        fill="#808083"
      />
      <rect
        x="234.22"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(453.8 -28.45) rotate(90)"
        fill="#808083"
      />
      <rect
        x="233.9"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(453.48 -28.12) rotate(90)"
        fill="#808083"
      />
      <rect
        x="233.57"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(453.15 -27.8) rotate(90)"
        fill="#808083"
      />
      <rect
        x="233.24"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(452.83 -27.47) rotate(90)"
        fill="#808083"
      />
      <rect
        x="232.92"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(452.5 -27.15) rotate(90)"
        fill="#808083"
      />
      <rect
        x="232.59"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(452.18 -26.82) rotate(90)"
        fill="#808083"
      />
      <rect
        x="232.27"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(451.85 -26.5) rotate(90)"
        fill="#808083"
      />
      <rect
        x="231.94"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(451.53 -26.17) rotate(90)"
        fill="#808083"
      />
      <rect
        x="231.62"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(451.2 -25.85) rotate(90)"
        fill="#808083"
      />
      <rect
        x="231.29"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(450.87 -25.52) rotate(90)"
        fill="#808083"
      />
      <rect
        x="230.97"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(450.55 -25.19) rotate(90)"
        fill="#808083"
      />
      <rect
        x="230.64"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(450.22 -24.87) rotate(90)"
        fill="#808083"
      />
      <rect
        x="230.31"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(449.9 -24.54) rotate(90)"
        fill="#808083"
      />
      <rect
        x="229.99"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(449.57 -24.22) rotate(90)"
        fill="#808083"
      />
      <rect
        x="229.66"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(449.25 -23.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="229.34"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(448.92 -23.57) rotate(90)"
        fill="#808083"
      />
      <rect
        x="229.01"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(448.6 -23.24) rotate(90)"
        fill="#808083"
      />
      <rect
        x="228.69"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(448.27 -22.92) rotate(90)"
        fill="#808083"
      />
      <rect
        x="228.36"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(447.94 -22.59) rotate(90)"
        fill="#808083"
      />
      <rect
        x="228.04"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(447.62 -22.26) rotate(90)"
        fill="#808083"
      />
      <rect
        x="227.71"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(447.29 -21.94) rotate(90)"
        fill="#808083"
      />
      <path
        d="M244.09,246.65a3.56,3.56,0,0,1-1.81-3.27H227.71c-.09,1.48,0,2.72-1.07,3.27Z"
        fill="#838383"
      />
      <rect
        x="211.22"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(420.46 -10.81) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="205.72"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(449.7 16.09) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="209.44 236.91 205.53 236.91 205.53 226.05 209.44 226.05 209.44 206.07 223.11 206.07 223.11 208.06 225.5 208.06 225.5 233.86 224.13 233.86 224.13 242.53 209.44 242.53 209.44 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M209.42,226.08s0-18,0-18h8.15v-2h5.5v2h2.45v25.73h-1.41V237H205.46v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="206.51"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(437.45 2.48) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="208.63"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(409.04 -17.13) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M223.06,227.68V227h2.46V207.9h-2.46v-2.08H209.43l0,21.86Zm-4-2.32h-8.95v-3.87H219Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="217.46"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(417.44 -25.57) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="201.5"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(409.63 2.77) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="206.54"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(426.16 -0.8) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="202.79"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(422.37 2.98) rotate(90)"
        fill="#808083"
      />
      <rect
        x="203.11"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(422.7 2.66) rotate(90)"
        fill="#808083"
      />
      <rect
        x="203.44"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(423.02 2.33) rotate(90)"
        fill="#808083"
      />
      <rect
        x="203.77"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(423.35 2.01) rotate(90)"
        fill="#808083"
      />
      <rect
        x="204.09"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(423.67 1.68) rotate(90)"
        fill="#808083"
      />
      <rect
        x="204.42"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(424 1.35) rotate(90)"
        fill="#808083"
      />
      <rect
        x="204.74"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(424.32 1.03) rotate(90)"
        fill="#808083"
      />
      <rect
        x="205.07"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(424.65 0.7) rotate(90)"
        fill="#808083"
      />
      <rect
        x="205.39"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(424.98 0.38) rotate(90)"
        fill="#808083"
      />
      <rect
        x="205.72"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(425.3 0.05) rotate(90)"
        fill="#808083"
      />
      <rect
        x="206.04"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(425.63 -0.27) rotate(90)"
        fill="#808083"
      />
      <rect
        x="206.37"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(425.95 -0.6) rotate(90)"
        fill="#808083"
      />
      <rect
        x="206.7"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(426.28 -0.92) rotate(90)"
        fill="#808083"
      />
      <rect
        x="207.02"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(426.6 -1.25) rotate(90)"
        fill="#808083"
      />
      <rect
        x="207.35"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(426.93 -1.58) rotate(90)"
        fill="#808083"
      />
      <rect
        x="207.67"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(427.25 -1.9) rotate(90)"
        fill="#808083"
      />
      <rect
        x="208"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(427.58 -2.23) rotate(90)"
        fill="#808083"
      />
      <rect
        x="208.32"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(427.91 -2.55) rotate(90)"
        fill="#808083"
      />
      <rect
        x="208.65"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(428.23 -2.88) rotate(90)"
        fill="#808083"
      />
      <rect
        x="208.97"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(428.56 -3.2) rotate(90)"
        fill="#808083"
      />
      <rect
        x="209.3"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(428.88 -3.53) rotate(90)"
        fill="#808083"
      />
      <rect
        x="209.63"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(429.21 -3.85) rotate(90)"
        fill="#808083"
      />
      <rect
        x="209.95"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(429.53 -4.18) rotate(90)"
        fill="#808083"
      />
      <rect
        x="210.28"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(429.86 -4.51) rotate(90)"
        fill="#808083"
      />
      <path
        d="M207.71,246.65a3.56,3.56,0,0,0,1.81-3.27h14.57c.09,1.48,0,2.72,1.06,3.27Z"
        fill="#838383"
      />
      <rect
        x="283.46"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(492.7 -83.05) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="275.63"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(519.6 -53.81) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="294.07 236.91 297.98 236.91 297.98 226.05 294.07 226.05 294.07 206.07 280.4 206.07 280.4 208.06 278.01 208.06 278.01 233.86 279.38 233.86 279.38 242.53 294.07 242.53 294.07 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M294.09,226.08s0-18,0-18h-8.15v-2h-5.5v2H278v25.73h1.41V237h18.65v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="275.05"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(505.99 -66.06) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="285.97"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(486.38 -94.47) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M294.12,227.68l0-21.86H280.45v2.08H278V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="277.96"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(477.94 -86.07) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="298.15"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(506.28 -93.88) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="283.09"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(502.71 -77.35) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="286.91"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(506.49 -81.14) rotate(90)"
        fill="#808083"
      />
      <rect
        x="286.58"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(506.17 -80.81) rotate(90)"
        fill="#808083"
      />
      <rect
        x="286.26"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(505.84 -80.49) rotate(90)"
        fill="#808083"
      />
      <rect
        x="285.93"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(505.52 -80.16) rotate(90)"
        fill="#808083"
      />
      <rect
        x="285.61"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(505.19 -79.84) rotate(90)"
        fill="#808083"
      />
      <rect
        x="285.28"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(504.86 -79.51) rotate(90)"
        fill="#808083"
      />
      <rect
        x="284.96"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(504.54 -79.19) rotate(90)"
        fill="#808083"
      />
      <rect
        x="284.63"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(504.21 -78.86) rotate(90)"
        fill="#808083"
      />
      <rect
        x="284.31"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(503.89 -78.53) rotate(90)"
        fill="#808083"
      />
      <rect
        x="283.98"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(503.56 -78.21) rotate(90)"
        fill="#808083"
      />
      <rect
        x="283.65"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(503.24 -77.88) rotate(90)"
        fill="#808083"
      />
      <rect
        x="283.33"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(502.91 -77.56) rotate(90)"
        fill="#808083"
      />
      <rect
        x="283"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(502.59 -77.23) rotate(90)"
        fill="#808083"
      />
      <rect
        x="282.68"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(502.26 -76.91) rotate(90)"
        fill="#808083"
      />
      <rect
        x="282.35"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(501.93 -76.58) rotate(90)"
        fill="#808083"
      />
      <rect
        x="282.03"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(501.61 -76.26) rotate(90)"
        fill="#808083"
      />
      <rect
        x="281.7"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(501.28 -75.93) rotate(90)"
        fill="#808083"
      />
      <rect
        x="281.38"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(500.96 -75.6) rotate(90)"
        fill="#808083"
      />
      <rect
        x="281.05"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(500.63 -75.28) rotate(90)"
        fill="#808083"
      />
      <rect
        x="280.72"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(500.31 -74.95) rotate(90)"
        fill="#808083"
      />
      <rect
        x="280.4"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(499.98 -74.63) rotate(90)"
        fill="#808083"
      />
      <rect
        x="280.07"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(499.66 -74.3) rotate(90)"
        fill="#808083"
      />
      <rect
        x="279.75"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(499.33 -73.98) rotate(90)"
        fill="#808083"
      />
      <rect
        x="279.42"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(499 -73.65) rotate(90)"
        fill="#808083"
      />
      <path
        d="M295.8,246.65a3.56,3.56,0,0,1-1.81-3.27H279.42c-.09,1.48,0,2.72-1.06,3.27Z"
        fill="#838383"
      />
      <rect
        x="262.93"
        y="194.95"
        width="8.83"
        height="19.74"
        transform="translate(472.17 -62.52) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="257.43"
        y="225.56"
        width="22.16"
        height="14.68"
        transform="translate(501.41 -35.62) rotate(90)"
        fill="#838383"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <polygon
        points="261.15 236.91 257.24 236.91 257.24 226.05 261.15 226.05 261.15 206.07 274.82 206.07 274.82 208.06 277.21 208.06 277.21 233.86 275.84 233.86 275.84 242.53 261.15 242.53 261.15 236.91"
        fill="#a6a7aa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M261.14,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H257.17v-10.9Z"
        fill="#c3c5c7"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="258.22"
        y="211.94"
        width="21.95"
        height="16.05"
        transform="translate(489.17 -49.23) rotate(90)"
        fill="#d1d3d4"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.02"
      />
      <rect
        x="260.34"
        y="188.64"
        width="8.91"
        height="14.63"
        transform="translate(460.75 -68.84) rotate(90)"
        fill="#aee2fa"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <path
        d="M274.77,227.68V227h2.46V207.9h-2.46v-2.08H261.14l0,21.86Zm-4-2.32h-8.95v-3.87h8.95Z"
        fill="#e5e6e6"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.01"
      />
      <rect
        x="269.17"
        y="194.37"
        width="8.1"
        height="3.14"
        transform="translate(469.15 -77.28) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.06"
      />
      <rect
        x="253.21"
        y="204.27"
        width="3.86"
        height="3.86"
        transform="translate(461.34 -48.94) rotate(90)"
        fill="#dfdfdd"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.08"
      />
      <rect
        x="258.25"
        y="208.59"
        width="13.88"
        height="8.18"
        transform="translate(477.87 -52.51) rotate(90)"
        fill="#6e7071"
        stroke="#808083"
        stroke-miterlimit="10"
        stroke-width="0.05"
      />
      <rect
        x="254.5"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(474.08 -48.73) rotate(90)"
        fill="#808083"
      />
      <rect
        x="254.83"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(474.41 -49.05) rotate(90)"
        fill="#808083"
      />
      <rect
        x="255.15"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(474.73 -49.38) rotate(90)"
        fill="#808083"
      />
      <rect
        x="255.48"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(475.06 -49.71) rotate(90)"
        fill="#808083"
      />
      <rect
        x="255.8"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(475.39 -50.03) rotate(90)"
        fill="#808083"
      />
      <rect
        x="256.13"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(475.71 -50.36) rotate(90)"
        fill="#808083"
      />
      <rect
        x="256.45"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(476.04 -50.68) rotate(90)"
        fill="#808083"
      />
      <rect
        x="256.78"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(476.36 -51.01) rotate(90)"
        fill="#808083"
      />
      <rect
        x="257.1"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(476.69 -51.33) rotate(90)"
        fill="#808083"
      />
      <rect
        x="257.43"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(477.01 -51.66) rotate(90)"
        fill="#808083"
      />
      <rect
        x="257.76"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(477.34 -51.98) rotate(90)"
        fill="#808083"
      />
      <rect
        x="258.08"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(477.66 -52.31) rotate(90)"
        fill="#808083"
      />
      <rect
        x="258.41"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(477.99 -52.64) rotate(90)"
        fill="#808083"
      />
      <rect
        x="258.73"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(478.32 -52.96) rotate(90)"
        fill="#808083"
      />
      <rect
        x="259.06"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(478.64 -53.29) rotate(90)"
        fill="#808083"
      />
      <rect
        x="259.38"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(478.97 -53.61) rotate(90)"
        fill="#808083"
      />
      <rect
        x="259.71"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(479.29 -53.94) rotate(90)"
        fill="#808083"
      />
      <rect
        x="260.03"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(479.62 -54.26) rotate(90)"
        fill="#808083"
      />
      <rect
        x="260.36"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(479.94 -54.59) rotate(90)"
        fill="#808083"
      />
      <rect
        x="260.69"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(480.27 -54.91) rotate(90)"
        fill="#808083"
      />
      <rect
        x="261.01"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(480.59 -55.24) rotate(90)"
        fill="#808083"
      />
      <rect
        x="261.34"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(480.92 -55.57) rotate(90)"
        fill="#808083"
      />
      <rect
        x="261.66"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(481.25 -55.89) rotate(90)"
        fill="#808083"
      />
      <rect
        x="261.99"
        y="212.6"
        width="13.81"
        height="0.15"
        transform="translate(481.57 -56.22) rotate(90)"
        fill="#808083"
      />
      <path
        d="M259.42,246.65a3.56,3.56,0,0,0,1.81-3.27H275.8c.09,1.48,0,2.72,1.07,3.27Z"
        fill="#838383"
      />
      <text
        transform="translate(104.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH1
        </tspan>
      </text>
      <text
        transform="translate(126.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH3
        </tspan>
      </text>
      <text
        transform="translate(156.38 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH5
        </tspan>
      </text>
      <text
        transform="translate(178.38 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH7
        </tspan>
      </text>
      <text
        transform="translate(207.63 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH9
        </tspan>
      </text>
      <text
        transform="translate(229.63 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.37" y="9.6">
          TH
        </tspan>
        <tspan x="8.29" y="9.6" letter-spacing="-0.07em">
          1
        </tspan>
        <tspan x="12.15" y="9.6">
          1
        </tspan>
      </text>
      <text
        transform="translate(259.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH13
        </tspan>
      </text>
      <text
        transform="translate(281.13 228.72)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH15
        </tspan>
      </text>
      <text
        transform="translate(78.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH2
        </tspan>
      </text>
      <text
        transform="translate(100.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH4
        </tspan>
      </text>
      <text
        transform="translate(131.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH6
        </tspan>
      </text>
      <text
        transform="translate(153.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-0.44" y="9.6">
          TH8
        </tspan>
      </text>
      <text
        transform="translate(182.63 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH10
        </tspan>
      </text>
      <text
        transform="translate(204.63 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH12
        </tspan>
      </text>
      <text
        transform="translate(234.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH14
        </tspan>
      </text>
      <text
        transform="translate(256.13 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH16
        </tspan>
      </text>
      <text
        transform="translate(285.88 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH17
        </tspan>
      </text>
      <text
        transform="translate(307.88 142.97)"
        font-size="8"
        fill="#231f20"
        font-family="Helvetica"
      >
        LP2
        <tspan x="-2.66" y="9.6">
          TH18
        </tspan>
      </text>
      <path
        d="M326,209.9v-9.19H309v25h17v-9.19h7.13V209.9Zm-5.5,13.15H310.25v-6.5H320.5Zm0-12.87H310.25v-6.5H320.5Z"
        fill="#939598"
      />
    </g>
    </g>
    <path
      id="flim_townhome"
      data-name="flim townhome"
      style={{ transform: "translateY(-26px)" }}
      className={`cls-76 ${
        selectedType === "townhome" || selectedType === "all"
          ? "flim-out"
          : "flim-in"
      }`}
      d="M76.22,153.79H595.1s18.42.8,31.53,13.91l73.69,61.16s24.32,43.69-40.27,43.69H102.58a12.87,12.87,0,0,1-9.12-6.22L68.1,217.46a24.51,24.51,0,0,1-1.71-9.82V164.33s.29-9.69,9.83-10.54"
    />
    <path
      id="flim_villa"
      data-name="flim villa"
      className={`cls-76 ${
        selectedType === "villa" || selectedType === "all"
          ? "flim-out"
          : "flim-in"
      }`}
      style={{ transform: "translateY(-26px)" }}
      d="M125.94,290.59H675s14.81.58,14,17.47l-35,105.07s-4.56,14.6-20.23,14.6H125.94s-10.26-2.29-11.11-12.6V302.05s1.42-9.74,11.11-11.46"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaPark2/sitePlan/svg/index.js